(function () {
  function r(e, n, t) {
    function o(i, f) {
      if (!n[i]) {
        if (!e[i]) {
          var c = 'function' == typeof require && require;
          if (!f && c) return c(i, !0);
          if (u) return u(i, !0);
          var a = new Error("Cannot find module '" + i + "'");
          throw ((a.code = 'MODULE_NOT_FOUND'), a);
        }
        var p = (n[i] = { exports: {} });
        e[i][0].call(
          p.exports,
          function (r) {
            var n = e[i][1][r];
            return o(n || r);
          },
          p,
          p.exports,
          r,
          e,
          n,
          t
        );
      }
      return n[i].exports;
    }
    for (var u = 'function' == typeof require && require, i = 0; i < t.length; i++) o(t[i]);
    return o;
  }
  return r;
})()(
  {
    1: [
      function (require, module, exports) {
        var HttpError = require('./httperror');
        var PropertyUtil = require('./util/property');
        var RetryUtil = require('./util/retry.util');

        /**
         * @author jwitz
         * @version 1.0.1
         *
         * Handles POSTing requests to event-bridge and handling successes and failures
         * to emit as events or callback completion functions
         *
         * @constructor
         * @param {string} channelUrl - the event-bridge channel to post to
         * @param {string} eventEmitter - the handler of events and completion callbacks
         * @param {int} maxRetries - Number of retries to invoke if an HTTP request fails.
         * @memberOf Twilio
         * @description Handles POSTing requests to event-bridge with JWTs<br>
         */
        function ApiRequester(channelUrl, eventEmitter, maxRetries) {
          Object.defineProperties(this, {
            channelUrl: {
              value: channelUrl,
            },
            eventEmitter: {
              value: eventEmitter,
            },
            maxRetries: {
              value: maxRetries ? maxRetries : 0,
            },
            retryUtil: {
              value: new RetryUtil(),
            },
          });
        }

        // private methods
        ApiRequester.prototype._handleHttpError = function _handleHttpError(code, message, completion) {
          if (completion) {
            var error = new HttpError(code, message);
            completion(error, null);
          }
        };

        ApiRequester.prototype._handleHttpSuccess = function _handleHttpSuccess(xhr, jsonParams, completion, entity) {
          var jsonResponse = JSON.parse(xhr.responseText);
          var type = jsonResponse.event_type;
          var payload = jsonResponse.payload;
          if (entity) {
            //update the entity with its latest properties from the update
            PropertyUtil.setProperties(entity, payload, entity.token, entity.apiRequester, entity.workspaceUrl);
          }
          if (type) {
            this.eventEmitter._emitMessage(type, payload);
          }
          if (completion) {
            this.eventEmitter._sendResponse(completion, payload);
          }
        };

        ApiRequester.prototype._handleHttpFailure = function _handleHttpFailure(
          xhr,
          jsonParams,
          completion,
          entity,
          retryCount
        ) {
          var status = xhr.status;
          var message = xhr.statusText;
          //  0 - time out on request -  retry up to 5 times; throw error to user
          // 400 - bad parsing of json - throw error to user
          // 401 - JWT expiration; send a message to generate a new one - throw error to user
          // 403 - JWT verification problem - invalid jwt or policy access issue - throw error to user
          // 404 - invalid endpoint - throw error to user
          // 500 - issues with account service or API; after retries, throw error to user
          // 504 - Gateway timedout
          // 503 - Service unavailable
          // 502 - Bad gateway server
          // 429 - Too many requests (rate limit exceeded)
          if ([0, 500, 502, 503, 504, 429].includes(status)) {
            if (status === 0) {
              console.log(new Date().toLocaleString() + '  ➤  Timeout on request, retrying');
            }

            // retry on timeouts & internal server error
            this._retry(xhr, jsonParams, completion, entity, retryCount);
          } else {
            // any other message should alert the user
            this._handleHttpError(status, message, completion);
          }
        };

        ApiRequester.prototype._retry = function _retry(xhr, jsonParams, completion, entity, retryCount) {
          var me = this;
          if (retryCount == this.maxRetries) {
            console.log(new Date().toLocaleString() + '  ➤  Retries exhausted after ' + retryCount + ' attempts');
            this._handleHttpError(xhr.status, xhr.statusText, completion);
            return;
          } else {
            if (retryCount < this.maxRetries) {
              me.retryUtil.whenReady(retryCount + 1).then(function (backoffTime) {
                console.log(
                  new Date().toLocaleString() + '  ➤  Retrying',
                  me.channelUrl,
                  'with backoff',
                  backoffTime + 'ms',
                  'for',
                  retryCount,
                  'retry'
                );
                me._postMessage(jsonParams, completion, entity, retryCount + 1);
              });
            }
          }
        };

        ApiRequester.prototype._handleHttpResponse = function _handleHttpResponse(
          xhr,
          completion,
          jsonParams,
          entity,
          retryCount
        ) {
          //only handle completes
          if (xhr.readyState == 4) {
            if (xhr.status == 200) {
              return this._handleHttpSuccess(xhr, jsonParams, completion, entity);
            } else {
              return this._handleHttpFailure(xhr, jsonParams, completion, entity, retryCount);
            }
          }
        };

        ApiRequester.prototype._postMessage = function _postMessage(jsonParams, completion, entity, retryCount) {
          retryCount = retryCount ? retryCount : 0;

          var xhr = new XMLHttpRequest();
          xhr.overrideMimeType('application/json');
          xhr.open('POST', this.channelUrl, true);
          var self = this;

          xhr.onreadystatechange = function () {
            self._handleHttpResponse(this, completion, jsonParams, entity, retryCount);
          };

          xhr.timeout = 5000;
          xhr.send(jsonParams);
        };

        ApiRequester.prototype._postMessageSync = function _postMessageSync(
          jsonParams,
          completion,
          entity,
          retryCount
        ) {
          retryCount = retryCount ? retryCount : 0;

          var xhr = new XMLHttpRequest();
          xhr.overrideMimeType('application/json');
          xhr.open('POST', this.channelUrl, false);
          var self = this;

          xhr.onreadystatechange = function () {
            self._handleHttpResponse(this, completion, jsonParams, entity, retryCount);
          };

          xhr.send(jsonParams);

          console.log(new Date().toLocaleString() + '  ➤  Sync XHR request issued');
        };

        ApiRequester.prototype._sendBeacon = function _sendBeacon(data) {
          navigator.sendBeacon(this.channelUrl, data);

          console.log(new Date().toLocaleString() + '  ➤  Beacon API request issued');
        };

        /**
         * Use Beacon if the API exists and the browser in use has good compatibility.
         * @returns {boolean} true if Beacon API should be used, false otherwise.
         * @private
         */
        ApiRequester.prototype._useBeacon = function _useBeacon() {
          var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

          return 'sendBeacon' in navigator && !isSafari;
        };

        module.exports = ApiRequester;
      },
      { './httperror': 8, './util/property': 35, './util/retry.util': 36 },
    ],
    2: [
      function (require, module, exports) {
        var EventEmitter = require('events').EventEmitter;
        var inherits = require('util').inherits;
        var JWTUtil = require('../util/jwt');
        var ApiRequester = require('../api.requester');
        var Heartbeat = require('./heartbeat').Heartbeat;

        /**
         * @author jwitz
         * @version 1.1.0
         *
         * Handles generic Event-Bridge handling of event-bridge requests, responses and events
         * Handles setting up of websockets
         * Handles token expiration
         *
         * @constructor
         * @param {string} token - The JWT access token
         * @param {string} channelUrl - the websocket channel url
         * @param {string} readyUrl - REST API url to issue a GET request to upon the websocket being opened
         * @param {string} debug - JS SDK will output events to console (defaults to true)
         * @param {int} maxRetries - Number of retries to invoke if an HTTP request fails.
         * @extends EventEmitter
         * @requires Atmosphere-Client
         * @requires ApiRequester
         * @requires JWTUtil
         * @memberOf Twilio
         */
        function EventBridgeClient(token, channelUrl, readyUrl, debug, maxRetries) {
          if (!token) {
            throw new Error('Token is required for TaskRouter JS SDK');
          }
          EventEmitter.call(this);

          this.token = token;
          if (debug === false || debug === 'false') {
            this.debug = false;
          } else {
            this.debug = true;
          }

          // API Requester uses XHR https requests
          var apiRequester = new ApiRequester(channelUrl, this, maxRetries);

          // Web Socket connects with wss request
          channelUrl = channelUrl.replace('https', 'wss');

          Object.defineProperties(this, {
            channelUrl: {
              value: channelUrl,
            },
            apiRequester: {
              value: apiRequester,
            },
            readyUrl: {
              value: readyUrl,
            },
          });

          var jwt = JWTUtil.objectize(token);
          var expired = jwt.exp;
          var now = Math.round(new Date().getTime() / 1000);
          var diff = expired - now - 5; //couple seconds buffer for token expired

          var self = this;
          this.tokenTimer = setTimeout(function () {
            self._emitTokenExpired();
          }, diff * 1000);

          //Check for minimum payload values
          //like account,channel,workspace_sid
          if (!jwt.account_sid || !jwt.channel || !jwt.workspace_sid) {
            throw new Error(
              'Missing minimum payload values. Check for existence of account_sid,channel or workspace_sid in the token'
            );
          }

          self._setupWebsocket();
        }
        inherits(EventBridgeClient, EventEmitter);

        /**
         * Update the JWT with a non-expired one
         * @param {string} token - new token
         */
        EventBridgeClient.prototype.updateToken = function updateToken(token) {
          this.token = token;
          clearTimeout(this.tokenTimer); // clear the previous timer for emitting token expiration event
          var jwt = JWTUtil.objectize(token);
          var expired = jwt.exp;
          var now = Math.round(new Date().getTime() / 1000);
          var diff = expired - now - 5; //couple seconds buffer for token expired
          var self = this;
          this.tokenTimer = setTimeout(function () {
            self._emitTokenExpired();
          }, diff * 1000);
        };

        // private methods
        /**
         * Emits a message to a client based on the event type and json payload
         * @param {string} type - event type
         * @param {string} payload - json payload
         * @private
         */
        EventBridgeClient.prototype._emitMessage = function _emitMessage(type, payload) {
          this.emit(type, payload);
        };

        /**
         * Sends a response from a REST API request to a completion function
         * @param {function} completion - async function to run upon completion
         * @param {json} payload - json payload
         * @private
         */
        EventBridgeClient.prototype._sendResponse = function _sendResponse(completion, payload) {
          completion(null, payload);
        };

        /**
         * Emits a token expired event
         * @private
         */
        EventBridgeClient.prototype._emitTokenExpired = function _emitTokenExpired() {
          this._emitMessage('token.expired');
        };

        /**
         * Logs a Message to the console and emits websocket error responses
         * @private
         */
        EventBridgeClient.prototype._log = function _log(message, errorResponse) {
          if (this.debug) {
            console.log(message);
          }
          if (errorResponse) {
            var error = {
              response: errorResponse,
              message: message,
            };
            this.emit('error', error);
          }
        };

        /**
         * Setup a websocket connection
         * @private
         */
        EventBridgeClient.prototype._setupWebsocket = function _setupWebsocket() {
          var queryParam = '';
          if (this.closeExistingSessions === true || this.closeExistingSessions === 'true') {
            queryParam += '&closeExistingSessions=true';
          } else {
            queryParam += '&closeExistingSessions=false';
          }
          if (typeof this.disconnectActivitySid !== 'undefined' && this.disconnectActivitySid !== null) {
            queryParam += '&disconnectActivitySid=' + this.disconnectActivitySid;
          }
          var self = this;
          var channelUrl = self.channelUrl;
          var attempts = 1;

          // cancel out any previous heartbeat
          if (this.heartbeat) {
            this.heartbeat.onsleep = function () {};
          }
          this.heartbeat = new Heartbeat({ interval: 60 });

          createWebSocket();

          // Create a websocket connection
          function createWebSocket() {
            var ws = new WebSocket(channelUrl + '?token=' + self.token + queryParam);
            ws.onopen = function () {
              // reset the tries back to 1 since we have a new connection opened.
              attempts = 1;

              self._log('Websocket opened: ' + ws.url);
              self._fetchResourceOnReady();
              self._emitMessage('connected');

              // setup heartbeat onsleep and beat it once to get timer started
              self.heartbeat.onsleep = function () {
                // treat it like the socket closed because when network drops onclose does not get called right away
                self._log('Heartbeat timed out. closing socket');
                ws.onclose();
              };
              self.heartbeat.beat();
            };
            ws.onmessage = function (response) {
              self.heartbeat.beat();

              // Receives a message
              if (response.data.trim().length === 0) {
                // heartbeat received
                return;
              }
              var json;
              try {
                json = JSON.parse(response.data);
              } catch (e) {
                self._log(e);
                self._log("This doesn't look like a valid JSON: " + response.data, response);
                return;
              }
              var type = json.event_type;
              var payload = json.payload;
              self._emitMessage(type, payload);
            };
            ws.onerror = function (response) {
              self._log('Websocket had an error', response);
            };
            ws.onclose = function (response) {
              self._log('Websocket closed');
              var payload = { message: 'Websocket disconnected due to lost connectivity' };
              self._emitMessage('disconnected', payload);
              var time = generateInterval(attempts);

              // clear the heartbeat onsleep callback
              self.heartbeat.onsleep = function () {};

              setTimeout(function () {
                // We've tried to reconnect so increment the attempts by 1
                attempts++;

                // Connection has closed so try to reconnect every 10 seconds.
                createWebSocket();
              }, time);
            };
          }

          // Generate a backoff interval to retry connecting
          function generateInterval(k) {
            return Math.min(30, Math.pow(2, k) - 1) * 1000;
          }
        };

        module.exports = EventBridgeClient;
      },
      { '../api.requester': 1, '../util/jwt': 34, './heartbeat': 3, events: 42, util: 61 },
    ],
    3: [
      function (require, module, exports) {
        /**
         * Heartbeat just wants you to call <code>beat()</code> every once in a while.
         *
         * <p>It initializes a countdown timer that expects a call to
         * <code>Hearbeat#beat</code> every n seconds. If <code>beat()</code> hasn't
         * been called for <code>#interval</code> seconds, it emits a
         * <code>onsleep</code> event and waits. The next call to <code>beat()</code>
         * emits <code>onwakeup</code> and initializes a new timer.</p>
         *
         * <p>For example:</p>
         *
         * @example
         *
         *     >>> hb = new Heartbeat({
         *     ...   interval: 10,
         *     ...   onsleep: function() { console.log(new Date().toLocaleString() + '  ➤  Gone to sleep...Zzz...'); },
         *     ...   onwakeup: function() { console.log(new Date().toLocaleString() + '  ➤  Awake already!'); },
         *     ... });
         *
         *     >>> hb.beat(); # then wait 10 seconds
         *     Gone to sleep...Zzz...
         *     >>> hb.beat();
         *     Awake already!
         *
         * @exports Heartbeat as Twilio.Heartbeat
         * @memberOf Twilio
         * @constructor
         * @param {object} opts Options for Heartbeat
         * @config {int} [interval=10] Seconds between each call to <code>beat</code>
         * @config {function} [onsleep] Callback for sleep events
         * @config {function} [onwakeup] Callback for wakeup events
         */
        function Heartbeat(opts) {
          if (!(this instanceof Heartbeat)) return new Heartbeat(opts);
          opts = opts || {};
          /** @ignore */
          var noop = function () {};
          var defaults = {
            interval: 10,
            now: function () {
              return new Date().getTime();
            },
            repeat: function (f, t) {
              return setInterval(f, t);
            },
            stop: function (f, t) {
              return clearInterval(f, t);
            },
            onsleep: noop,
            onwakeup: noop,
          };
          for (var prop in defaults) {
            if (prop in opts) continue;
            opts[prop] = defaults[prop];
          }
          /**
           * Number of seconds with no beat before sleeping.
           * @type number
           */
          this.interval = opts.interval;
          this.lastbeat = 0;
          this.pintvl = null;

          /**
           * Invoked when this object has not received a call to <code>#beat</code>
           * for an elapsed period of time greater than <code>#interval</code>
           * seconds.
           *
           * @event
           */
          this.onsleep = opts.onsleep;

          /**
           * Invoked when this object is sleeping and receives a call to
           * <code>#beat</code>.
           *
           * @event
           */
          this.onwakeup = opts.onwakeup;

          this.repeat = opts.repeat;
          this.stop = opts.stop;
          this.now = opts.now;
        }

        /**
         * @return {string}
         */
        Heartbeat.toString = function () {
          return '[Twilio.Heartbeat class]';
        };

        /**
         * @return {string}
         */
        Heartbeat.prototype.toString = function () {
          return '[Twilio.Heartbeat instance]';
        };
        /**
         * Keeps the instance awake (by resetting the count down); or if asleep,
         * wakes it up.
         */
        Heartbeat.prototype.beat = function () {
          this.lastbeat = this.now();
          if (this.sleeping()) {
            if (this.onwakeup) {
              this.onwakeup();
            }
            var self = this;
            this.pintvl = this.repeat.call(
              null,
              function () {
                self.check();
              },
              this.interval * 1000
            );
          }
        };
        /**
         * Goes into a sleep state if the time between now and the last heartbeat
         * is greater than or equal to the specified <code>interval</code>.
         */
        Heartbeat.prototype.check = function () {
          var timeidle = this.now() - this.lastbeat;
          if (!this.sleeping() && timeidle >= this.interval * 1000) {
            if (this.onsleep) {
              this.onsleep();
            }
            this.stop.call(null, this.pintvl);

            this.pintvl = null;
          }
        };
        /**
         * @return {boolean} True if sleeping
         */
        Heartbeat.prototype.sleeping = function () {
          return this.pintvl === null;
        };
        exports.Heartbeat = Heartbeat;
      },
      {},
    ],
    4: [
      function (require, module, exports) {
        var TaskRouterEventBridgeClient = require('./taskrouter-event-bridge-client');
        var JWTUtil = require('../util/jwt');
        var TaskQueue = require('../resources/instance/taskqueue');

        /**
         *
         * @version 1.1.0
         *
         * Handles TaskQueue related handling of event-bridge requests, responses and events
         *
         * @constructor
         * @param {string} token - The JWT access token for the workspace
         * @param {string} debug - JS SDK will output events to console (defaults to true)
         * @param {string} region - the ingress region for event-bridge connections
         * @param {int} maxRetries - Number of retries to invoke if an HTTP request fails.
         * @param {string} apiBaseUrl - base TaskRouter REST API endpoint
         * @param {string} eventBridgeBaseUrl - base Event-Bridge endpoint
         * @extends TaskRouterEventBridgeClient
         * @requires JWTUtil
         * @memberOf Twilio.TaskRouter
         * @description Registers a Twilio TaskRouter TaskQueue JS client
         */
        function TaskQueueClient(token, debug, region, maxRetries, apiBaseUrl, eventBridgeBaseUrl) {
          if (!token) {
            throw new Error('Token is required for TaskRouter JS SDK');
          }
          var jwt = JWTUtil.objectize(token);
          var taskqueueSid = jwt.taskqueue_sid;

          TaskRouterEventBridgeClient.call(
            this,
            token,
            apiBaseUrl,
            eventBridgeBaseUrl,
            region,
            taskqueueSid,
            '/TaskQueues/' + taskqueueSid,
            debug,
            maxRetries
          );

          var taskqueue = new TaskQueue(token, taskqueueSid, this.apiRequester, this.workspaceUrl);
          this._taskqueue = taskqueue;

          // expose all properties on a taskqueue on the taskqueue client
          // so they can be easily accessible to the developer
          for (var property in taskqueue) {
            if (!this.hasOwnProperty(property) && property !== 'updateToken') {
              var propertyValue = taskqueue[property];
              Object.defineProperty(this, property, {
                enumerable: true,
                value: propertyValue,
              });
            }
          }
        }
        TaskQueueClient.prototype = Object.create(TaskRouterEventBridgeClient.prototype);

        /**
         * Update the JWT with a non-expired one
         * @param {string} token - new token
         */
        TaskQueueClient.prototype.updateToken = function updateToken(token) {
          this._taskqueue.updateToken(token);
          TaskRouterEventBridgeClient.prototype.updateToken.call(this, token);
        };

        module.exports = TaskQueueClient;
      },
      { '../resources/instance/taskqueue': 14, '../util/jwt': 34, './taskrouter-event-bridge-client': 5 },
    ],
    5: [
      function (require, module, exports) {
        var inherits = require('util').inherits;
        var EventBridgeClient = require('./event-bridge-client');
        var JWTUtil = require('../util/jwt');
        var EntityUtil = require('../util/entity');
        var PropertyUtil = require('../util/property');

        /**
         * @author jwitz
         * @version 1.1.0
         *
         * Handles WDS Specific Event-Bridge handling of event-bridge requests, responses and events
         *
         * @constructor
         * @param {string} token - The JWT access token
         * @param {string} wdsBaseUrl - base WDS REST API endpoint
         * @param {string} eventBridgeBaseUrl - base Event-Bridge endpoint
         * @param {string} region - the ingress region for event-bridge connections
         * @param {string} channelId - the websocket channel
         * @param {string} readyPath - WDS REST API path relative to a WorkspaceSid
         * @param {string} debug - JS SDK will output events to console (defaults to true)
         * @param {int} maxRetries - Number of retries to invoke if an HTTP request fails.
         * @extends EventBridgeClient
         * @requires JWTUtil
         * @requires EntityUtil
         * @memberOf Twilio.TaskRouter
         */
        function TaskRouterEventBridgeClient(
          token,
          wdsBaseUrl,
          eventBridgeBaseUrl,
          region,
          channelId,
          readyPath,
          debug,
          maxRetries
        ) {
          if (!token) {
            throw new Error('Token is required for WDS client');
          }

          var jwt = JWTUtil.objectize(token);

          var accountSid = jwt.account_sid;
          var workspaceSid = jwt.workspace_sid;

          // wds location
          wdsBaseUrl = wdsBaseUrl ? wdsBaseUrl : 'https://taskrouter.twilio.com/v1';
          var workspaceUrl = wdsBaseUrl + '/Workspaces/' + workspaceSid;

          // GET path to fire off open connecting, tied to 'ready' event
          var readyUrl;
          if (readyPath) {
            readyUrl = workspaceUrl + readyPath;
          }

          // event-bridge location
          eventBridgeBaseUrl = eventBridgeBaseUrl ? eventBridgeBaseUrl : 'https://event-bridge.twilio.com';
          if (region) {
            eventBridgeBaseUrl = eventBridgeBaseUrl.split('twilio.com')[0] + region + '.us1.twilio.com';
          }
          var baseUrl = eventBridgeBaseUrl + '/v1/wschannels/' + accountSid + '/';
          var channelUrl = baseUrl + channelId;
          this.token = token;

          Object.defineProperties(this, {
            workspaceUrl: {
              value: workspaceUrl,
            },
            resourceUrl: {
              value: readyUrl,
            },
          });

          EventBridgeClient.call(this, token, channelUrl, readyUrl, debug, maxRetries);
        }
        TaskRouterEventBridgeClient.prototype = Object.create(EventBridgeClient.prototype);

        // private methods
        /**
         * Emits a message to a client based on the event type and json payload
         * @param {string} type - event type
         * @param {json} payload - json payload to either convert into an object or send raw to the client
         * @private
         */
        TaskRouterEventBridgeClient.prototype._emitMessage = function _emitMessage(type, payload) {
          var log = 'Received a message of type [' + type + ']';

          // emit based on object or
          // emit based on json payload
          if (type) {
            var entity = EntityUtil.createEntity(payload, this.token, this.apiRequester, this.workspaceUrl);
            if (entity) {
              log = log + ' with object ' + JSON.stringify(entity);
              this.emit(type, entity);
            } else {
              if (payload) {
                log = log + ' with json payload ' + JSON.stringify(payload);
              }
              this.emit(type, payload);
            }
          }
          this._log(log);
        };

        /**
         * Sends a response from a REST API request to a completion function
         * @param {function} completion - async function to run upon completion
         * @param {json} payload - json payload to either convert into an object or send raw to the client
         * @private
         */
        TaskRouterEventBridgeClient.prototype._sendResponse = function _sendResponse(completion, payload) {
          var entity = EntityUtil.createEntity(payload, this.token, this.apiRequester, this.workspaceUrl);
          if (entity) {
            var sid = entity.sid;
            if (sid && sid.substring(0, 2) === 'WR') {
              var promise = PropertyUtil.setTaskProperty(entity);
              promise.then(function (entity) {
                completion(null, entity);
              });
            } else {
              completion(null, entity);
            }
          } else {
            completion(null, payload);
          }
        };

        /**
         * Fetches a resource tied to the client upon ready
         * @private
         */
        TaskRouterEventBridgeClient.prototype._fetchResourceOnReady = function _fetchResourceOnReady() {
          var request = { url: this.resourceUrl, method: 'GET', event_type: 'ready', token: this.token };
          var jsonParams = JSON.stringify(request);
          this.apiRequester._postMessage(jsonParams);
        };

        module.exports = TaskRouterEventBridgeClient;
      },
      { '../util/entity': 33, '../util/jwt': 34, '../util/property': 35, './event-bridge-client': 2, util: 61 },
    ],
    6: [
      function (require, module, exports) {
        var TaskRouterEventBridgeClient = require('./taskrouter-event-bridge-client');
        var JWTUtil = require('../util/jwt');
        var EntityUtil = require('../util/entity');
        var PropertyUtil = require('../util/property');
        var Task = require('../resources/instance/task');
        var Reservation = require('../resources/instance/reservation');
        var Worker = require('../resources/instance/worker');
        var ActivityList = require('../resources/list/activities');

        /**
         * @author jwitz
         * @version 1.1.0
         *
         * Handles Worker related handling of event-bridge requests, responses and events
         *
         * @constructor
         * @param {string} token - The JWT access token for the worker
         * @param {string} debug - JS SDK will output events to console (defaults to true)
         * @param {string} connectActivitySid - ActivitySid to place the worker in upon connecting
         * @param {string} disconnectActivitySid - ActivitySid to place the worker in upon disconnecting
         * @param {boolean} closeExistingSessions - close existing connections for a given channel (defaults to false)
         * @param {string} region - the ingress region for event-bridge connections
         * @param {int} maxRetries - Number of retries to invoke if an HTTP request fails.
         * @param {string} apiBaseUrl - base TaskRouter REST API endpoint
         * @param {string} eventBridgeBaseUrl - base Event-Bridge endpoint
         * @extends TaskRouterEventBridgeClient
         * @requires JWTUtil
         * @requires EntityUtil
         * @memberOf Twilio.TaskRouter
         * @description Registers a Twilio TaskRouter Worker JS client
         */
        function WorkerClient(
          token,
          debug,
          connectActivitySid,
          disconnectActivitySid,
          closeExistingSessions,
          region,
          maxRetries,
          apiBaseUrl,
          eventBridgeBaseUrl
        ) {
          if (!token) {
            throw new Error('Token is required for TaskRouter JS SDK');
          }
          var jwt = JWTUtil.objectize(token);
          var workerSid = jwt.worker_sid;

          Object.defineProperties(this, {
            workerSid: {
              value: workerSid,
            },
            connectActivitySid: {
              value: connectActivitySid,
            },
            disconnectActivitySid: {
              value: disconnectActivitySid,
            },
            closeExistingSessions: {
              value: closeExistingSessions,
            },
          });

          var readyPath = '/Workers/' + workerSid;
          TaskRouterEventBridgeClient.call(
            this,
            token,
            apiBaseUrl,
            eventBridgeBaseUrl,
            region,
            workerSid,
            readyPath,
            debug,
            maxRetries
          );

          var worker = new Worker(token, workerSid, this.apiRequester, this.workspaceUrl);
          this._worker = worker;
          var activityList = new ActivityList(token, this.apiRequester, this.workspaceUrl);

          Object.defineProperties(this, {
            activities: {
              value: activityList,
            },
          });

          // expose all properties on a worker on the worker client
          // so they can be easily accessible to the developer
          for (var property in worker) {
            if (!this.hasOwnProperty(property) && property !== 'updateToken') {
              var propertyValue = worker[property];
              Object.defineProperty(this, property, {
                enumerable: true,
                value: propertyValue,
              });
            }
          }
        }

        WorkerClient.prototype = Object.create(TaskRouterEventBridgeClient.prototype);

        /**
         * Update the JWT with a non-expired one
         * @param {string} token - new token
         */
        WorkerClient.prototype.updateToken = function updateToken(token) {
          this._worker.updateToken(token);
          this.activities.updateToken(token);
          TaskRouterEventBridgeClient.prototype.updateToken.call(this, token);
        };

        /**
         * Set whether to fetch reservation details when emitting a
         * reservation event. Defaults to false.
         * @param {boolean} skip  - whether to fetch reservation details
         */
        WorkerClient.prototype.setSkipFetchReservation = function setSkipFetchReservation(skip) {
          Object.defineProperty(this, 'skipFetchReservation', {
            value: skip,
          });
        };

        /**
         * Fetch reservations for a worker
         * @param {function} completion - async function to run upon completion
         * @param {json} params - (optional) json formatted query parameters
         */
        WorkerClient.prototype.fetchReservations = function fetchReservations(completion, params) {
          var request = {
            url: this.workspaceUrl + '/Workers/' + this.workerSid + '/Reservations',
            method: 'GET',
            token: this.token,
          };
          if (params) {
            request.params = params;
          }
          var jsonParams = JSON.stringify(request);

          // create a wrapper function to set task objects on reservation
          var wrapperCompletionFunc = function (error, reservations) {
            if (error) {
              completion(error);
              return;
            }
            var data = reservations.data;
            var promises = [];

            // helper function
            var setTaskProperties = function (reservation) {
              var promise = PropertyUtil.setTaskProperty(reservation);
              promises.push(promise);
            };

            // loop through reservations and set task properties
            for (i = 0; i < data.length; i++) {
              setTaskProperties(data[i]);
            }

            // only return once all promises are satisfied and thus all data is populated
            Promise.all(promises).then(function (results) {
              // return using user function
              completion(null, reservations);
            });
          };
          this.apiRequester._postMessage(jsonParams, wrapperCompletionFunc);
        };

        /**
         * Fetch all channels for a worker
         * @param {function} completion - async function to call upon completion
         */
        WorkerClient.prototype.fetchChannels = function fetchChannels(completion) {
          var jsonParams = JSON.stringify({
            url: this.workspaceUrl + '/Workers/' + this.workerSid + '/Channels',
            method: 'GET',
            token: this.token,
          });
          this.apiRequester._postMessage(jsonParams, completion);
        };

        /**
         * Update a Task
         * @param {string} taskSid - the task to complete
         * @param {json} params - json formatted POST
         * @param {function} completion - async function to call upon completion
         */
        WorkerClient.prototype.updateTask = function updateTask(taskSid, params, completion) {
          var request = {
            url: this.workspaceUrl + '/Tasks/' + taskSid,
            method: 'POST',
            params: params,
            token: this.token,
          };
          var jsonParams = JSON.stringify(request);
          this.apiRequester._postMessage(jsonParams, completion);
        };

        /**
         * Complete a Task
         * @param {string} taskSid - the task to complete
         * @param {function} completion - async function to call upon completion
         * @param {string} reason - (optional)
         */
        WorkerClient.prototype.completeTask = function completeTask(taskSid, completion, reason) {
          var jsonParams = JSON.stringify({
            url: this.workspaceUrl + '/Tasks/' + taskSid,
            method: 'POST',
            params: { AssignmentStatus: 'completed', Reason: reason },
            token: this.token,
          });
          this.apiRequester._postMessage(jsonParams, completion);
        };

        /**
         * Fetch the list of activities in the workspace of the worker
         * @deprecated since version 1.1
         * @param {function} completion - async function to call upon completion
         */
        WorkerClient.prototype.fetchActivityList = function fetchActivityList(completion) {
          console.warn('Deprecated. Please utilize worker.activities.fetch(function() {}) instead.');
          var jsonParams = JSON.stringify({ url: this.workspaceUrl + '/Activities', method: 'GET', token: this.token });
          this.apiRequester._postMessage(jsonParams, completion);
        };

        /**
         * Update the worker's activity to the Activity provided
         * @deprecated since version 1.1
         * @param {string} activitySid - the activity to update the worker to
         * @param {function} completion - async function to call upon completion
         */
        WorkerClient.prototype.updateActivity = function updateActivity(activitySid, completion) {
          console.warn(
            'Deprecated. Please utilize worker.update({"ActivitySid":"' + activitySid + '"}, function() {}) instead.'
          );
          var jsonParams = JSON.stringify({
            url: this.workspaceUrl + '/Workers/' + this.workerSid,
            method: 'POST',
            params: { ActivitySid: activitySid },
            token: this.token,
          });
          this.apiRequester._postMessage(jsonParams, completion);
        };

        // private methods
        /**
         * Emits a message to a client based on the event type and json payload.
         * @param {string} type - event type
         * @param {json} payload - json payload to either convert into an object or send raw to the client
         * @private
         */
        WorkerClient.prototype._emitMessage = function _emitMessage(type, payload) {
          // since we're in the context of a worker,
          // take off worker. from event types
          if (type && type.indexOf('worker') === 0) {
            type = type.replace('worker.', '');
          }
          var self = this;

          // emit based on object or
          // emit based on json payload
          if (type) {
            var entity;
            //reservation.created, reservation.accepted, reservation.rejected, reservation.timeout, reservation.rescinded
            //reservation.canceled will happen in the case of task.canceled or task.deleted
            if (type.indexOf('reservation') === 0) {
              //have to do this because of our mashup of task+reservation_sid in the event broadcast
              var taskSid = payload.sid;
              var sid = payload.reservation_sid;
              if (type.indexOf('reservation.pending') === 0) {
                // flip these for onload event due to mashup of task+reservation_sid in event broadcast
                taskSid = payload.taskSid;
                sid = payload.sid;
                type = 'reservation.created';
              }
              entity = new Reservation(this.token, sid, taskSid, this.apiRequester, this.workspaceUrl);

              // fetch a task/reservation async and then upon return emit the message
              if (this.skipFetchReservation) {
                self._emitReservationWithoutProperties(entity, taskSid, payload, type);
              } else {
                var promise = PropertyUtil.setReservationProperties(entity);
                promise.then(
                  function (reservation) {
                    self.emit(type, reservation);
                  },
                  function (err) {
                    self._emitReservationWithoutProperties(entity, taskSid, payload, type);
                  }
                );
              }
            } else {
              entity = EntityUtil.createEntity(payload, this.token, this.apiRequester, this.workspaceUrl);
              if (entity) {
                log = log + ' with object ' + JSON.stringify(entity);
                this.emit(type, entity);
              } else {
                if (payload) {
                  log = log + ' with json payload ' + JSON.stringify(payload);
                }
                this.emit(type, payload);
              }
              if (type.indexOf('ready') === 0) {
                this._emitPendingReservations();
                if (this.disconnectActivitySid) {
                  window.addEventListener('unload', function () {
                    self._updateWorkerToDisconnectActivity();
                  });
                }
              }
            }
          }
          var log = 'Received a message of type [' + type + ']';
          this._log(log);
        };

        /**
         * In the absence of fetching full Reservation and Task details, emit
         * a Reservation instance with the properties contained within the event
         * payload.
         * @param {reservation} reservation - new Reservation instance
         * @param {string} taskSid - taskSid associated with reservation
         * @param {json} payload - json payload to set as properties on the reservation
         * @param {string} eventType - event type
         * @private
         */
        WorkerClient.prototype._emitReservationWithoutProperties = function _emitReservationWithoutProperties(
          reservation,
          taskSid,
          payload,
          eventType
        ) {
          var task = new Task(this.token, taskSid, this.apiRequester, this.workspaceUrl);
          PropertyUtil.setProperties(task, payload, this.token, this.apiRequester, this.workspaceUrl);

          // set a task property on the reservation
          Object.defineProperties(reservation, {
            task: {
              value: task,
              enumerable: true,
            },
          });

          this.emit(eventType, reservation);
        };

        /**
         * Emits all pending reservations to the client
         * @private
         */
        WorkerClient.prototype._emitPendingReservations = function _emitPendingReservations() {
          var self = this;
          this._fetchPendingReservations().then(
            function (reservations) {
              // update the worker to the given activity if they don't have any pending reservations
              if (reservations.length === 0 && self.connectActivitySid) {
                self.update('ActivitySid', self.connectActivitySid);
              }
              for (i = 0; i < reservations.length; i++) {
                self._emitMessage('reservation.pending', reservations[i]);
              }
            },
            function (error) {
              self._log(error.code + ' with ' + error.message);
            }
          );
        };

        /**
         * Fetches all pending resrvations
         * @private
         */
        WorkerClient.prototype._fetchPendingReservations = function _fetchPendingReservations() {
          var queryParams = { ReservationStatus: 'pending' };
          var self = this;
          return new Promise(function (resolve, reject) {
            self.fetchReservations(function (error, reservations) {
              if (error) {
                reject(error);
                return;
              }
              var data = reservations.data;
              resolve(data);
            }, queryParams);
          });
        };

        /**
         * Sends a Worker to their disconnected activity upon a window closing
         * @private
         */
        WorkerClient.prototype._updateWorkerToDisconnectActivity = function _updateWorkerToDisconnectActivity() {
          var params = { ActivitySid: this.disconnectActivitySid };
          var request = JSON.stringify({ url: this.resourceUrl, method: 'POST', params: params, token: this.token });

          if (this.apiRequester._useBeacon()) {
            this.apiRequester._sendBeacon(request);
          } else {
            this.apiRequester._postMessageSync(request);
          }
        };

        module.exports = WorkerClient;
      },
      {
        '../resources/instance/reservation': 11,
        '../resources/instance/task': 13,
        '../resources/instance/worker': 16,
        '../resources/list/activities': 20,
        '../util/entity': 33,
        '../util/jwt': 34,
        '../util/property': 35,
        './taskrouter-event-bridge-client': 5,
      },
    ],
    7: [
      function (require, module, exports) {
        var TaskRouterEventBridgeClient = require('./taskrouter-event-bridge-client');
        var JWTUtil = require('../util/jwt');
        var Workspace = require('../resources/instance/workspace');

        /**
         * @author jwitz
         * @version 1.1.0
         *
         * Handles Worker related handling of event-bridge requests, responses and events
         *
         * @constructor
         * @param {string} token - The JWT access token for the workspace
         * @param {string} debug - JS SDK will output events to console (defaults to true)
         * @param {string} region - the ingress region for event-bridge connections
         * @param {int} maxRetries - Number of retries to invoke if an HTTP request fails.
         * @param {string} apiBaseUrl - base TaskRouter REST API endpoint
         * @param {string} eventBridgeBaseUrl - base Event-Bridge endpoint
         * @extends TaskRouterEventBridgeClient
         * @requires JWTUtil
         * @memberOf Twilio.TaskRouter
         * @description Registers a Twilio TaskRouter Workspace JS client
         */
        function WorkspaceClient(token, debug, region, maxRetries, apiBaseUrl, eventBridgeBaseUrl) {
          if (!token) {
            throw new Error('Token is required for TaskRouter JS SDK');
          }
          var jwt = JWTUtil.objectize(token);
          var workspaceSid = jwt.workspace_sid;

          TaskRouterEventBridgeClient.call(
            this,
            token,
            apiBaseUrl,
            eventBridgeBaseUrl,
            region,
            workspaceSid,
            '/',
            debug,
            maxRetries
          );

          var workspace = new Workspace(token, this.apiRequester, this.workspaceUrl);
          this._workspace = workspace;

          // expose all properties on a workspace on the workspace client
          // so they can be easily accessible to the developer
          for (var property in workspace) {
            if (!this.hasOwnProperty(property) && property !== 'updateToken') {
              var propertyValue = workspace[property];
              Object.defineProperty(this, property, {
                enumerable: true,
                value: propertyValue,
              });
            }
          }
        }
        WorkspaceClient.prototype = Object.create(TaskRouterEventBridgeClient.prototype);

        /**
         * Update the JWT with a non-expired one
         * @param {string} token - new token
         */
        WorkspaceClient.prototype.updateToken = function updateToken(token) {
          this._workspace.updateToken(token);
          TaskRouterEventBridgeClient.prototype.updateToken.call(this, token);
        };

        module.exports = WorkspaceClient;
      },
      { '../resources/instance/workspace': 19, '../util/jwt': 34, './taskrouter-event-bridge-client': 5 },
    ],
    8: [
      function (require, module, exports) {
        function HttpError(code, message) {
          Object.defineProperties(this, {
            code: {
              value: code,
            },
            message: {
              value: message,
            },
          });
        }

        module.exports = HttpError;
      },
      {},
    ],
    9: [
      function (require, module, exports) {
        function TaskRouter() {}

        Object.defineProperties(TaskRouter, {
          TaskQueue: {
            enumerable: true,
            value: require('./clients/taskqueue-client'),
          },
          Worker: {
            enumerable: true,
            value: require('./clients/worker-client'),
          },
          Workspace: {
            enumerable: true,
            value: require('./clients/workspace-client'),
          },
        });

        module.exports = TaskRouter;
      },
      { './clients/taskqueue-client': 4, './clients/worker-client': 6, './clients/workspace-client': 7 },
    ],
    10: [
      function (require, module, exports) {
        var TaskRouterResource = require('./taskrouter-resource');
        /**
         * @author jwitz
         * @version 1.1.0
         *
         * @constructor
         * @param {string} token - The JWT access token
         * @param {string} sid - the sid of the activity
         * @param {string} apiRequester - issues the api request
         * @param {string} workspaceUrl - REST API workspace url
         * @memberOf Twilio.TaskRouter
         * @description Creates a Twilio TaskRouter Activity which can fetch its attributes
         */
        function Activity(token, sid, apiRequester, workspaceUrl) {
          var resourceUrl = workspaceUrl + '/Activities/' + sid;
          TaskRouterResource.call(this, token, resourceUrl, apiRequester, workspaceUrl);
        }
        Activity.prototype = Object.create(TaskRouterResource.prototype);

        module.exports = Activity;
      },
      { './taskrouter-resource': 15 },
    ],
    11: [
      function (require, module, exports) {
        var TaskRouterResource = require('./taskrouter-resource');
        var Task = require('./task');

        /**
         * @author jwitz
         * @version 1.1.0
         *
         * @constructor
         * @param {string} token - The JWT access token
         * @param {string} sid - reservation sid
         * @param {string} taskSid - task sid
         * @param {string} apiRequester - issues the api request
         * @param {string} workspaceUrl - REST API workspace url
         * @memberOf Twilio.TaskRouter
         * @description Creates a Twilio TaskRouter Reservation which can:<br>
         * - Accept a Reservation<br>
         * - Reject a Reservation<br>
         * - Dequeue a Call & Accept a Reservation<br>
         * - Dial & Accept a Reservation<br>
         */
        function Reservation(token, sid, taskSid, apiRequester, workspaceUrl) {
          var task = new Task(token, taskSid, apiRequester, workspaceUrl);
          var resourceUrl = workspaceUrl + '/Tasks/' + taskSid + '/Reservations/' + sid;
          this.task = task;
          this.sid = sid;

          TaskRouterResource.call(this, token, resourceUrl, apiRequester, workspaceUrl);
        }
        Reservation.prototype = Object.create(TaskRouterResource.prototype);

        /**
         * Accept the reservation
         * @param {function} completion - (optional) function to call upon the completion of task acceptance
         */
        Object.defineProperty(Reservation.prototype, 'accept', {
          value: function (completion) {
            var jsonParams = JSON.stringify({
              url: this.resourceUrl,
              method: 'POST',
              token: this.token,
              params: {
                ReservationStatus: 'accepted',
              },
            });
            this.apiRequester._postMessage(jsonParams, completion);
          },
          enumerable: false,
        });

        /**
         * Reject the reservation
         * @param {string} activitySid - (optional) The activitySid to update the worker to after rejecting the task
         * @param {function} completion - (optional) function to call upon the completion of the rejection of task
         */
        Object.defineProperty(Reservation.prototype, 'reject', {
          value: function (activitySid, completion) {
            var jsonParams = JSON.stringify({
              url: this.resourceUrl,
              method: 'POST',
              token: this.token,
              params: {
                ReservationStatus: 'rejected',
                WorkerActivitySid: activitySid,
              },
            });
            this.apiRequester._postMessage(jsonParams, completion);
          },
          enumerable: false,
        });

        /**
         * Dequeue the reservation
         * @param {string} dequeueFrom - (required) The caller id for the call to the worker
         * @param {string} dequeuePostWorkActivitySid - (optional) The activitySid to update the worker to after dequeue
         * @param {string} dequeueRecord - (optional) Determines if we should record both legs of the call
         * @param {string} dequeueTimeout - (optional) The number of seconds Twilio should allow ringing to occur
         * @param {string} dequeueStatusCallbackUrl - (optional) A URL that Twilio will send asynchronous webhook requests to on completed call even
         * @param {string} dequeueStatusCallbackEvents (optional) which dequeue status callbacks you can receive
         * @param {string} dequeueTo - (optional) The contact information to dequeue the call to the worker
         * @param {function} completion - (optional) function to call upon the completion of the dequeue
         */
        Object.defineProperty(Reservation.prototype, 'dequeue', {
          value: function (
            dequeueFrom,
            dequeuePostWorkActivitySid,
            dequeueRecord,
            dequeueTimeout,
            dequeueStatusCallbackUrl,
            dequeueStatusCallbackEvents,
            dequeueTo,
            completion
          ) {
            var jsonParams = JSON.stringify({
              url: this.resourceUrl,
              method: 'POST',
              token: this.token,
              params: {
                Instruction: 'dequeue',
                DequeuePostWorkActivitySid: dequeuePostWorkActivitySid,
                DequeueFrom: dequeueFrom,
                DequeueRecord: dequeueRecord,
                DequeueTimeout: dequeueTimeout,
                DequeueStatusCallbackUrl: dequeueStatusCallbackUrl,
                DequeueStatusCallbackEvent: dequeueStatusCallbackEvents,
                DequeueTo: dequeueTo,
              },
            });
            this.apiRequester._postMessage(jsonParams, completion);
          },
          enumerable: false,
        });

        /**
         * Dial the reservation
         * @param {string} callFrom - (required) The caller id for the call to the worker
         * @param {string} callUrl - (required) A valid TwiML URI that is executed on the answering Worker's leg
         * @param {string} callStatusCallbackUrl - (optional) A valid status callback url
         * @param {string} callAccept - (optional) true or false, accept the task before initiating call. Defaults to false
         * @param {string} callRecord - (optional) record-from-answer or none. Record the call. Defaults to none.
         * @param {string} callTo - (optional) Whom to call. If not provided, will utilize worker's "contact_uri" attribute
         * @param {function} completion - (optional) function to call upon the completion of the dial
         */
        Object.defineProperty(Reservation.prototype, 'call', {
          value: function (callFrom, callUrl, callStatusCallbackUrl, callAccept, callRecord, callTo, completion) {
            var jsonParams = JSON.stringify({
              url: this.resourceUrl,
              method: 'POST',
              token: this.token,
              params: {
                Instruction: 'call',
                CallFrom: callFrom,
                CallUrl: callUrl,
                CallStatusCallbackUrl: callStatusCallbackUrl,
                CallAccept: callAccept,
                CallRecord: callRecord,
                CallTo: callTo,
              },
            });
            this.apiRequester._postMessage(jsonParams, completion);
          },
          enumerable: false,
        });

        /**
         * Redirect the reservation's call
         * @param {string} redirectCallSid - (required) The Call to Redirect
         * @param {string} redirectCallUrl - (required) The TwiML URL to Redirect the Call to
         * @param {string} redirectAccept - (optional) true or false, accept the task before redirecting call. Defaults to false
         * @param {function} completion - (optional) function to call upon the completion of the redirect
         */
        Object.defineProperty(Reservation.prototype, 'redirect', {
          value: function (redirectCallSid, redirectCallUrl, redirectAccept, completion) {
            var jsonParams = JSON.stringify({
              url: this.resourceUrl,
              method: 'POST',
              token: this.token,
              params: {
                Instruction: 'redirect',
                RedirectCallSid: redirectCallSid,
                RedirectUrl: redirectCallUrl,
                RedirectAccept: redirectAccept,
              },
            });
            this.apiRequester._postMessage(jsonParams, completion);
          },
          enumerable: false,
        });

        /**
         * Conference the reservation
         * @param {string} from - (optional) The caller id for the call to the worker
         * @param {string} postWorkActivitySid - (optional) The activitySid to update the worker to after dequeue
         * @param {string} timeout - (optional) The number of seconds Twilio should allow ringing to occur
         * @param {string} to - (optional) The contact information to dequeue the call to the worker
         * @param {string} options - (optional) any additional participant api parameters
         * @param {function} completion - (optional) function to call upon the completion of the dequeue
         */
        Object.defineProperty(Reservation.prototype, 'conference', {
          value: function (from, postWorkActivitySid, timeout, to, completion, options) {
            var params = { Instruction: 'conference' };

            // check options
            params = Object.assign(
              params,
              {
                From: from,
                PostWorkActivitySid: postWorkActivitySid,
                Timeout: timeout,
                To: to,
              },
              options
            );

            var json = {
              url: this.resourceUrl,
              method: 'POST',
              token: this.token,
              params: params,
            };
            var jsonParams = JSON.stringify(json);
            this.apiRequester._postMessage(jsonParams, completion);
          },
          enumerable: false,
        });

        module.exports = Reservation;
      },
      { './task': 13, './taskrouter-resource': 15 },
    ],
    12: [
      function (require, module, exports) {
        /**
         * @author jwitz
         * @version 1.1.0
         *
         * @constructor
         * @param {string} token - The JWT access token
         * @param {string} resourceUrl - REST API resource url
         * @param {string} apiRequester - issues the api request
         * @memberOf Twilio
         * @description Creates a Twilio Resource which can fetch or update its attributes
         */
        function Resource(token, resourceUrl, apiRequester) {
          Object.defineProperties(this, {
            token: {
              value: token,
              writable: true,
            },
            resourceUrl: {
              value: resourceUrl,
            },
            apiRequester: {
              value: apiRequester,
            },
          });
        }

        /**
         * Get a resource's information
         * @param {function} completion - async function to run upon completion of the query
         */
        Resource.prototype.fetch = function fetch(completion) {
          var jsonParams = JSON.stringify({ url: this.resourceUrl, method: 'GET', token: this.token });
          this.apiRequester._postMessage(jsonParams, completion);
        };

        /**
         * Update a resource
         * @param {json} params - json formatted POST parameters or a single attribute and value
         * @param {function} completion - async function to run upon completion of the post
         */
        Resource.prototype.update = function update() {
          // handle optional single parameters argument
          var arg0 = arguments[0];
          var arg1 = arguments[1];
          var arg2 = arguments[2];

          var params = {};
          var completion;
          if (typeof arg0 === 'string') {
            // we're handling a single attribute update
            if (typeof arg1 === 'string') {
              params[arg0] = arg1;
              completion = arg2;
            } else {
              throw Error('2nd argument needs to be a string value');
            }
          } else if (arg0 instanceof Object) {
            params = arg0;
            for (var key in params) {
              var value = params[key];
              if (value instanceof Object) {
                params[key] = JSON.stringify(value);
              }
            }
            if (typeof arg1 === 'undefined' || arg1 instanceof Function) {
              completion = arg1;
            } else {
              throw Error('2nd argument needs to be a function');
            }
          } else {
            throw Error('1st argument needs to either be a string or a JSON object');
          }

          var request = JSON.stringify({ url: this.resourceUrl, method: 'POST', params: params, token: this.token });
          this.apiRequester._postMessage(request, completion, this);
        };

        /**
         * Delete a resource
         * @param {function} completion - async function to run upon completion of the deletion
         */
        Resource.prototype.delete = function deleteR(completion) {
          var request = JSON.stringify({ url: this.resourceUrl, method: 'DELETE', token: this.token });
          this.apiRequester._postMessage(request, completion);
        };

        /**
         * Update the JWT with a non-expired one
         * @param {string} token - new token
         */
        Resource.prototype.updateToken = function updateToken(token) {
          this.token = token;
        };

        module.exports = Resource;
      },
      {},
    ],
    13: [
      function (require, module, exports) {
        var TaskRouterResource = require('./taskrouter-resource');
        /**
         * @author jwitz
         * @version 1.1.0
         *
         * @constructor
         * @param {string} token - The JWT access token
         * @param {string} sid - the sid of the task
         * @param {string} apiRequester - issues the api request
         * @param {string} workspaceUrl - REST API workspace url
         * @memberOf Twilio.TaskRouter
         * @description Creates a Twilio TaskRouter Task which can fetch its attributes
         */
        function Task(token, sid, apiRequester, workspaceUrl) {
          var resourceUrl = workspaceUrl + '/Tasks/' + sid;
          TaskRouterResource.call(this, token, resourceUrl, apiRequester, workspaceUrl);
        }
        Task.prototype = Object.create(TaskRouterResource.prototype);

        /**
         * Complete the Task
         * @param {function} completion - (optional) function to call upon the completion of task acceptance
         * @param {string} reason - (optional) reason for completion
         */
        Object.defineProperty(Task.prototype, 'complete', {
          value: function (completion, reason) {
            var jsonParams = JSON.stringify({
              url: this.resourceUrl,
              method: 'POST',
              token: this.token,
              params: {
                AssignmentStatus: 'completed',
                Reason: reason,
              },
            });
            this.apiRequester._postMessage(jsonParams, completion);
          },
          enumerable: false,
        });

        module.exports = Task;
      },
      { './taskrouter-resource': 15 },
    ],
    14: [
      function (require, module, exports) {
        var TaskRouterResource = require('./taskrouter-resource');
        var Statistics = require('../list/statistics');
        var RealTimeStatistics = require('../list/realtime-statistics');
        var CumulativeStatistics = require('../list/cumulative-statistics');

        /**
         * @author jwitz
         * @version 1.1.0
         *
         * @constructor
         * @param {string} token - The JWT access token
         * @param {string} sid - the sid of the task queue
         * @param {string} apiRequester - issues the api request
         * @param {string} workspaceUrl - REST API workspace url
         * @memberOf Twilio.TaskRouter
         * @description Creates a Twilio TaskRouter TaskQueue which can fetch its attributes
         */
        function TaskQueue(token, sid, apiRequester, workspaceUrl) {
          var resourceUrl = workspaceUrl + '/TaskQueues/' + sid;

          var statistics = new Statistics(token, resourceUrl, apiRequester, workspaceUrl);
          var realtimeStats = new RealTimeStatistics(token, resourceUrl, apiRequester, workspaceUrl);
          var cumulativeStats = new CumulativeStatistics(token, resourceUrl, apiRequester, workspaceUrl);

          Object.defineProperties(this, {
            statistics: {
              value: statistics,
              enumerable: true,
            },
            realtimeStats: {
              value: realtimeStats,
              enumerable: true,
            },
            cumulativeStats: {
              value: cumulativeStats,
              enumerable: true,
            },
          });

          TaskRouterResource.call(this, token, resourceUrl, apiRequester, workspaceUrl);
        }
        TaskQueue.prototype = Object.create(TaskRouterResource.prototype);

        /**
         * Update the JWT with a non-expired one
         * @param {string} token - new token
         */
        TaskQueue.prototype.updateToken = function updateToken(token) {
          this.token = token;
          this.statistics.updateToken(token);
        };

        module.exports = TaskQueue;
      },
      {
        '../list/cumulative-statistics': 21,
        '../list/realtime-statistics': 23,
        '../list/statistics': 25,
        './taskrouter-resource': 15,
      },
    ],
    15: [
      function (require, module, exports) {
        var Resource = require('./resource');
        /**
         * @author jwitz
         * @version 1.1.0
         *
         * @constructor
         * @param {string} token - The JWT access token
         * @param {string} resourceUrl - REST API resource url
         * @param {string} apiRequester - issues the api request
         * @param {string} workspaceUrl - REST API workspace url
         * @memberOf Twilio.TaskRouter
         * @description Creates a Twilio TaskRouter Resource which can fetch or update its attributes
         */
        function TaskRouterResource(token, resourceUrl, apiRequester, workspaceUrl) {
          Object.defineProperties(this, {
            workspaceUrl: {
              value: workspaceUrl,
            },
          });
          Resource.call(this, token, resourceUrl, apiRequester);
        }
        TaskRouterResource.prototype = Object.create(Resource.prototype);

        module.exports = TaskRouterResource;
      },
      { './resource': 12 },
    ],
    16: [
      function (require, module, exports) {
        var TaskRouterResource = require('./taskrouter-resource');
        var Statistics = require('../list/statistics');
        /**
         * @author jwitz
         * @version 1.1.0
         *
         * @constructor
         * @param {string} token - The JWT access token
         * @param {string} sid - the sid of the worker
         * @param {string} apiRequester - issues the api request
         * @param {string} workspaceUrl - REST API workspace url
         * @memberOf Twilio.TaskRouter
         * @description Creates a Twilio TaskRouter Worker which can fetch its attributes
         */
        function Worker(token, sid, apiRequester, workspaceUrl) {
          var resourceUrl = workspaceUrl + '/Workers/' + sid;

          var statistics = new Statistics(token, resourceUrl, apiRequester, workspaceUrl);
          Object.defineProperties(this, {
            statistics: {
              value: statistics,
              enumerable: true,
            },
          });

          TaskRouterResource.call(this, token, resourceUrl, apiRequester, workspaceUrl);
        }
        Worker.prototype = Object.create(TaskRouterResource.prototype);

        /**
         * Update the JWT with a non-expired one
         * @param {string} token - new token
         */
        Worker.prototype.updateToken = function updateToken(token) {
          this.token = token;
          this.statistics.updateToken(token);
        };

        module.exports = Worker;
      },
      { '../list/statistics': 25, './taskrouter-resource': 15 },
    ],
    17: [
      function (require, module, exports) {
        var TaskRouterResource = require('./taskrouter-resource');
        /**
         * @author gramanathaiah
         * @version 1.6.0
         *
         * @constructor
         * @param {string} token - The JWT access token
         * @param {string} workerSid - the sid of the worker
         * @param {string} channelSid - the sid of the worker channel
         * @param {string} apiRequester - issues the api request
         * @param {string} workspaceUrl - REST API workspace url
         * @memberOf Twilio.TaskRouter
         * @description Creates a Twilio TaskRouter WorkerChannel which can fetch its attributes
         */
        function WorkerChannel(token, workerSid, channelSid, apiRequester, workspaceUrl) {
          var resourceUrl = workspaceUrl + '/Workers/' + workerSid + '/Channels/' + channelSid;
          TaskRouterResource.call(this, token, resourceUrl, apiRequester, workspaceUrl);
        }
        WorkerChannel.prototype = Object.create(TaskRouterResource.prototype);

        module.exports = WorkerChannel;
      },
      { './taskrouter-resource': 15 },
    ],
    18: [
      function (require, module, exports) {
        var TaskRouterResource = require('./taskrouter-resource');
        var Statistics = require('../list/statistics');
        var RealTimeStatistics = require('../list/realtime-statistics');
        var CumulativeStatistics = require('../list/cumulative-statistics');
        /**
         * @author jwitz
         * @version 1.1.0
         *
         * @constructor
         * @param {string} token - The JWT access token
         * @param {string} sid - the sid of the workflow
         * @param {string} apiRequester - issues the api request
         * @param {string} workspaceUrl - REST API workspace url
         * @memberOf Twilio.TaskRouter
         * @description Creates a Twilio TaskRouter Workflow which can fetch its attributes
         */
        function Workflow(token, sid, apiRequester, workspaceUrl) {
          var resourceUrl = workspaceUrl + '/Workflows/' + sid;

          var statistics = new Statistics(token, resourceUrl, apiRequester, workspaceUrl);
          var realtimeStats = new RealTimeStatistics(token, resourceUrl, apiRequester, workspaceUrl);
          var cumulativeStats = new CumulativeStatistics(token, resourceUrl, apiRequester, workspaceUrl);

          Object.defineProperties(this, {
            statistics: {
              value: statistics,
              enumerable: true,
            },
            realtimeStats: {
              value: realtimeStats,
              enumerable: true,
            },
            cumulativeStats: {
              value: cumulativeStats,
              enumerable: true,
            },
          });

          TaskRouterResource.call(this, token, resourceUrl, apiRequester, workspaceUrl);
        }
        Workflow.prototype = Object.create(TaskRouterResource.prototype);

        /**
         * Update the JWT with a non-expired one
         * @param {string} token - new token
         */
        Workflow.prototype.updateToken = function updateToken(token) {
          this.token = token;
          this.statistics.updateToken(token);
        };

        module.exports = Workflow;
      },
      {
        '../list/cumulative-statistics': 21,
        '../list/realtime-statistics': 23,
        '../list/statistics': 25,
        './taskrouter-resource': 15,
      },
    ],
    19: [
      function (require, module, exports) {
        var TaskRouterResource = require('./taskrouter-resource');
        var ActivityList = require('../list/activities');
        var WorkflowList = require('../list/workflows');
        var WorkerList = require('../list/workers');
        var TaskQueueList = require('../list/taskqueues');
        var TaskList = require('../list/tasks');
        var Statistics = require('../list/statistics');
        var RealTimeStatistics = require('../list/realtime-statistics');
        var CumulativeStatistics = require('../list/cumulative-statistics');
        /**
         * @author jwitz
         * @version 1.1.0
         *
         * @constructor
         * @param {string} token - The JWT access token
         * @param {string} apiRequester - issues the api request
         * @param {string} workspaceUrl - REST API workspace url
         * @memberOf Twilio.TaskRouter
         * @description Creates a Twilio TaskRouter Workspace which can fetch its attributes
         */
        function Workspace(token, apiRequester, workspaceUrl) {
          TaskRouterResource.call(this, token, workspaceUrl, apiRequester, workspaceUrl);

          var activityList = new ActivityList(token, apiRequester, workspaceUrl);
          var workflowList = new WorkflowList(token, apiRequester, workspaceUrl);
          var workerList = new WorkerList(token, apiRequester, workspaceUrl);
          var queueList = new TaskQueueList(token, apiRequester, workspaceUrl);
          var taskList = new TaskList(token, apiRequester, workspaceUrl);

          var statistics = new Statistics(token, workspaceUrl, apiRequester, workspaceUrl);
          var realtimeStats = new RealTimeStatistics(token, workspaceUrl, apiRequester, workspaceUrl);
          var cumulativeStats = new CumulativeStatistics(token, workspaceUrl, apiRequester, workspaceUrl);

          Object.defineProperties(this, {
            activities: {
              value: activityList,
              enumerable: true,
            },
            workflows: {
              value: workflowList,
              enumerable: true,
            },
            taskqueues: {
              value: queueList,
              enumerable: true,
            },
            workers: {
              value: workerList,
              enumerable: true,
            },
            tasks: {
              value: taskList,
              enumerable: true,
            },
            statistics: {
              value: statistics,
              enumerable: true,
            },
            realtimeStats: {
              value: realtimeStats,
              enumerable: true,
            },
            cumulativeStats: {
              value: cumulativeStats,
              enumerable: true,
            },
          });
        }
        Workspace.prototype = Object.create(TaskRouterResource.prototype);

        /**
         * Update the JWT with a non-expired one
         * @param {string} token - new token
         */
        Workspace.prototype.updateToken = function updateToken(token) {
          this.token = token;
          this.activities.updateToken(token);
          this.workflows.updateToken(token);
          this.taskqueues.updateToken(token);
          this.workers.updateToken(token);
          this.tasks.updateToken(token);
          this.statistics.updateToken(token);
        };

        module.exports = Workspace;
      },
      {
        '../list/activities': 20,
        '../list/cumulative-statistics': 21,
        '../list/realtime-statistics': 23,
        '../list/statistics': 25,
        '../list/taskqueues': 26,
        '../list/tasks': 28,
        '../list/workers': 30,
        '../list/workflows': 31,
        './taskrouter-resource': 15,
      },
    ],
    20: [
      function (require, module, exports) {
        var TaskRouterListResource = require('./taskrouter-list-resource');
        /**
         * @author jwitz
         * @version 1.1.0
         *
         * @constructor
         * @param {string} token - The JWT access token
         * @param {string} sid - the sid of the task
         * @param {string} apiRequester - issues the api request
         * @param {string} workspaceUrl - REST API workspace url
         * @memberOf Twilio.TaskRouter
         * @description Creates a Twilio TaskRouter ActivityList which can fetch the list of activities or create a new activity
         */
        function ActivityList(token, apiRequester, workspaceUrl) {
          var resourceUrl = workspaceUrl + '/Activities';
          TaskRouterListResource.call(this, token, resourceUrl, apiRequester, workspaceUrl);
        }
        ActivityList.prototype = Object.create(TaskRouterListResource.prototype);

        module.exports = ActivityList;
      },
      { './taskrouter-list-resource': 27 },
    ],
    21: [
      function (require, module, exports) {
        var TaskRouterListResource = require('./taskrouter-list-resource');
        /**
         * @author jwitz
         * @version 1.1.0
         *
         * @constructor
         * @param {string} token - The JWT access token
         * @param {string} resourceUrl - REST API resource url to fetch statistics for
         * @param {string} apiRequester - issues the api request
         * @param {string} workspaceUrl - REST API workspace url
         * @memberOf Twilio.TaskRouter
         * @description CumulativeStatistics Statistics fetcher
         */
        function CumulativeStatistics(token, resourceUrl, apiRequester, workspaceUrl) {
          var statsResourceUrl = resourceUrl + '/CumulativeStatistics';
          TaskRouterListResource.call(this, token, statsResourceUrl, apiRequester, workspaceUrl);
        }
        CumulativeStatistics.prototype = Object.create(TaskRouterListResource.prototype);

        module.exports = CumulativeStatistics;
      },
      { './taskrouter-list-resource': 27 },
    ],
    22: [
      function (require, module, exports) {
        /**
         * @author jwitz
         * @version 1.1.0
         *
         * @constructor
         * @param {string} token - The JWT access token
         * @param {string} resourceUrl - REST API list resource url
         * @param {string} apiRequester - issues the api request
         * @memberOf Twilio
         * @description Creates a Twilio List Resource which can fetch a list or create a new entity
         */
        function ListResource(token, resourceUrl, apiRequester) {
          Object.defineProperties(this, {
            token: {
              value: token,
              writable: true,
            },
            resourceUrl: {
              value: resourceUrl,
            },
            apiRequester: {
              value: apiRequester,
            },
          });
        }

        /**
         * Get a resource list's information
         * @param {json or string} params - (optional) json formatted query parameters or a single SID
         * @param {function} completion - async function to run upon completion of the query
         */
        ListResource.prototype.fetch = function fetch() {
          // handle optional params argument first
          var arg0 = arguments[0];
          var arg1 = arguments[1];

          var params;
          var completion;

          if (typeof arg0 === 'string') {
            // handling a single SID
            var sid = arg0;
            if (arg1 instanceof Function) {
              completion = arg1;
            } else {
              throw Error('2nd argument needs to be a function');
            }

            var sidRequest = JSON.stringify({ url: this.resourceUrl + '/' + sid, method: 'GET', token: this.token });
            this.apiRequester._postMessage(sidRequest, completion);
          } else {
            if (arg0 instanceof Function) {
              // handle no query parameters
              completion = arg0;
            } else if (arg0 instanceof Object) {
              // handle query parameters first, then completion function as 2nd arg
              params = arg0;
              if (arg1 instanceof Function) {
                completion = arg1;
              } else {
                throw Error('2nd argument needs to be a function');
              }
            } else {
              throw Error('1st argument needs to be either a callback function, query parameters, or a SID string');
            }

            var request = { url: this.resourceUrl, method: 'GET', token: this.token };
            if (params) {
              request.params = params;
            }
            var jsonParams = JSON.stringify(request);
            this.apiRequester._postMessage(jsonParams, completion);
          }
        };

        /**
         * Create a list resource
         * @param {json} params - json formatted POST parameters
         * @param {function} completion - async function to run upon completion of the query
         */
        ListResource.prototype.create = function create(params, completion) {
          var request = JSON.stringify({ url: this.resourceUrl, method: 'POST', params: params, token: this.token });
          this.apiRequester._postMessage(request, completion);
        };

        /**
         * Update a resource
         * @param {string} sid - sid to update
         * @param {json} params - json formatted POST parameters or a single attribute and value
         * @param {function} completion - async function to run upon completion of the post
         */
        ListResource.prototype.update = function update() {
          // handle optional single parameters argument
          var sid = arguments[0];
          var arg1 = arguments[1];
          var arg2 = arguments[2];
          var arg3 = arguments[3];

          var params = {};
          var completion;
          if (typeof arg1 === 'string') {
            // we're handling a single attribute update
            if (typeof arg2 === 'string') {
              params[arg1] = arg2;
              completion = arg3;
            } else {
              throw Error('3rd argument needs to be a string value');
            }
          } else if (arg1 instanceof Object) {
            params = arg1;
            for (var key in params) {
              var value = params[key];
              if (value instanceof Object) {
                params[key] = JSON.stringify(value);
              }
            }
            if (typeof arg2 === 'undefined' || arg2 instanceof Function) {
              completion = arg2;
            } else {
              throw Error('3rd argument needs to be a function');
            }
          } else {
            throw Error('2nd argument needs to either be a string or a JSON object');
          }
          var request = JSON.stringify({
            url: this.resourceUrl + '/' + sid,
            method: 'POST',
            params: params,
            token: this.token,
          });
          this.apiRequester._postMessage(request, completion, this);
        };

        /**
         * Delete a resource
         * @param {string} sid - the sid to delete
         * @param {function} completion - async function to run upon completion of the deletion
         */
        ListResource.prototype.delete = function deleteR(sid, completion) {
          var request = JSON.stringify({ url: this.resourceUrl + '/' + sid, method: 'DELETE', token: this.token });
          this.apiRequester._postMessage(request, completion);
        };

        /**
         * Update the JWT with a non-expired one
         * @param {string} token - new token
         */
        ListResource.prototype.updateToken = function updateToken(token) {
          this.token = token;
        };

        module.exports = ListResource;
      },
      {},
    ],
    23: [
      function (require, module, exports) {
        var TaskRouterListResource = require('./taskrouter-list-resource');
        /**
         * @author jwitz
         * @version 1.1.0
         *
         * @constructor
         * @param {string} token - The JWT access token
         * @param {string} resourceUrl - REST API resource url to fetch statistics for
         * @param {string} apiRequester - issues the api request
         * @param {string} workspaceUrl - REST API workspace url
         * @memberOf Twilio.TaskRouter
         * @description RealTime Statistics fetcher
         */
        function RealTimeStatistics(token, resourceUrl, apiRequester, workspaceUrl) {
          var statsResourceUrl = resourceUrl + '/RealTimeStatistics';
          TaskRouterListResource.call(this, token, statsResourceUrl, apiRequester, workspaceUrl);
        }
        RealTimeStatistics.prototype = Object.create(TaskRouterListResource.prototype);

        module.exports = RealTimeStatistics;
      },
      { './taskrouter-list-resource': 27 },
    ],
    24: [
      function (require, module, exports) {
        var TaskRouterListResource = require('./taskrouter-list-resource');
        /**
         * @author jwitz
         * @version 1.1.0
         *
         * @constructor
         * @param {string} token - The JWT access token
         * @param {string} url - The URL
         * @param {string} apiRequester - issues the api request
         * @param {string} workspaceUrl - REST API workspace url
         * @memberOf Twilio.TaskRouter
         * @description Creates a Twilio TaskRouter ReservationList which can fetch the list of reservations
         */
        function ReservationList(token, url, apiRequester, workspaceUrl) {
          var resourceUrl = url.split('?')[0];
          TaskRouterListResource.call(this, token, resourceUrl, apiRequester, workspaceUrl);
        }
        ReservationList.prototype = Object.create(TaskRouterListResource.prototype);

        module.exports = ReservationList;
      },
      { './taskrouter-list-resource': 27 },
    ],
    25: [
      function (require, module, exports) {
        var TaskRouterListResource = require('./taskrouter-list-resource');
        /**
         * @author jwitz
         * @version 1.1.0
         *
         * @constructor
         * @param {string} token - The JWT access token
         * @param {string} resourceUrl - REST API resource url to fetch statistics for
         * @param {string} apiRequester - issues the api request
         * @param {string} workspaceUrl - REST API workspace url
         * @memberOf Twilio.TaskRouter
         * @description Creates a Twilio TaskRouter Activity which can fetch its attributes
         */
        function Statistics(token, resourceUrl, apiRequester, workspaceUrl) {
          var statsResourceUrl = resourceUrl + '/Statistics';
          TaskRouterListResource.call(this, token, statsResourceUrl, apiRequester, workspaceUrl);
        }
        Statistics.prototype = Object.create(TaskRouterListResource.prototype);

        module.exports = Statistics;
      },
      { './taskrouter-list-resource': 27 },
    ],
    26: [
      function (require, module, exports) {
        var TaskRouterListResource = require('./taskrouter-list-resource');
        var Statistics = require('../list/statistics');
        var RealTimeStatistics = require('../list/realtime-statistics');
        var CumulativeStatistics = require('../list/cumulative-statistics');
        /**
         * @author jwitz
         * @version 1.1.0
         *
         * @constructor
         * @param {string} token - The JWT access token
         * @param {string} apiRequester - issues the api request
         * @param {string} workspaceUrl - REST API workspace url
         * @memberOf Twilio.TaskRouter
         * @description Creates a Twilio TaskRouter TaskQueueList which can fetch the list of queues or create a new queue
         */
        function TaskQueueList(token, apiRequester, workspaceUrl) {
          var resourceUrl = workspaceUrl + '/TaskQueues';

          var statistics = new Statistics(token, resourceUrl, apiRequester, workspaceUrl);
          var realtimeStats = new RealTimeStatistics(token, resourceUrl, apiRequester, workspaceUrl);
          var cumulativeStats = new CumulativeStatistics(token, resourceUrl, apiRequester, workspaceUrl);

          Object.defineProperties(this, {
            statistics: {
              value: statistics,
              enumerable: true,
            },
            realtimeStats: {
              value: realtimeStats,
              enumerable: true,
            },
            cumulativeStats: {
              value: cumulativeStats,
              enumerable: true,
            },
          });

          TaskRouterListResource.call(this, token, resourceUrl, apiRequester, workspaceUrl);
        }
        TaskQueueList.prototype = Object.create(TaskRouterListResource.prototype);

        /**
         * Update the JWT with a non-expired one
         * @param {string} token - new token
         */
        TaskQueueList.prototype.updateToken = function updateToken(token) {
          this.token = token;
          this.statistics.updateToken(token);
        };

        module.exports = TaskQueueList;
      },
      {
        '../list/cumulative-statistics': 21,
        '../list/realtime-statistics': 23,
        '../list/statistics': 25,
        './taskrouter-list-resource': 27,
      },
    ],
    27: [
      function (require, module, exports) {
        var ListResource = require('./list-resource');
        /**
         * @author jwitz
         * @version 1.1.0
         *
         * @constructor
         * @param {string} token - The JWT access token
         * @param {string} workspaceUrl - REST API list url
         * @param {string} apiRequester - issues the api request
         * @param {string} workspaceUrl - REST API workspace url
         * @memberOf Twilio
         * @description Creates a Twilio TaskRouter List Resource which can fetch a list or create a new entity
         */
        function TaskRouterListResource(token, resourceUrl, apiRequester, workspaceUrl) {
          Object.defineProperties(this, {
            workspaceUrl: {
              value: workspaceUrl,
            },
          });
          ListResource.call(this, token, resourceUrl, apiRequester);
        }
        TaskRouterListResource.prototype = Object.create(ListResource.prototype);

        module.exports = TaskRouterListResource;
      },
      { './list-resource': 22 },
    ],
    28: [
      function (require, module, exports) {
        var TaskRouterListResource = require('./taskrouter-list-resource');
        /**
         * @author jwitz
         * @version 1.1.0
         *
         * @constructor
         * @param {string} token - The JWT access token
         * @param {string} apiRequester - issues the api request
         * @param {string} workspaceUrl - REST API workspace url
         * @memberOf Twilio.TaskRouter
         * @description Creates a Twilio TaskRouter TaskList which can fetch the list of tasks or create a new task
         */
        function TaskList(token, apiRequester, workspaceUrl) {
          var resourceUrl = workspaceUrl + '/Tasks';
          TaskRouterListResource.call(this, token, resourceUrl, apiRequester, workspaceUrl);
        }
        TaskList.prototype = Object.create(TaskRouterListResource.prototype);

        module.exports = TaskList;
      },
      { './taskrouter-list-resource': 27 },
    ],
    29: [
      function (require, module, exports) {
        var TaskRouterListResource = require('./taskrouter-list-resource');
        /**
         * @author  gramanathaiah
         * @version 1.1.0
         *
         * @constructor
         * @param {string} token - The JWT access token
         * @param {string} apiRequester - issues the api request
         * @param {string} workspaceUrl - REST API workspace url
         * @memberOf Twilio.TaskRouter
         * @description Creates a Twilio TaskRouter WorkerChannel List  which can fetch the list of Channels
         */
        function WorkerChannelList(token, url, apiRequester, workspaceUrl) {
          var resourceUrl = url.split('?')[0];
          TaskRouterListResource.call(this, token, resourceUrl, apiRequester, workspaceUrl);
        }
        WorkerChannelList.prototype = Object.create(TaskRouterListResource.prototype);

        module.exports = WorkerChannelList;
      },
      { './taskrouter-list-resource': 27 },
    ],
    30: [
      function (require, module, exports) {
        var TaskRouterListResource = require('./taskrouter-list-resource');
        var Statistics = require('../list/statistics');
        var RealTimeStatistics = require('../list/realtime-statistics');
        var CumulativeStatistics = require('../list/cumulative-statistics');
        /**
         * @author jwitz
         * @version 1.1.0
         *
         * @constructor
         * @param {string} token - The JWT access token
         * @param {string} apiRequester - issues the api request
         * @param {string} workspaceUrl - REST API workspace url
         * @memberOf Twilio.TaskRouter
         * @description Creates a Twilio TaskRouter WorkerList which can fetch the list of workers or create a new worker
         */
        function WorkerList(token, apiRequester, workspaceUrl) {
          var resourceUrl = workspaceUrl + '/Workers';

          var statistics = new Statistics(token, resourceUrl, apiRequester, workspaceUrl);
          var realtimeStats = new RealTimeStatistics(token, resourceUrl, apiRequester, workspaceUrl);
          var cumulativeStats = new CumulativeStatistics(token, resourceUrl, apiRequester, workspaceUrl);

          Object.defineProperties(this, {
            statistics: {
              value: statistics,
              enumerable: true,
            },
            realtimeStats: {
              value: realtimeStats,
              enumerable: true,
            },
            cumulativeStats: {
              value: cumulativeStats,
              enumerable: true,
            },
          });

          TaskRouterListResource.call(this, token, resourceUrl, apiRequester, workspaceUrl);
        }
        WorkerList.prototype = Object.create(TaskRouterListResource.prototype);

        /**
         * Update the JWT with a non-expired one
         * @param {string} token - new token
         */
        WorkerList.prototype.updateToken = function updateToken(token) {
          this.token = token;
          this.statistics.updateToken(token);
        };

        module.exports = WorkerList;
      },
      {
        '../list/cumulative-statistics': 21,
        '../list/realtime-statistics': 23,
        '../list/statistics': 25,
        './taskrouter-list-resource': 27,
      },
    ],
    31: [
      function (require, module, exports) {
        var TaskRouterListResource = require('./taskrouter-list-resource');
        /**
         * @author jwitz
         * @version 1.1.0
         *
         * @constructor
         * @param {string} token - The JWT access token
         * @param {string} apiRequester - issues the api request
         * @param {string} workspaceUrl - REST API workspace url
         * @memberOf Twilio.TaskRouter
         * @description Creates a Twilio TaskRouter WorkflowList which can fetch the list of workflows or create a new workflow
         */
        function WorkflowList(token, apiRequester, workspaceUrl) {
          var resourceUrl = workspaceUrl + '/Workflows';
          TaskRouterListResource.call(this, token, resourceUrl, apiRequester, workspaceUrl);
        }
        WorkflowList.prototype = Object.create(TaskRouterListResource.prototype);

        module.exports = WorkflowList;
      },
      { './taskrouter-list-resource': 27 },
    ],
    32: [
      function (require, module, exports) {
        /**
         * @author jwitz
         * @version 1.1.0
         *
         * Converting a snake-case property to a camelcase property
         *
         * @name convertToCamelCase
         * @exports convertToCamelCase as Twilio.convertToCamelCase
         * @memberOf Twilio
         * @param {string} snakeCaseProperty json snake case property
         * @return {object} camelCaseProperty
         */
        function convertToCamelCase(snakeCaseProperty) {
          var underScoreIndex = snakeCaseProperty.indexOf('_');
          if (underScoreIndex === -1) {
            return snakeCaseProperty;
          } else {
            var firstProperty = snakeCaseProperty.substring(0, underScoreIndex);
            var startOfNextChar = snakeCaseProperty.charAt(underScoreIndex + 1).toUpperCase();
            var restOfProperties = snakeCaseProperty.substring(underScoreIndex + 2, snakeCaseProperty.length);
            var newProperty = firstProperty + startOfNextChar + restOfProperties;
            return convertToCamelCase(newProperty);
          }
        }

        exports.convertToCamelCase = convertToCamelCase;
      },
      {},
    ],
    33: [
      function (require, module, exports) {
        var Workspace = require('../resources/instance/workspace');
        var Activity = require('../resources/instance/activity');
        var Workflow = require('../resources/instance/workflow');
        var TaskQueue = require('../resources/instance/taskqueue');
        var Worker = require('../resources/instance/worker');
        var Task = require('../resources/instance/task');
        var Reservation = require('../resources/instance/reservation');
        var WorkerChannel = require('../resources/instance/workerchannel');

        var ActivityList = require('../resources/list/activities');
        var WorkflowList = require('../resources/list/workflows');
        var TaskQueueList = require('../resources/list/taskqueues');
        var WorkerList = require('../resources/list/workers');
        var TaskList = require('../resources/list/tasks');
        var ReservationList = require('../resources/list/reservations');
        var WorkerChannelList = require('../resources/list/workerchannels');

        var PropertyUtil = require('./property');

        /**
         * @author jwitz
         * @version 1.1.0
         *
         * Define objects for foreign key lookups
         *
         * @name setFKLookup
         * @exports setFKLookup as Twilio.TaskRouter.setFKLookup
         * @memberOf Twilio.TaskRouter
         * @function
         * @param {object} object object to set properties on
         * @param {string} sidType sid type
         * @param {string} sid sid
         * @param {string} token token to run rest api request on
         * @param {string} apiRequester utility to run api requests
         * @param {string} workspaceUrl workspace uri
         */
        function setFKLookup(object, sidType, sid, token, apiRequester, workspaceUrl) {
          var fkObject;
          var type;

          if (sidType === 'workspaceSid') {
            fkObject = new Workspace(token, apiRequester, workspaceUrl);
            type = 'workspace';
          } else if (sidType === 'workflowSid') {
            fkObject = new Workflow(token, sid, apiRequester, workspaceUrl);
            type = 'workflow';
          } else if (sidType === 'queueSid') {
            fkObject = new TaskQueue(token, sid, apiRequester, workspaceUrl);
            type = 'queue';
          } else if (sidType === 'workerSid') {
            fkObject = new Worker(token, sid, apiRequester, workspaceUrl);
            type = 'worker';
          } else if (sidType.toLowerCase().indexOf('activitysid') > 0) {
            fkObject = new Activity(token, sid, apiRequester, workspaceUrl);
            type = sidType.substring(0, sidType.indexOf('Sid'));
          } else if (sidType === 'taskSid') {
            fkObject = new Task(token, sid, apiRequester, workspaceUrl);
            type = 'task';
          } else if (sidType === 'reservationSid') {
            fkObject = new Reservation(token, sid, apiRequester, workspaceUrl);
            type = 'reservation';
          }

          if (typeof fkObject !== 'undefined') {
            if (!object.hasOwnProperty(type)) {
              Object.defineProperty(object, type, {
                enumerable: true,
                value: fkObject,
              });
            }
          }
        }

        /**
         * Create an entity for a payload based on the sid
         *
         * @name createEntity
         * @exports createEntity as Twilio.TaskRouter.createEntity
         * @memberOf Twilio.TaskRouter
         * @function
         * @param payload for the entity
         * @param {object} payload json properties to set on new object
         * @param {string} token token to run rest api request on
         * @param {string} apiRequester utility to run api requests
         * @param {string} workspaceURL the workspace to use
         * @returns {*} an entity for the given object
         */
        function createEntity(payload, token, apiRequester, workspaceUrl) {
          if (!payload) {
            return;
          }

          var entity;
          if (payload.sid) {
            var sid = payload.sid;
            var prefix = sid.substring(0, 2);

            if (prefix === 'WS') {
              entity = new Workspace(token, apiRequester, workspaceUrl);
            } else if (prefix === 'WW') {
              entity = new Workflow(token, sid, apiRequester, workspaceUrl);
            } else if (prefix === 'WQ') {
              entity = new TaskQueue(token, sid, apiRequester, workspaceUrl);
            } else if (prefix === 'WK') {
              entity = new Worker(token, sid, apiRequester, workspaceUrl);
            } else if (prefix === 'WA') {
              entity = new Activity(token, sid, apiRequester, workspaceUrl);
            } else if (prefix === 'WT') {
              entity = new Task(token, sid, apiRequester, workspaceUrl);
            } else if (prefix === 'WR') {
              var taskSid = payload.task_sid;
              entity = new Reservation(token, sid, taskSid, apiRequester, workspaceUrl);
            } else if (prefix === 'WC') {
              var workerSid = payload.worker_sid;
              entity = new WorkerChannel(token, workerSid, sid, apiRequester, workspaceUrl);
            }
            PropertyUtil.setProperties(entity, payload, token, apiRequester, workspaceUrl);
            return entity;
          } else if (payload.meta) {
            var meta = payload.meta;
            var metaKey = payload.meta.key;

            if (metaKey.indexOf('statistics') === -1) {
              // list entities so we can create and fetch next/previous pages
              var listEntity;
              if (metaKey === 'workflows') {
                listEntity = new WorkflowList(token, apiRequester, workspaceUrl);
              } else if (metaKey === 'task_queues') {
                listEntity = new TaskQueueList(token, apiRequester, workspaceUrl);
              } else if (metaKey === 'workers') {
                listEntity = new WorkerList(token, apiRequester, workspaceUrl);
              } else if (metaKey === 'activities') {
                listEntity = new ActivityList(token, apiRequester, workspaceUrl);
              } else if (metaKey === 'tasks') {
                listEntity = new TaskList(token, apiRequester, workspaceUrl);
              } else if (metaKey === 'reservations') {
                listEntity = new ReservationList(token, meta.url, apiRequester, workspaceUrl);
              } else if (metaKey === 'channels') {
                listEntity = new WorkerChannelList(token, meta.url, apiRequester, workspaceUrl);
              }

              // list items
              var listItems = [];
              payload[metaKey].forEach(function (element) {
                var listItem;
                if (metaKey === 'workflows') {
                  listItem = new Workflow(token, element.sid, apiRequester, workspaceUrl);
                } else if (metaKey === 'task_queues') {
                  listItem = new TaskQueue(token, element.sid, apiRequester, workspaceUrl);
                } else if (metaKey === 'workers') {
                  listItem = new Worker(token, element.sid, apiRequester, workspaceUrl);
                } else if (metaKey === 'activities') {
                  listItem = new Activity(token, element.sid, apiRequester, workspaceUrl);
                } else if (metaKey === 'tasks') {
                  listItem = new Task(token, element.sid, apiRequester, workspaceUrl);
                } else if (metaKey === 'reservations') {
                  var taskSid = element.task_sid;
                  listItem = new Reservation(token, element.sid, taskSid, apiRequester, workspaceUrl);
                } else if (metaKey === 'channels') {
                  var workerSid = element.worker_sid;
                  listItem = new WorkerChannel(token, workerSid, element.sid, apiRequester, workspaceUrl);
                }
                if (listItem) {
                  PropertyUtil.setProperties(listItem, element, token, apiRequester, workspaceUrl);
                  listItems.push(listItem);
                }
              });

              Object.defineProperty(listEntity, 'data', {
                enumerable: true,
                value: listItems,
              });

              Object.defineProperty(listEntity, 'page', {
                enumerable: true,
                value: meta.page,
              });

              Object.defineProperty(listEntity, 'pageSize', {
                enumerable: true,
                value: meta.page_size,
              });

              if (meta.next_page_url) {
                Object.defineProperty(listEntity, 'next', {
                  value: function (completion) {
                    var request = { url: meta.next_page_url, method: 'GET', token: token };
                    var jsonParams = JSON.stringify(request);
                    this.apiRequester._postMessage(jsonParams, completion);
                  },
                  enumerable: true,
                });
                Object.defineProperty(listEntity, 'hasNext', {
                  value: true,
                  enumerable: true,
                });
              } else {
                Object.defineProperty(listEntity, 'hasNext', {
                  value: false,
                  enumerable: true,
                });
              }

              if (meta.previous_page_url) {
                Object.defineProperty(listEntity, 'previous', {
                  value: function (completion) {
                    var request = { url: meta.previous_page_url, method: 'GET', token: token };
                    var jsonParams = JSON.stringify(request);
                    this.apiRequester._postMessage(jsonParams, completion);
                  },
                  enumerable: true,
                });
                Object.defineProperty(listEntity, 'hasPrevious', {
                  value: true,
                  enumerable: true,
                });
              } else {
                Object.defineProperty(listEntity, 'hasPrevious', {
                  value: false,
                  enumerable: true,
                });
              }

              return listEntity;
            } else {
              // dealing with statistics for a list resource
              var statsList = {};
              var statsListJSON = payload[metaKey];
              PropertyUtil.setProperties(statsList, statsListJSON);
              return statsList;
            }
          } else if (
            payload.cumulative ||
            payload.realtime ||
            (payload.url && payload.url.indexOf('Statistics') !== -1)
          ) {
            // dealing with statistics for a particular Sid
            var stats = {};
            var statsJSON = payload;
            PropertyUtil.setProperties(stats, statsJSON);
            return stats;
          }
        }

        exports.setFKLookup = setFKLookup;
        exports.createEntity = createEntity;
      },
      {
        '../resources/instance/activity': 10,
        '../resources/instance/reservation': 11,
        '../resources/instance/task': 13,
        '../resources/instance/taskqueue': 14,
        '../resources/instance/worker': 16,
        '../resources/instance/workerchannel': 17,
        '../resources/instance/workflow': 18,
        '../resources/instance/workspace': 19,
        '../resources/list/activities': 20,
        '../resources/list/reservations': 24,
        '../resources/list/taskqueues': 26,
        '../resources/list/tasks': 28,
        '../resources/list/workerchannels': 29,
        '../resources/list/workers': 30,
        '../resources/list/workflows': 31,
        './property': 35,
      },
    ],
    34: [
      function (require, module, exports) {
        (function (Buffer) {
          (function () {
            function memoize(fn) {
              return function () {
                var args = Array.prototype.slice.call(arguments, 0);
                fn.memo = fn.memo || {};
                return fn.memo[args] ? fn.memo[args] : (fn.memo[args] = fn.apply(null, args));
              };
            }

            function decodePayload(encoded_payload) {
              var remainder = encoded_payload.length % 4;
              if (remainder > 0) {
                var padlen = 4 - remainder;
                encoded_payload += new Array(padlen + 1).join('=');
              }
              encoded_payload = encoded_payload.replace(/-/g, '+').replace(/_/g, '/');
              var decoded_payload = _atob(encoded_payload);
              return JSON.parse(decoded_payload);
            }

            var memoizedDecodePayload = memoize(decodePayload);

            /**
             * Decodes a token.
             *
             * @name decode
             * @exports decode as Twilio.decode
             * @memberOf Twilio
             * @function
             * @param {string} token The JWT
             * @return {object} The payload
             */
            function decode(token) {
              var segs = token.split('.');
              if (segs.length != 3) {
                throw new Error('Wrong number of segments');
              }
              var encoded_payload = segs[1];
              var payload = memoizedDecodePayload(encoded_payload);
              return payload;
            }

            /**
             * Wrapper for atob.
             *
             * @name atob
             * @exports _atob as Twilio.atob
             * @memberOf Twilio
             * @function
             * @param {string} encoded The encoded string
             * @return {string} The decoded string
             */
            function _atob(encoded) {
              try {
                return atob(encoded);
              } catch (e) {
                try {
                  return new Buffer(encoded, 'base64').toString('ascii');
                } catch (f) {
                  return Twilio._phpjs_atob(encoded);
                }
              }
            }

            function objectize(token) {
              var jwt = decode(token);
              return jwt;
            }

            var memoizedObjectize = memoize(objectize);

            exports.decode = decode;
            exports.atob = _atob;
            exports.objectize = memoizedObjectize;
          }.call(this));
        }.call(this, require('buffer').Buffer));
      },
      { buffer: 39 },
    ],
    35: [
      function (require, module, exports) {
        var CamelCaseUtil = require('./camelcase');
        var EntityUtil = require('./entity');
        /**
         * @author jwitz
         * @version 1.1.0
         *
         * Loop through payload properties (json) and set them on an object
         * Additionally, create FK objects as needed to create additional object fetches
         * and handle payload properties (json) with multiple layers of depth
         *
         * @name setProperties
         * @exports convertToCamelCase as Twilio.convertToCamelCase
         * @memberOf Twilio
         * @function
         * @param {object} object object to set properties on
         * @param {string} payload json payload
         * @return {object} camelCaseProperty
         */
        function setProperties(object, payload, token, apiRequester, workspaceUrl) {
          for (var property in payload) {
            if (property == 'reservation_sid' || property === 'url' || property === 'links') {
              continue;
            }

            var propertyValue;
            if (property === 'attributes' || property === 'configuration' || property === 'addons') {
              propertyValue = JSON.parse(payload[property]);
            } else if (
              property === 'date_created' ||
              property === 'date_updated' ||
              property === 'date_status_changed'
            ) {
              propertyValue =
                typeof payload[property] === 'number'
                  ? new Date(payload[property] * 1000)
                  : new Date(payload[property]);
            } else if (payload[property] instanceof Object) {
              //handling nested properties
              propertyValue = payload[property];

              for (var prop in propertyValue) {
                if (propertyValue.hasOwnProperty(prop)) {
                  // define a new property that is camelcase
                  var propertyValueProp = propertyValue[prop];
                  var newProp = CamelCaseUtil.convertToCamelCase(prop);

                  // delete the current property that is non-camelcase
                  delete propertyValue[prop];

                  // if the nested property is an object, recursively create a new object
                  // with the object's payload to create a new object with camelcase properties
                  // otherwise just set the properties of the nested property
                  if (propertyValueProp instanceof Array) {
                    /* jshint ignore:start */
                    var arrayList = [];
                    propertyValueProp.forEach(function (element) {
                      var arrayObject = {};
                      setProperties(arrayObject, element, token, apiRequester, workspaceUrl);
                      arrayList.push(arrayObject);
                    });

                    Object.defineProperty(propertyValue, newProp, {
                      enumerable: true,
                      value: arrayList,
                    });
                    /* jshint ignore:end */
                  } else if (propertyValueProp instanceof Object) {
                    var newNestedObject = {};
                    setProperties(newNestedObject, propertyValueProp, token, apiRequester, workspaceUrl);

                    Object.defineProperty(propertyValue, newProp, {
                      enumerable: true,
                      value: newNestedObject,
                    });
                  } else {
                    Object.defineProperty(propertyValue, newProp, {
                      enumerable: true,
                      value: propertyValueProp,
                    });
                  }
                }
              }
            } else {
              propertyValue = payload[property];
            }

            // convert property to a camelcase version
            property = CamelCaseUtil.convertToCamelCase(property);

            // set the property on the object with the value determined above
            // override attributes on an entity update
            Object.defineProperty(object, property, {
              enumerable: true,
              configurable: true,
              value: propertyValue,
            });

            // create links to other FK objects
            // (i.e. if we find queue_sid, convert to camelcase to be queueSid,
            // create a queue object within FKLookup so we can do will queue.fetch to get the full attributes)
            if (property.indexOf('Sid') > 0) {
              EntityUtil.setFKLookup(object, property, propertyValue, token, apiRequester, workspaceUrl);
            }
          }
        }

        /**
         * Sets properties on a reservation based on XHR requests to fetch a task and reservation
         * @param reservation
         * @returns {Promise}
         */
        function setReservationProperties(reservation) {
          return new Promise(function (resolve, reject) {
            var taskPromise = _getTask(reservation);
            var reservationPromise = _getReservation(reservation);

            var promises = [taskPromise, reservationPromise];
            Promise.all(promises).then(
              function (results) {
                var reservation = results[1];

                // set a task property on the reservation
                Object.defineProperties(reservation, {
                  task: {
                    value: results[0],
                    enumerable: true,
                  },
                });

                resolve(reservation);
              },
              function (err) {
                reject(Error('Could not fetch task and reservation information'));
              }
            );
          });
        }

        /**
         * Sets a task property on a reservation
         * @param reservation
         * @returns {Promise}
         */
        function setTaskProperty(reservation) {
          return new Promise(function (resolve, reject) {
            var taskPromise = _getTask(reservation);
            taskPromise.then(function (task) {
              // set a task property on the reservation
              Object.defineProperties(reservation, {
                task: {
                  value: task,
                  enumerable: true,
                },
              });
              resolve(reservation);
            });
          });
        }

        /**
         * Fetches a task
         * @param reservation a reservation for a task
         * @returns {Promise}
         * @private
         */
        function _getTask(reservation) {
          return new Promise(function (resolve, reject) {
            reservation.task.fetch(function (error, task) {
              if (error) {
                console.log(error.code);
                console.log(error.message);
                reject(Error(error.message));
                return;
              }
              resolve(task);
            });
          });
        }

        /**
         * Fetches a reservation
         * @param reservation reservation
         * @returns {Promise}
         * @private
         */
        function _getReservation(reservation) {
          return new Promise(function (resolve, reject) {
            reservation.fetch(function (error, reservation) {
              if (error) {
                console.log(error.code);
                console.log(error.message);
                reject(Error(error.message));
                return;
              }
              resolve(reservation);
            });
          });
        }

        exports.setProperties = setProperties;
        exports.setReservationProperties = setReservationProperties;
        exports.setTaskProperty = setTaskProperty;
      },
      { './camelcase': 32, './entity': 33 },
    ],
    36: [
      function (require, module, exports) {
        function isValidNumber(x, msg) {
          return Number.isFinite(x) && x > 0;
        }

        var DEFAULT_MAX_TIMEOUT_LIMIT = 3000;
        var DEFAULT_BASE_TIMEOUT_MS = 800;

        module.exports = function RetryUtil(baseTimeout, timeoutLimit) {
          var _baseTimeout = DEFAULT_BASE_TIMEOUT_MS;
          var _maxTimeoutLimit = DEFAULT_MAX_TIMEOUT_LIMIT;

          if (isValidNumber(baseTimeout)) {
            _baseTimeout = baseTimeout;
          }

          if (isValidNumber(timeoutLimit)) {
            _maxTimeoutLimit = timeoutLimit;
          }

          /**
           * This helps to avoid cases in which many clients are synchronized by some
           * situation and all retry at once, sending requests in synchronized waves.
           * The value of random_number_milliseconds is recalculated after each retry
           * request.
           *
           * Ref: https://cloud.google.com/iot/docs/how-tos/exponential-backoff#example_algorithm
           *
           * Ref: https://en.wikipedia.org/wiki/Exponential_backoff#Expected_backoff
           */
          function generateRandomNumberLessThanX(x) {
            return Math.ceil(Math.random() * (x || 100));
          }

          function generateBackoffInterval(retryCount) {
            if (!isValidNumber(retryCount)) {
              console.warn(
                'retryCount should be a positive finite number. Resetting retryCount to 1. Current value: ' + retryCount
              );
              retryCount = 1;
            }

            var calculatedBackoff = Math.max(_baseTimeout, (_baseTimeout * (Math.pow(2, retryCount) - 1)) / 2);

            return Math.min(calculatedBackoff, _maxTimeoutLimit) + generateRandomNumberLessThanX();
          }

          function whenReady(nthRetry) {
            return new Promise(function (resolve) {
              var backoff = generateBackoffInterval(nthRetry);
              return setTimeout(function () {
                return resolve(backoff);
              }, backoff);
            });
          }

          this.generateBackoffInterval = generateBackoffInterval.bind(this);
          this.whenReady = whenReady.bind(this);
        };
      },
      {},
    ],
    37: [
      function (require, module, exports) {
        (function (global) {
          (function () {
            'use strict';

            var possibleNames = [
              'BigInt64Array',
              'BigUint64Array',
              'Float32Array',
              'Float64Array',
              'Int16Array',
              'Int32Array',
              'Int8Array',
              'Uint16Array',
              'Uint32Array',
              'Uint8Array',
              'Uint8ClampedArray',
            ];

            var g = typeof globalThis === 'undefined' ? global : globalThis;

            module.exports = function availableTypedArrays() {
              var out = [];
              for (var i = 0; i < possibleNames.length; i++) {
                if (typeof g[possibleNames[i]] === 'function') {
                  out[out.length] = possibleNames[i];
                }
              }
              return out;
            };
          }.call(this));
        }.call(
          this,
          typeof global !== 'undefined'
            ? global
            : typeof self !== 'undefined'
            ? self
            : typeof window !== 'undefined'
            ? window
            : {}
        ));
      },
      {},
    ],
    38: [
      function (require, module, exports) {
        'use strict';

        exports.byteLength = byteLength;
        exports.toByteArray = toByteArray;
        exports.fromByteArray = fromByteArray;

        var lookup = [];
        var revLookup = [];
        var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;

        var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
        for (var i = 0, len = code.length; i < len; ++i) {
          lookup[i] = code[i];
          revLookup[code.charCodeAt(i)] = i;
        }

        // Support decoding URL-safe base64 strings, as Node.js does.
        // See: https://en.wikipedia.org/wiki/Base64#URL_applications
        revLookup['-'.charCodeAt(0)] = 62;
        revLookup['_'.charCodeAt(0)] = 63;

        function getLens(b64) {
          var len = b64.length;

          if (len % 4 > 0) {
            throw new Error('Invalid string. Length must be a multiple of 4');
          }

          // Trim off extra bytes after placeholder bytes are found
          // See: https://github.com/beatgammit/base64-js/issues/42
          var validLen = b64.indexOf('=');
          if (validLen === -1) validLen = len;

          var placeHoldersLen = validLen === len ? 0 : 4 - (validLen % 4);

          return [validLen, placeHoldersLen];
        }

        // base64 is 4/3 + up to two characters of the original data
        function byteLength(b64) {
          var lens = getLens(b64);
          var validLen = lens[0];
          var placeHoldersLen = lens[1];
          return ((validLen + placeHoldersLen) * 3) / 4 - placeHoldersLen;
        }

        function _byteLength(b64, validLen, placeHoldersLen) {
          return ((validLen + placeHoldersLen) * 3) / 4 - placeHoldersLen;
        }

        function toByteArray(b64) {
          var tmp;
          var lens = getLens(b64);
          var validLen = lens[0];
          var placeHoldersLen = lens[1];

          var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));

          var curByte = 0;

          // if there are placeholders, only get up to the last complete 4 chars
          var len = placeHoldersLen > 0 ? validLen - 4 : validLen;

          var i;
          for (i = 0; i < len; i += 4) {
            tmp =
              (revLookup[b64.charCodeAt(i)] << 18) |
              (revLookup[b64.charCodeAt(i + 1)] << 12) |
              (revLookup[b64.charCodeAt(i + 2)] << 6) |
              revLookup[b64.charCodeAt(i + 3)];
            arr[curByte++] = (tmp >> 16) & 0xff;
            arr[curByte++] = (tmp >> 8) & 0xff;
            arr[curByte++] = tmp & 0xff;
          }

          if (placeHoldersLen === 2) {
            tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4);
            arr[curByte++] = tmp & 0xff;
          }

          if (placeHoldersLen === 1) {
            tmp =
              (revLookup[b64.charCodeAt(i)] << 10) |
              (revLookup[b64.charCodeAt(i + 1)] << 4) |
              (revLookup[b64.charCodeAt(i + 2)] >> 2);
            arr[curByte++] = (tmp >> 8) & 0xff;
            arr[curByte++] = tmp & 0xff;
          }

          return arr;
        }

        function tripletToBase64(num) {
          return (
            lookup[(num >> 18) & 0x3f] + lookup[(num >> 12) & 0x3f] + lookup[(num >> 6) & 0x3f] + lookup[num & 0x3f]
          );
        }

        function encodeChunk(uint8, start, end) {
          var tmp;
          var output = [];
          for (var i = start; i < end; i += 3) {
            tmp = ((uint8[i] << 16) & 0xff0000) + ((uint8[i + 1] << 8) & 0xff00) + (uint8[i + 2] & 0xff);
            output.push(tripletToBase64(tmp));
          }
          return output.join('');
        }

        function fromByteArray(uint8) {
          var tmp;
          var len = uint8.length;
          var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
          var parts = [];
          var maxChunkLength = 16383; // must be multiple of 3

          // go through the array every three bytes, we'll deal with trailing stuff later
          for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
            parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
          }

          // pad the end with zeros, but make sure to not forget the extra bytes
          if (extraBytes === 1) {
            tmp = uint8[len - 1];
            parts.push(lookup[tmp >> 2] + lookup[(tmp << 4) & 0x3f] + '==');
          } else if (extraBytes === 2) {
            tmp = (uint8[len - 2] << 8) + uint8[len - 1];
            parts.push(lookup[tmp >> 10] + lookup[(tmp >> 4) & 0x3f] + lookup[(tmp << 2) & 0x3f] + '=');
          }

          return parts.join('');
        }
      },
      {},
    ],
    39: [
      function (require, module, exports) {
        (function (Buffer) {
          (function () {
            /*!
             * The buffer module from node.js, for the browser.
             *
             * @author   Feross Aboukhadijeh <https://feross.org>
             * @license  MIT
             */
            /* eslint-disable no-proto */

            'use strict';

            var base64 = require('base64-js');
            var ieee754 = require('ieee754');

            exports.Buffer = Buffer;
            exports.SlowBuffer = SlowBuffer;
            exports.INSPECT_MAX_BYTES = 50;

            var K_MAX_LENGTH = 0x7fffffff;
            exports.kMaxLength = K_MAX_LENGTH;

            /**
             * If `Buffer.TYPED_ARRAY_SUPPORT`:
             *   === true    Use Uint8Array implementation (fastest)
             *   === false   Print warning and recommend using `buffer` v4.x which has an Object
             *               implementation (most compatible, even IE6)
             *
             * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
             * Opera 11.6+, iOS 4.2+.
             *
             * We report that the browser does not support typed arrays if the are not subclassable
             * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
             * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
             * for __proto__ and has a buggy typed array implementation.
             */
            Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();

            if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') {
              console.error(
                'This browser lacks typed array (Uint8Array) support which is required by ' +
                  '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
              );
            }

            function typedArraySupport() {
              // Can typed array instances can be augmented?
              try {
                var arr = new Uint8Array(1);
                arr.__proto__ = {
                  __proto__: Uint8Array.prototype,
                  foo: function () {
                    return 42;
                  },
                };
                return arr.foo() === 42;
              } catch (e) {
                return false;
              }
            }

            Object.defineProperty(Buffer.prototype, 'parent', {
              enumerable: true,
              get: function () {
                if (!Buffer.isBuffer(this)) return undefined;
                return this.buffer;
              },
            });

            Object.defineProperty(Buffer.prototype, 'offset', {
              enumerable: true,
              get: function () {
                if (!Buffer.isBuffer(this)) return undefined;
                return this.byteOffset;
              },
            });

            function createBuffer(length) {
              if (length > K_MAX_LENGTH) {
                throw new RangeError('The value "' + length + '" is invalid for option "size"');
              }
              // Return an augmented `Uint8Array` instance
              var buf = new Uint8Array(length);
              buf.__proto__ = Buffer.prototype;
              return buf;
            }

            /**
             * The Buffer constructor returns instances of `Uint8Array` that have their
             * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
             * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
             * and the `Uint8Array` methods. Square bracket notation works as expected -- it
             * returns a single octet.
             *
             * The `Uint8Array` prototype remains unmodified.
             */

            function Buffer(arg, encodingOrOffset, length) {
              // Common case.
              if (typeof arg === 'number') {
                if (typeof encodingOrOffset === 'string') {
                  throw new TypeError('The "string" argument must be of type string. Received type number');
                }
                return allocUnsafe(arg);
              }
              return from(arg, encodingOrOffset, length);
            }

            // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
            if (typeof Symbol !== 'undefined' && Symbol.species != null && Buffer[Symbol.species] === Buffer) {
              Object.defineProperty(Buffer, Symbol.species, {
                value: null,
                configurable: true,
                enumerable: false,
                writable: false,
              });
            }

            Buffer.poolSize = 8192; // not used by this implementation

            function from(value, encodingOrOffset, length) {
              if (typeof value === 'string') {
                return fromString(value, encodingOrOffset);
              }

              if (ArrayBuffer.isView(value)) {
                return fromArrayLike(value);
              }

              if (value == null) {
                throw TypeError(
                  'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
                    'or Array-like Object. Received type ' +
                    typeof value
                );
              }

              if (isInstance(value, ArrayBuffer) || (value && isInstance(value.buffer, ArrayBuffer))) {
                return fromArrayBuffer(value, encodingOrOffset, length);
              }

              if (typeof value === 'number') {
                throw new TypeError('The "value" argument must not be of type number. Received type number');
              }

              var valueOf = value.valueOf && value.valueOf();
              if (valueOf != null && valueOf !== value) {
                return Buffer.from(valueOf, encodingOrOffset, length);
              }

              var b = fromObject(value);
              if (b) return b;

              if (
                typeof Symbol !== 'undefined' &&
                Symbol.toPrimitive != null &&
                typeof value[Symbol.toPrimitive] === 'function'
              ) {
                return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
              }

              throw new TypeError(
                'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
                  'or Array-like Object. Received type ' +
                  typeof value
              );
            }

            /**
             * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
             * if value is a number.
             * Buffer.from(str[, encoding])
             * Buffer.from(array)
             * Buffer.from(buffer)
             * Buffer.from(arrayBuffer[, byteOffset[, length]])
             **/
            Buffer.from = function (value, encodingOrOffset, length) {
              return from(value, encodingOrOffset, length);
            };

            // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
            // https://github.com/feross/buffer/pull/148
            Buffer.prototype.__proto__ = Uint8Array.prototype;
            Buffer.__proto__ = Uint8Array;

            function assertSize(size) {
              if (typeof size !== 'number') {
                throw new TypeError('"size" argument must be of type number');
              } else if (size < 0) {
                throw new RangeError('The value "' + size + '" is invalid for option "size"');
              }
            }

            function alloc(size, fill, encoding) {
              assertSize(size);
              if (size <= 0) {
                return createBuffer(size);
              }
              if (fill !== undefined) {
                // Only pay attention to encoding if it's a string. This
                // prevents accidentally sending in a number that would
                // be interpretted as a start offset.
                return typeof encoding === 'string'
                  ? createBuffer(size).fill(fill, encoding)
                  : createBuffer(size).fill(fill);
              }
              return createBuffer(size);
            }

            /**
             * Creates a new filled Buffer instance.
             * alloc(size[, fill[, encoding]])
             **/
            Buffer.alloc = function (size, fill, encoding) {
              return alloc(size, fill, encoding);
            };

            function allocUnsafe(size) {
              assertSize(size);
              return createBuffer(size < 0 ? 0 : checked(size) | 0);
            }

            /**
             * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
             * */
            Buffer.allocUnsafe = function (size) {
              return allocUnsafe(size);
            };
            /**
             * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
             */
            Buffer.allocUnsafeSlow = function (size) {
              return allocUnsafe(size);
            };

            function fromString(string, encoding) {
              if (typeof encoding !== 'string' || encoding === '') {
                encoding = 'utf8';
              }

              if (!Buffer.isEncoding(encoding)) {
                throw new TypeError('Unknown encoding: ' + encoding);
              }

              var length = byteLength(string, encoding) | 0;
              var buf = createBuffer(length);

              var actual = buf.write(string, encoding);

              if (actual !== length) {
                // Writing a hex string, for example, that contains invalid characters will
                // cause everything after the first invalid character to be ignored. (e.g.
                // 'abxxcd' will be treated as 'ab')
                buf = buf.slice(0, actual);
              }

              return buf;
            }

            function fromArrayLike(array) {
              var length = array.length < 0 ? 0 : checked(array.length) | 0;
              var buf = createBuffer(length);
              for (var i = 0; i < length; i += 1) {
                buf[i] = array[i] & 255;
              }
              return buf;
            }

            function fromArrayBuffer(array, byteOffset, length) {
              if (byteOffset < 0 || array.byteLength < byteOffset) {
                throw new RangeError('"offset" is outside of buffer bounds');
              }

              if (array.byteLength < byteOffset + (length || 0)) {
                throw new RangeError('"length" is outside of buffer bounds');
              }

              var buf;
              if (byteOffset === undefined && length === undefined) {
                buf = new Uint8Array(array);
              } else if (length === undefined) {
                buf = new Uint8Array(array, byteOffset);
              } else {
                buf = new Uint8Array(array, byteOffset, length);
              }

              // Return an augmented `Uint8Array` instance
              buf.__proto__ = Buffer.prototype;
              return buf;
            }

            function fromObject(obj) {
              if (Buffer.isBuffer(obj)) {
                var len = checked(obj.length) | 0;
                var buf = createBuffer(len);

                if (buf.length === 0) {
                  return buf;
                }

                obj.copy(buf, 0, 0, len);
                return buf;
              }

              if (obj.length !== undefined) {
                if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
                  return createBuffer(0);
                }
                return fromArrayLike(obj);
              }

              if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
                return fromArrayLike(obj.data);
              }
            }

            function checked(length) {
              // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
              // length is NaN (which is otherwise coerced to zero.)
              if (length >= K_MAX_LENGTH) {
                throw new RangeError(
                  'Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes'
                );
              }
              return length | 0;
            }

            function SlowBuffer(length) {
              if (+length != length) {
                // eslint-disable-line eqeqeq
                length = 0;
              }
              return Buffer.alloc(+length);
            }

            Buffer.isBuffer = function isBuffer(b) {
              return b != null && b._isBuffer === true && b !== Buffer.prototype; // so Buffer.isBuffer(Buffer.prototype) will be false
            };

            Buffer.compare = function compare(a, b) {
              if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
              if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
              if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
                throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
              }

              if (a === b) return 0;

              var x = a.length;
              var y = b.length;

              for (var i = 0, len = Math.min(x, y); i < len; ++i) {
                if (a[i] !== b[i]) {
                  x = a[i];
                  y = b[i];
                  break;
                }
              }

              if (x < y) return -1;
              if (y < x) return 1;
              return 0;
            };

            Buffer.isEncoding = function isEncoding(encoding) {
              switch (String(encoding).toLowerCase()) {
                case 'hex':
                case 'utf8':
                case 'utf-8':
                case 'ascii':
                case 'latin1':
                case 'binary':
                case 'base64':
                case 'ucs2':
                case 'ucs-2':
                case 'utf16le':
                case 'utf-16le':
                  return true;
                default:
                  return false;
              }
            };

            Buffer.concat = function concat(list, length) {
              if (!Array.isArray(list)) {
                throw new TypeError('"list" argument must be an Array of Buffers');
              }

              if (list.length === 0) {
                return Buffer.alloc(0);
              }

              var i;
              if (length === undefined) {
                length = 0;
                for (i = 0; i < list.length; ++i) {
                  length += list[i].length;
                }
              }

              var buffer = Buffer.allocUnsafe(length);
              var pos = 0;
              for (i = 0; i < list.length; ++i) {
                var buf = list[i];
                if (isInstance(buf, Uint8Array)) {
                  buf = Buffer.from(buf);
                }
                if (!Buffer.isBuffer(buf)) {
                  throw new TypeError('"list" argument must be an Array of Buffers');
                }
                buf.copy(buffer, pos);
                pos += buf.length;
              }
              return buffer;
            };

            function byteLength(string, encoding) {
              if (Buffer.isBuffer(string)) {
                return string.length;
              }
              if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
                return string.byteLength;
              }
              if (typeof string !== 'string') {
                throw new TypeError(
                  'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
                    'Received type ' +
                    typeof string
                );
              }

              var len = string.length;
              var mustMatch = arguments.length > 2 && arguments[2] === true;
              if (!mustMatch && len === 0) return 0;

              // Use a for loop to avoid recursion
              var loweredCase = false;
              for (;;) {
                switch (encoding) {
                  case 'ascii':
                  case 'latin1':
                  case 'binary':
                    return len;
                  case 'utf8':
                  case 'utf-8':
                    return utf8ToBytes(string).length;
                  case 'ucs2':
                  case 'ucs-2':
                  case 'utf16le':
                  case 'utf-16le':
                    return len * 2;
                  case 'hex':
                    return len >>> 1;
                  case 'base64':
                    return base64ToBytes(string).length;
                  default:
                    if (loweredCase) {
                      return mustMatch ? -1 : utf8ToBytes(string).length; // assume utf8
                    }
                    encoding = ('' + encoding).toLowerCase();
                    loweredCase = true;
                }
              }
            }
            Buffer.byteLength = byteLength;

            function slowToString(encoding, start, end) {
              var loweredCase = false;

              // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
              // property of a typed array.

              // This behaves neither like String nor Uint8Array in that we set start/end
              // to their upper/lower bounds if the value passed is out of range.
              // undefined is handled specially as per ECMA-262 6th Edition,
              // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
              if (start === undefined || start < 0) {
                start = 0;
              }
              // Return early if start > this.length. Done here to prevent potential uint32
              // coercion fail below.
              if (start > this.length) {
                return '';
              }

              if (end === undefined || end > this.length) {
                end = this.length;
              }

              if (end <= 0) {
                return '';
              }

              // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
              end >>>= 0;
              start >>>= 0;

              if (end <= start) {
                return '';
              }

              if (!encoding) encoding = 'utf8';

              while (true) {
                switch (encoding) {
                  case 'hex':
                    return hexSlice(this, start, end);

                  case 'utf8':
                  case 'utf-8':
                    return utf8Slice(this, start, end);

                  case 'ascii':
                    return asciiSlice(this, start, end);

                  case 'latin1':
                  case 'binary':
                    return latin1Slice(this, start, end);

                  case 'base64':
                    return base64Slice(this, start, end);

                  case 'ucs2':
                  case 'ucs-2':
                  case 'utf16le':
                  case 'utf-16le':
                    return utf16leSlice(this, start, end);

                  default:
                    if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                    encoding = (encoding + '').toLowerCase();
                    loweredCase = true;
                }
              }
            }

            // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
            // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
            // reliably in a browserify context because there could be multiple different
            // copies of the 'buffer' package in use. This method works even for Buffer
            // instances that were created from another copy of the `buffer` package.
            // See: https://github.com/feross/buffer/issues/154
            Buffer.prototype._isBuffer = true;

            function swap(b, n, m) {
              var i = b[n];
              b[n] = b[m];
              b[m] = i;
            }

            Buffer.prototype.swap16 = function swap16() {
              var len = this.length;
              if (len % 2 !== 0) {
                throw new RangeError('Buffer size must be a multiple of 16-bits');
              }
              for (var i = 0; i < len; i += 2) {
                swap(this, i, i + 1);
              }
              return this;
            };

            Buffer.prototype.swap32 = function swap32() {
              var len = this.length;
              if (len % 4 !== 0) {
                throw new RangeError('Buffer size must be a multiple of 32-bits');
              }
              for (var i = 0; i < len; i += 4) {
                swap(this, i, i + 3);
                swap(this, i + 1, i + 2);
              }
              return this;
            };

            Buffer.prototype.swap64 = function swap64() {
              var len = this.length;
              if (len % 8 !== 0) {
                throw new RangeError('Buffer size must be a multiple of 64-bits');
              }
              for (var i = 0; i < len; i += 8) {
                swap(this, i, i + 7);
                swap(this, i + 1, i + 6);
                swap(this, i + 2, i + 5);
                swap(this, i + 3, i + 4);
              }
              return this;
            };

            Buffer.prototype.toString = function toString() {
              var length = this.length;
              if (length === 0) return '';
              if (arguments.length === 0) return utf8Slice(this, 0, length);
              return slowToString.apply(this, arguments);
            };

            Buffer.prototype.toLocaleString = Buffer.prototype.toString;

            Buffer.prototype.equals = function equals(b) {
              if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
              if (this === b) return true;
              return Buffer.compare(this, b) === 0;
            };

            Buffer.prototype.inspect = function inspect() {
              var str = '';
              var max = exports.INSPECT_MAX_BYTES;
              str = this.toString('hex', 0, max)
                .replace(/(.{2})/g, '$1 ')
                .trim();
              if (this.length > max) str += ' ... ';
              return '<Buffer ' + str + '>';
            };

            Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
              if (isInstance(target, Uint8Array)) {
                target = Buffer.from(target, target.offset, target.byteLength);
              }
              if (!Buffer.isBuffer(target)) {
                throw new TypeError(
                  'The "target" argument must be one of type Buffer or Uint8Array. ' + 'Received type ' + typeof target
                );
              }

              if (start === undefined) {
                start = 0;
              }
              if (end === undefined) {
                end = target ? target.length : 0;
              }
              if (thisStart === undefined) {
                thisStart = 0;
              }
              if (thisEnd === undefined) {
                thisEnd = this.length;
              }

              if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
                throw new RangeError('out of range index');
              }

              if (thisStart >= thisEnd && start >= end) {
                return 0;
              }
              if (thisStart >= thisEnd) {
                return -1;
              }
              if (start >= end) {
                return 1;
              }

              start >>>= 0;
              end >>>= 0;
              thisStart >>>= 0;
              thisEnd >>>= 0;

              if (this === target) return 0;

              var x = thisEnd - thisStart;
              var y = end - start;
              var len = Math.min(x, y);

              var thisCopy = this.slice(thisStart, thisEnd);
              var targetCopy = target.slice(start, end);

              for (var i = 0; i < len; ++i) {
                if (thisCopy[i] !== targetCopy[i]) {
                  x = thisCopy[i];
                  y = targetCopy[i];
                  break;
                }
              }

              if (x < y) return -1;
              if (y < x) return 1;
              return 0;
            };

            // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
            // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
            //
            // Arguments:
            // - buffer - a Buffer to search
            // - val - a string, Buffer, or number
            // - byteOffset - an index into `buffer`; will be clamped to an int32
            // - encoding - an optional encoding, relevant is val is a string
            // - dir - true for indexOf, false for lastIndexOf
            function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
              // Empty buffer means no match
              if (buffer.length === 0) return -1;

              // Normalize byteOffset
              if (typeof byteOffset === 'string') {
                encoding = byteOffset;
                byteOffset = 0;
              } else if (byteOffset > 0x7fffffff) {
                byteOffset = 0x7fffffff;
              } else if (byteOffset < -0x80000000) {
                byteOffset = -0x80000000;
              }
              byteOffset = +byteOffset; // Coerce to Number.
              if (numberIsNaN(byteOffset)) {
                // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
                byteOffset = dir ? 0 : buffer.length - 1;
              }

              // Normalize byteOffset: negative offsets start from the end of the buffer
              if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
              if (byteOffset >= buffer.length) {
                if (dir) return -1;
                else byteOffset = buffer.length - 1;
              } else if (byteOffset < 0) {
                if (dir) byteOffset = 0;
                else return -1;
              }

              // Normalize val
              if (typeof val === 'string') {
                val = Buffer.from(val, encoding);
              }

              // Finally, search either indexOf (if dir is true) or lastIndexOf
              if (Buffer.isBuffer(val)) {
                // Special case: looking for empty string/buffer always fails
                if (val.length === 0) {
                  return -1;
                }
                return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
              } else if (typeof val === 'number') {
                val = val & 0xff; // Search for a byte value [0-255]
                if (typeof Uint8Array.prototype.indexOf === 'function') {
                  if (dir) {
                    return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
                  } else {
                    return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
                  }
                }
                return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
              }

              throw new TypeError('val must be string, number or Buffer');
            }

            function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
              var indexSize = 1;
              var arrLength = arr.length;
              var valLength = val.length;

              if (encoding !== undefined) {
                encoding = String(encoding).toLowerCase();
                if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
                  if (arr.length < 2 || val.length < 2) {
                    return -1;
                  }
                  indexSize = 2;
                  arrLength /= 2;
                  valLength /= 2;
                  byteOffset /= 2;
                }
              }

              function read(buf, i) {
                if (indexSize === 1) {
                  return buf[i];
                } else {
                  return buf.readUInt16BE(i * indexSize);
                }
              }

              var i;
              if (dir) {
                var foundIndex = -1;
                for (i = byteOffset; i < arrLength; i++) {
                  if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                    if (foundIndex === -1) foundIndex = i;
                    if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
                  } else {
                    if (foundIndex !== -1) i -= i - foundIndex;
                    foundIndex = -1;
                  }
                }
              } else {
                if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
                for (i = byteOffset; i >= 0; i--) {
                  var found = true;
                  for (var j = 0; j < valLength; j++) {
                    if (read(arr, i + j) !== read(val, j)) {
                      found = false;
                      break;
                    }
                  }
                  if (found) return i;
                }
              }

              return -1;
            }

            Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
              return this.indexOf(val, byteOffset, encoding) !== -1;
            };

            Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
              return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
            };

            Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
              return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
            };

            function hexWrite(buf, string, offset, length) {
              offset = Number(offset) || 0;
              var remaining = buf.length - offset;
              if (!length) {
                length = remaining;
              } else {
                length = Number(length);
                if (length > remaining) {
                  length = remaining;
                }
              }

              var strLen = string.length;

              if (length > strLen / 2) {
                length = strLen / 2;
              }
              for (var i = 0; i < length; ++i) {
                var parsed = parseInt(string.substr(i * 2, 2), 16);
                if (numberIsNaN(parsed)) return i;
                buf[offset + i] = parsed;
              }
              return i;
            }

            function utf8Write(buf, string, offset, length) {
              return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
            }

            function asciiWrite(buf, string, offset, length) {
              return blitBuffer(asciiToBytes(string), buf, offset, length);
            }

            function latin1Write(buf, string, offset, length) {
              return asciiWrite(buf, string, offset, length);
            }

            function base64Write(buf, string, offset, length) {
              return blitBuffer(base64ToBytes(string), buf, offset, length);
            }

            function ucs2Write(buf, string, offset, length) {
              return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
            }

            Buffer.prototype.write = function write(string, offset, length, encoding) {
              // Buffer#write(string)
              if (offset === undefined) {
                encoding = 'utf8';
                length = this.length;
                offset = 0;
                // Buffer#write(string, encoding)
              } else if (length === undefined && typeof offset === 'string') {
                encoding = offset;
                length = this.length;
                offset = 0;
                // Buffer#write(string, offset[, length][, encoding])
              } else if (isFinite(offset)) {
                offset = offset >>> 0;
                if (isFinite(length)) {
                  length = length >>> 0;
                  if (encoding === undefined) encoding = 'utf8';
                } else {
                  encoding = length;
                  length = undefined;
                }
              } else {
                throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
              }

              var remaining = this.length - offset;
              if (length === undefined || length > remaining) length = remaining;

              if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
                throw new RangeError('Attempt to write outside buffer bounds');
              }

              if (!encoding) encoding = 'utf8';

              var loweredCase = false;
              for (;;) {
                switch (encoding) {
                  case 'hex':
                    return hexWrite(this, string, offset, length);

                  case 'utf8':
                  case 'utf-8':
                    return utf8Write(this, string, offset, length);

                  case 'ascii':
                    return asciiWrite(this, string, offset, length);

                  case 'latin1':
                  case 'binary':
                    return latin1Write(this, string, offset, length);

                  case 'base64':
                    // Warning: maxLength not taken into account in base64Write
                    return base64Write(this, string, offset, length);

                  case 'ucs2':
                  case 'ucs-2':
                  case 'utf16le':
                  case 'utf-16le':
                    return ucs2Write(this, string, offset, length);

                  default:
                    if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                    encoding = ('' + encoding).toLowerCase();
                    loweredCase = true;
                }
              }
            };

            Buffer.prototype.toJSON = function toJSON() {
              return {
                type: 'Buffer',
                data: Array.prototype.slice.call(this._arr || this, 0),
              };
            };

            function base64Slice(buf, start, end) {
              if (start === 0 && end === buf.length) {
                return base64.fromByteArray(buf);
              } else {
                return base64.fromByteArray(buf.slice(start, end));
              }
            }

            function utf8Slice(buf, start, end) {
              end = Math.min(buf.length, end);
              var res = [];

              var i = start;
              while (i < end) {
                var firstByte = buf[i];
                var codePoint = null;
                var bytesPerSequence = firstByte > 0xef ? 4 : firstByte > 0xdf ? 3 : firstByte > 0xbf ? 2 : 1;

                if (i + bytesPerSequence <= end) {
                  var secondByte, thirdByte, fourthByte, tempCodePoint;

                  switch (bytesPerSequence) {
                    case 1:
                      if (firstByte < 0x80) {
                        codePoint = firstByte;
                      }
                      break;
                    case 2:
                      secondByte = buf[i + 1];
                      if ((secondByte & 0xc0) === 0x80) {
                        tempCodePoint = ((firstByte & 0x1f) << 0x6) | (secondByte & 0x3f);
                        if (tempCodePoint > 0x7f) {
                          codePoint = tempCodePoint;
                        }
                      }
                      break;
                    case 3:
                      secondByte = buf[i + 1];
                      thirdByte = buf[i + 2];
                      if ((secondByte & 0xc0) === 0x80 && (thirdByte & 0xc0) === 0x80) {
                        tempCodePoint = ((firstByte & 0xf) << 0xc) | ((secondByte & 0x3f) << 0x6) | (thirdByte & 0x3f);
                        if (tempCodePoint > 0x7ff && (tempCodePoint < 0xd800 || tempCodePoint > 0xdfff)) {
                          codePoint = tempCodePoint;
                        }
                      }
                      break;
                    case 4:
                      secondByte = buf[i + 1];
                      thirdByte = buf[i + 2];
                      fourthByte = buf[i + 3];
                      if ((secondByte & 0xc0) === 0x80 && (thirdByte & 0xc0) === 0x80 && (fourthByte & 0xc0) === 0x80) {
                        tempCodePoint =
                          ((firstByte & 0xf) << 0x12) |
                          ((secondByte & 0x3f) << 0xc) |
                          ((thirdByte & 0x3f) << 0x6) |
                          (fourthByte & 0x3f);
                        if (tempCodePoint > 0xffff && tempCodePoint < 0x110000) {
                          codePoint = tempCodePoint;
                        }
                      }
                  }
                }

                if (codePoint === null) {
                  // we did not generate a valid codePoint so insert a
                  // replacement char (U+FFFD) and advance only 1 byte
                  codePoint = 0xfffd;
                  bytesPerSequence = 1;
                } else if (codePoint > 0xffff) {
                  // encode to utf16 (surrogate pair dance)
                  codePoint -= 0x10000;
                  res.push(((codePoint >>> 10) & 0x3ff) | 0xd800);
                  codePoint = 0xdc00 | (codePoint & 0x3ff);
                }

                res.push(codePoint);
                i += bytesPerSequence;
              }

              return decodeCodePointsArray(res);
            }

            // Based on http://stackoverflow.com/a/22747272/680742, the browser with
            // the lowest limit is Chrome, with 0x10000 args.
            // We go 1 magnitude less, for safety
            var MAX_ARGUMENTS_LENGTH = 0x1000;

            function decodeCodePointsArray(codePoints) {
              var len = codePoints.length;
              if (len <= MAX_ARGUMENTS_LENGTH) {
                return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
              }

              // Decode in chunks to avoid "call stack size exceeded".
              var res = '';
              var i = 0;
              while (i < len) {
                res += String.fromCharCode.apply(String, codePoints.slice(i, (i += MAX_ARGUMENTS_LENGTH)));
              }
              return res;
            }

            function asciiSlice(buf, start, end) {
              var ret = '';
              end = Math.min(buf.length, end);

              for (var i = start; i < end; ++i) {
                ret += String.fromCharCode(buf[i] & 0x7f);
              }
              return ret;
            }

            function latin1Slice(buf, start, end) {
              var ret = '';
              end = Math.min(buf.length, end);

              for (var i = start; i < end; ++i) {
                ret += String.fromCharCode(buf[i]);
              }
              return ret;
            }

            function hexSlice(buf, start, end) {
              var len = buf.length;

              if (!start || start < 0) start = 0;
              if (!end || end < 0 || end > len) end = len;

              var out = '';
              for (var i = start; i < end; ++i) {
                out += toHex(buf[i]);
              }
              return out;
            }

            function utf16leSlice(buf, start, end) {
              var bytes = buf.slice(start, end);
              var res = '';
              for (var i = 0; i < bytes.length; i += 2) {
                res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
              }
              return res;
            }

            Buffer.prototype.slice = function slice(start, end) {
              var len = this.length;
              start = ~~start;
              end = end === undefined ? len : ~~end;

              if (start < 0) {
                start += len;
                if (start < 0) start = 0;
              } else if (start > len) {
                start = len;
              }

              if (end < 0) {
                end += len;
                if (end < 0) end = 0;
              } else if (end > len) {
                end = len;
              }

              if (end < start) end = start;

              var newBuf = this.subarray(start, end);
              // Return an augmented `Uint8Array` instance
              newBuf.__proto__ = Buffer.prototype;
              return newBuf;
            };

            /*
             * Need to make sure that buffer isn't trying to write out of bounds.
             */
            function checkOffset(offset, ext, length) {
              if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
              if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
            }

            Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
              offset = offset >>> 0;
              byteLength = byteLength >>> 0;
              if (!noAssert) checkOffset(offset, byteLength, this.length);

              var val = this[offset];
              var mul = 1;
              var i = 0;
              while (++i < byteLength && (mul *= 0x100)) {
                val += this[offset + i] * mul;
              }

              return val;
            };

            Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
              offset = offset >>> 0;
              byteLength = byteLength >>> 0;
              if (!noAssert) {
                checkOffset(offset, byteLength, this.length);
              }

              var val = this[offset + --byteLength];
              var mul = 1;
              while (byteLength > 0 && (mul *= 0x100)) {
                val += this[offset + --byteLength] * mul;
              }

              return val;
            };

            Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
              offset = offset >>> 0;
              if (!noAssert) checkOffset(offset, 1, this.length);
              return this[offset];
            };

            Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
              offset = offset >>> 0;
              if (!noAssert) checkOffset(offset, 2, this.length);
              return this[offset] | (this[offset + 1] << 8);
            };

            Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
              offset = offset >>> 0;
              if (!noAssert) checkOffset(offset, 2, this.length);
              return (this[offset] << 8) | this[offset + 1];
            };

            Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
              offset = offset >>> 0;
              if (!noAssert) checkOffset(offset, 4, this.length);

              return (this[offset] | (this[offset + 1] << 8) | (this[offset + 2] << 16)) + this[offset + 3] * 0x1000000;
            };

            Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
              offset = offset >>> 0;
              if (!noAssert) checkOffset(offset, 4, this.length);

              return this[offset] * 0x1000000 + ((this[offset + 1] << 16) | (this[offset + 2] << 8) | this[offset + 3]);
            };

            Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
              offset = offset >>> 0;
              byteLength = byteLength >>> 0;
              if (!noAssert) checkOffset(offset, byteLength, this.length);

              var val = this[offset];
              var mul = 1;
              var i = 0;
              while (++i < byteLength && (mul *= 0x100)) {
                val += this[offset + i] * mul;
              }
              mul *= 0x80;

              if (val >= mul) val -= Math.pow(2, 8 * byteLength);

              return val;
            };

            Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
              offset = offset >>> 0;
              byteLength = byteLength >>> 0;
              if (!noAssert) checkOffset(offset, byteLength, this.length);

              var i = byteLength;
              var mul = 1;
              var val = this[offset + --i];
              while (i > 0 && (mul *= 0x100)) {
                val += this[offset + --i] * mul;
              }
              mul *= 0x80;

              if (val >= mul) val -= Math.pow(2, 8 * byteLength);

              return val;
            };

            Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
              offset = offset >>> 0;
              if (!noAssert) checkOffset(offset, 1, this.length);
              if (!(this[offset] & 0x80)) return this[offset];
              return (0xff - this[offset] + 1) * -1;
            };

            Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
              offset = offset >>> 0;
              if (!noAssert) checkOffset(offset, 2, this.length);
              var val = this[offset] | (this[offset + 1] << 8);
              return val & 0x8000 ? val | 0xffff0000 : val;
            };

            Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
              offset = offset >>> 0;
              if (!noAssert) checkOffset(offset, 2, this.length);
              var val = this[offset + 1] | (this[offset] << 8);
              return val & 0x8000 ? val | 0xffff0000 : val;
            };

            Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
              offset = offset >>> 0;
              if (!noAssert) checkOffset(offset, 4, this.length);

              return this[offset] | (this[offset + 1] << 8) | (this[offset + 2] << 16) | (this[offset + 3] << 24);
            };

            Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
              offset = offset >>> 0;
              if (!noAssert) checkOffset(offset, 4, this.length);

              return (this[offset] << 24) | (this[offset + 1] << 16) | (this[offset + 2] << 8) | this[offset + 3];
            };

            Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
              offset = offset >>> 0;
              if (!noAssert) checkOffset(offset, 4, this.length);
              return ieee754.read(this, offset, true, 23, 4);
            };

            Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
              offset = offset >>> 0;
              if (!noAssert) checkOffset(offset, 4, this.length);
              return ieee754.read(this, offset, false, 23, 4);
            };

            Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
              offset = offset >>> 0;
              if (!noAssert) checkOffset(offset, 8, this.length);
              return ieee754.read(this, offset, true, 52, 8);
            };

            Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
              offset = offset >>> 0;
              if (!noAssert) checkOffset(offset, 8, this.length);
              return ieee754.read(this, offset, false, 52, 8);
            };

            function checkInt(buf, value, offset, ext, max, min) {
              if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
              if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
              if (offset + ext > buf.length) throw new RangeError('Index out of range');
            }

            Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
              value = +value;
              offset = offset >>> 0;
              byteLength = byteLength >>> 0;
              if (!noAssert) {
                var maxBytes = Math.pow(2, 8 * byteLength) - 1;
                checkInt(this, value, offset, byteLength, maxBytes, 0);
              }

              var mul = 1;
              var i = 0;
              this[offset] = value & 0xff;
              while (++i < byteLength && (mul *= 0x100)) {
                this[offset + i] = (value / mul) & 0xff;
              }

              return offset + byteLength;
            };

            Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
              value = +value;
              offset = offset >>> 0;
              byteLength = byteLength >>> 0;
              if (!noAssert) {
                var maxBytes = Math.pow(2, 8 * byteLength) - 1;
                checkInt(this, value, offset, byteLength, maxBytes, 0);
              }

              var i = byteLength - 1;
              var mul = 1;
              this[offset + i] = value & 0xff;
              while (--i >= 0 && (mul *= 0x100)) {
                this[offset + i] = (value / mul) & 0xff;
              }

              return offset + byteLength;
            };

            Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
              value = +value;
              offset = offset >>> 0;
              if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
              this[offset] = value & 0xff;
              return offset + 1;
            };

            Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
              value = +value;
              offset = offset >>> 0;
              if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
              this[offset] = value & 0xff;
              this[offset + 1] = value >>> 8;
              return offset + 2;
            };

            Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
              value = +value;
              offset = offset >>> 0;
              if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
              this[offset] = value >>> 8;
              this[offset + 1] = value & 0xff;
              return offset + 2;
            };

            Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
              value = +value;
              offset = offset >>> 0;
              if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
              this[offset + 3] = value >>> 24;
              this[offset + 2] = value >>> 16;
              this[offset + 1] = value >>> 8;
              this[offset] = value & 0xff;
              return offset + 4;
            };

            Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
              value = +value;
              offset = offset >>> 0;
              if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
              this[offset] = value >>> 24;
              this[offset + 1] = value >>> 16;
              this[offset + 2] = value >>> 8;
              this[offset + 3] = value & 0xff;
              return offset + 4;
            };

            Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
              value = +value;
              offset = offset >>> 0;
              if (!noAssert) {
                var limit = Math.pow(2, 8 * byteLength - 1);

                checkInt(this, value, offset, byteLength, limit - 1, -limit);
              }

              var i = 0;
              var mul = 1;
              var sub = 0;
              this[offset] = value & 0xff;
              while (++i < byteLength && (mul *= 0x100)) {
                if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
                  sub = 1;
                }
                this[offset + i] = (((value / mul) >> 0) - sub) & 0xff;
              }

              return offset + byteLength;
            };

            Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
              value = +value;
              offset = offset >>> 0;
              if (!noAssert) {
                var limit = Math.pow(2, 8 * byteLength - 1);

                checkInt(this, value, offset, byteLength, limit - 1, -limit);
              }

              var i = byteLength - 1;
              var mul = 1;
              var sub = 0;
              this[offset + i] = value & 0xff;
              while (--i >= 0 && (mul *= 0x100)) {
                if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
                  sub = 1;
                }
                this[offset + i] = (((value / mul) >> 0) - sub) & 0xff;
              }

              return offset + byteLength;
            };

            Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
              value = +value;
              offset = offset >>> 0;
              if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
              if (value < 0) value = 0xff + value + 1;
              this[offset] = value & 0xff;
              return offset + 1;
            };

            Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
              value = +value;
              offset = offset >>> 0;
              if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
              this[offset] = value & 0xff;
              this[offset + 1] = value >>> 8;
              return offset + 2;
            };

            Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
              value = +value;
              offset = offset >>> 0;
              if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
              this[offset] = value >>> 8;
              this[offset + 1] = value & 0xff;
              return offset + 2;
            };

            Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
              value = +value;
              offset = offset >>> 0;
              if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
              this[offset] = value & 0xff;
              this[offset + 1] = value >>> 8;
              this[offset + 2] = value >>> 16;
              this[offset + 3] = value >>> 24;
              return offset + 4;
            };

            Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
              value = +value;
              offset = offset >>> 0;
              if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
              if (value < 0) value = 0xffffffff + value + 1;
              this[offset] = value >>> 24;
              this[offset + 1] = value >>> 16;
              this[offset + 2] = value >>> 8;
              this[offset + 3] = value & 0xff;
              return offset + 4;
            };

            function checkIEEE754(buf, value, offset, ext, max, min) {
              if (offset + ext > buf.length) throw new RangeError('Index out of range');
              if (offset < 0) throw new RangeError('Index out of range');
            }

            function writeFloat(buf, value, offset, littleEndian, noAssert) {
              value = +value;
              offset = offset >>> 0;
              if (!noAssert) {
                checkIEEE754(buf, value, offset, 4, 3.4028234663852886e38, -3.4028234663852886e38);
              }
              ieee754.write(buf, value, offset, littleEndian, 23, 4);
              return offset + 4;
            }

            Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
              return writeFloat(this, value, offset, true, noAssert);
            };

            Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
              return writeFloat(this, value, offset, false, noAssert);
            };

            function writeDouble(buf, value, offset, littleEndian, noAssert) {
              value = +value;
              offset = offset >>> 0;
              if (!noAssert) {
                checkIEEE754(buf, value, offset, 8, 1.7976931348623157e308, -1.7976931348623157e308);
              }
              ieee754.write(buf, value, offset, littleEndian, 52, 8);
              return offset + 8;
            }

            Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
              return writeDouble(this, value, offset, true, noAssert);
            };

            Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
              return writeDouble(this, value, offset, false, noAssert);
            };

            // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
            Buffer.prototype.copy = function copy(target, targetStart, start, end) {
              if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
              if (!start) start = 0;
              if (!end && end !== 0) end = this.length;
              if (targetStart >= target.length) targetStart = target.length;
              if (!targetStart) targetStart = 0;
              if (end > 0 && end < start) end = start;

              // Copy 0 bytes; we're done
              if (end === start) return 0;
              if (target.length === 0 || this.length === 0) return 0;

              // Fatal error conditions
              if (targetStart < 0) {
                throw new RangeError('targetStart out of bounds');
              }
              if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
              if (end < 0) throw new RangeError('sourceEnd out of bounds');

              // Are we oob?
              if (end > this.length) end = this.length;
              if (target.length - targetStart < end - start) {
                end = target.length - targetStart + start;
              }

              var len = end - start;

              if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
                // Use built-in when available, missing from IE11
                this.copyWithin(targetStart, start, end);
              } else if (this === target && start < targetStart && targetStart < end) {
                // descending copy from end
                for (var i = len - 1; i >= 0; --i) {
                  target[i + targetStart] = this[i + start];
                }
              } else {
                Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
              }

              return len;
            };

            // Usage:
            //    buffer.fill(number[, offset[, end]])
            //    buffer.fill(buffer[, offset[, end]])
            //    buffer.fill(string[, offset[, end]][, encoding])
            Buffer.prototype.fill = function fill(val, start, end, encoding) {
              // Handle string cases:
              if (typeof val === 'string') {
                if (typeof start === 'string') {
                  encoding = start;
                  start = 0;
                  end = this.length;
                } else if (typeof end === 'string') {
                  encoding = end;
                  end = this.length;
                }
                if (encoding !== undefined && typeof encoding !== 'string') {
                  throw new TypeError('encoding must be a string');
                }
                if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
                  throw new TypeError('Unknown encoding: ' + encoding);
                }
                if (val.length === 1) {
                  var code = val.charCodeAt(0);
                  if ((encoding === 'utf8' && code < 128) || encoding === 'latin1') {
                    // Fast path: If `val` fits into a single byte, use that numeric value.
                    val = code;
                  }
                }
              } else if (typeof val === 'number') {
                val = val & 255;
              }

              // Invalid ranges are not set to a default, so can range check early.
              if (start < 0 || this.length < start || this.length < end) {
                throw new RangeError('Out of range index');
              }

              if (end <= start) {
                return this;
              }

              start = start >>> 0;
              end = end === undefined ? this.length : end >>> 0;

              if (!val) val = 0;

              var i;
              if (typeof val === 'number') {
                for (i = start; i < end; ++i) {
                  this[i] = val;
                }
              } else {
                var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
                var len = bytes.length;
                if (len === 0) {
                  throw new TypeError('The value "' + val + '" is invalid for argument "value"');
                }
                for (i = 0; i < end - start; ++i) {
                  this[i + start] = bytes[i % len];
                }
              }

              return this;
            };

            // HELPER FUNCTIONS
            // ================

            var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;

            function base64clean(str) {
              // Node takes equal signs as end of the Base64 encoding
              str = str.split('=')[0];
              // Node strips out invalid characters like \n and \t from the string, base64-js does not
              str = str.trim().replace(INVALID_BASE64_RE, '');
              // Node converts strings with length < 2 to ''
              if (str.length < 2) return '';
              // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
              while (str.length % 4 !== 0) {
                str = str + '=';
              }
              return str;
            }

            function toHex(n) {
              if (n < 16) return '0' + n.toString(16);
              return n.toString(16);
            }

            function utf8ToBytes(string, units) {
              units = units || Infinity;
              var codePoint;
              var length = string.length;
              var leadSurrogate = null;
              var bytes = [];

              for (var i = 0; i < length; ++i) {
                codePoint = string.charCodeAt(i);

                // is surrogate component
                if (codePoint > 0xd7ff && codePoint < 0xe000) {
                  // last char was a lead
                  if (!leadSurrogate) {
                    // no lead yet
                    if (codePoint > 0xdbff) {
                      // unexpected trail
                      if ((units -= 3) > -1) bytes.push(0xef, 0xbf, 0xbd);
                      continue;
                    } else if (i + 1 === length) {
                      // unpaired lead
                      if ((units -= 3) > -1) bytes.push(0xef, 0xbf, 0xbd);
                      continue;
                    }

                    // valid lead
                    leadSurrogate = codePoint;

                    continue;
                  }

                  // 2 leads in a row
                  if (codePoint < 0xdc00) {
                    if ((units -= 3) > -1) bytes.push(0xef, 0xbf, 0xbd);
                    leadSurrogate = codePoint;
                    continue;
                  }

                  // valid surrogate pair
                  codePoint = (((leadSurrogate - 0xd800) << 10) | (codePoint - 0xdc00)) + 0x10000;
                } else if (leadSurrogate) {
                  // valid bmp char, but last char was a lead
                  if ((units -= 3) > -1) bytes.push(0xef, 0xbf, 0xbd);
                }

                leadSurrogate = null;

                // encode utf8
                if (codePoint < 0x80) {
                  if ((units -= 1) < 0) break;
                  bytes.push(codePoint);
                } else if (codePoint < 0x800) {
                  if ((units -= 2) < 0) break;
                  bytes.push((codePoint >> 0x6) | 0xc0, (codePoint & 0x3f) | 0x80);
                } else if (codePoint < 0x10000) {
                  if ((units -= 3) < 0) break;
                  bytes.push((codePoint >> 0xc) | 0xe0, ((codePoint >> 0x6) & 0x3f) | 0x80, (codePoint & 0x3f) | 0x80);
                } else if (codePoint < 0x110000) {
                  if ((units -= 4) < 0) break;
                  bytes.push(
                    (codePoint >> 0x12) | 0xf0,
                    ((codePoint >> 0xc) & 0x3f) | 0x80,
                    ((codePoint >> 0x6) & 0x3f) | 0x80,
                    (codePoint & 0x3f) | 0x80
                  );
                } else {
                  throw new Error('Invalid code point');
                }
              }

              return bytes;
            }

            function asciiToBytes(str) {
              var byteArray = [];
              for (var i = 0; i < str.length; ++i) {
                // Node's code seems to be doing this and not & 0x7F..
                byteArray.push(str.charCodeAt(i) & 0xff);
              }
              return byteArray;
            }

            function utf16leToBytes(str, units) {
              var c, hi, lo;
              var byteArray = [];
              for (var i = 0; i < str.length; ++i) {
                if ((units -= 2) < 0) break;

                c = str.charCodeAt(i);
                hi = c >> 8;
                lo = c % 256;
                byteArray.push(lo);
                byteArray.push(hi);
              }

              return byteArray;
            }

            function base64ToBytes(str) {
              return base64.toByteArray(base64clean(str));
            }

            function blitBuffer(src, dst, offset, length) {
              for (var i = 0; i < length; ++i) {
                if (i + offset >= dst.length || i >= src.length) break;
                dst[i + offset] = src[i];
              }
              return i;
            }

            // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
            // the `instanceof` check but they should be treated as of that type.
            // See: https://github.com/feross/buffer/issues/166
            function isInstance(obj, type) {
              return (
                obj instanceof type ||
                (obj != null &&
                  obj.constructor != null &&
                  obj.constructor.name != null &&
                  obj.constructor.name === type.name)
              );
            }
            function numberIsNaN(obj) {
              // For IE11 support
              return obj !== obj; // eslint-disable-line no-self-compare
            }
          }.call(this));
        }.call(this, require('buffer').Buffer));
      },
      { 'base64-js': 38, buffer: 39, ieee754: 52 },
    ],
    40: [
      function (require, module, exports) {
        'use strict';

        var GetIntrinsic = require('get-intrinsic');

        var callBind = require('./');

        var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

        module.exports = function callBoundIntrinsic(name, allowMissing) {
          var intrinsic = GetIntrinsic(name, !!allowMissing);
          if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
            return callBind(intrinsic);
          }
          return intrinsic;
        };
      },
      { './': 41, 'get-intrinsic': 46 },
    ],
    41: [
      function (require, module, exports) {
        'use strict';

        var bind = require('function-bind');
        var GetIntrinsic = require('get-intrinsic');

        var $apply = GetIntrinsic('%Function.prototype.apply%');
        var $call = GetIntrinsic('%Function.prototype.call%');
        var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

        var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
        var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
        var $max = GetIntrinsic('%Math.max%');

        if ($defineProperty) {
          try {
            $defineProperty({}, 'a', { value: 1 });
          } catch (e) {
            // IE 8 has a broken defineProperty
            $defineProperty = null;
          }
        }

        module.exports = function callBind(originalFunction) {
          var func = $reflectApply(bind, $call, arguments);
          if ($gOPD && $defineProperty) {
            var desc = $gOPD(func, 'length');
            if (desc.configurable) {
              // original length, plus the receiver, minus any additional arguments (after the receiver)
              $defineProperty(func, 'length', { value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) });
            }
          }
          return func;
        };

        var applyBind = function applyBind() {
          return $reflectApply(bind, $apply, arguments);
        };

        if ($defineProperty) {
          $defineProperty(module.exports, 'apply', { value: applyBind });
        } else {
          module.exports.apply = applyBind;
        }
      },
      { 'function-bind': 45, 'get-intrinsic': 46 },
    ],
    42: [
      function (require, module, exports) {
        // Copyright Joyent, Inc. and other Node contributors.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a
        // copy of this software and associated documentation files (the
        // "Software"), to deal in the Software without restriction, including
        // without limitation the rights to use, copy, modify, merge, publish,
        // distribute, sublicense, and/or sell copies of the Software, and to permit
        // persons to whom the Software is furnished to do so, subject to the
        // following conditions:
        //
        // The above copyright notice and this permission notice shall be included
        // in all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
        // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
        // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
        // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
        // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
        // USE OR OTHER DEALINGS IN THE SOFTWARE.

        'use strict';

        var R = typeof Reflect === 'object' ? Reflect : null;
        var ReflectApply =
          R && typeof R.apply === 'function'
            ? R.apply
            : function ReflectApply(target, receiver, args) {
                return Function.prototype.apply.call(target, receiver, args);
              };

        var ReflectOwnKeys;
        if (R && typeof R.ownKeys === 'function') {
          ReflectOwnKeys = R.ownKeys;
        } else if (Object.getOwnPropertySymbols) {
          ReflectOwnKeys = function ReflectOwnKeys(target) {
            return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
          };
        } else {
          ReflectOwnKeys = function ReflectOwnKeys(target) {
            return Object.getOwnPropertyNames(target);
          };
        }

        function ProcessEmitWarning(warning) {
          if (console && console.warn) console.warn(warning);
        }

        var NumberIsNaN =
          Number.isNaN ||
          function NumberIsNaN(value) {
            return value !== value;
          };

        function EventEmitter() {
          EventEmitter.init.call(this);
        }
        module.exports = EventEmitter;
        module.exports.once = once;

        // Backwards-compat with node 0.10.x
        EventEmitter.EventEmitter = EventEmitter;

        EventEmitter.prototype._events = undefined;
        EventEmitter.prototype._eventsCount = 0;
        EventEmitter.prototype._maxListeners = undefined;

        // By default EventEmitters will print a warning if more than 10 listeners are
        // added to it. This is a useful default which helps finding memory leaks.
        var defaultMaxListeners = 10;

        function checkListener(listener) {
          if (typeof listener !== 'function') {
            throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
          }
        }

        Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
          enumerable: true,
          get: function () {
            return defaultMaxListeners;
          },
          set: function (arg) {
            if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
              throw new RangeError(
                'The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' +
                  arg +
                  '.'
              );
            }
            defaultMaxListeners = arg;
          },
        });

        EventEmitter.init = function () {
          if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
            this._events = Object.create(null);
            this._eventsCount = 0;
          }

          this._maxListeners = this._maxListeners || undefined;
        };

        // Obviously not all Emitters should be limited to 10. This function allows
        // that to be increased. Set to zero for unlimited.
        EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
          if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
            throw new RangeError(
              'The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.'
            );
          }
          this._maxListeners = n;
          return this;
        };

        function _getMaxListeners(that) {
          if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
          return that._maxListeners;
        }

        EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
          return _getMaxListeners(this);
        };

        EventEmitter.prototype.emit = function emit(type) {
          var args = [];
          for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
          var doError = type === 'error';

          var events = this._events;
          if (events !== undefined) doError = doError && events.error === undefined;
          else if (!doError) return false;

          // If there is no 'error' event listener then throw.
          if (doError) {
            var er;
            if (args.length > 0) er = args[0];
            if (er instanceof Error) {
              // Note: The comments on the `throw` lines are intentional, they show
              // up in Node's output if this results in an unhandled exception.
              throw er; // Unhandled 'error' event
            }
            // At least give some kind of context to the user
            var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
            err.context = er;
            throw err; // Unhandled 'error' event
          }

          var handler = events[type];

          if (handler === undefined) return false;

          if (typeof handler === 'function') {
            ReflectApply(handler, this, args);
          } else {
            var len = handler.length;
            var listeners = arrayClone(handler, len);
            for (var i = 0; i < len; ++i) ReflectApply(listeners[i], this, args);
          }

          return true;
        };

        function _addListener(target, type, listener, prepend) {
          var m;
          var events;
          var existing;

          checkListener(listener);

          events = target._events;
          if (events === undefined) {
            events = target._events = Object.create(null);
            target._eventsCount = 0;
          } else {
            // To avoid recursion in the case that type === "newListener"! Before
            // adding it to the listeners, first emit "newListener".
            if (events.newListener !== undefined) {
              target.emit('newListener', type, listener.listener ? listener.listener : listener);

              // Re-assign `events` because a newListener handler could have caused the
              // this._events to be assigned to a new object
              events = target._events;
            }
            existing = events[type];
          }

          if (existing === undefined) {
            // Optimize the case of one listener. Don't need the extra array object.
            existing = events[type] = listener;
            ++target._eventsCount;
          } else {
            if (typeof existing === 'function') {
              // Adding the second element, need to change to array.
              existing = events[type] = prepend ? [listener, existing] : [existing, listener];
              // If we've already got an array, just append.
            } else if (prepend) {
              existing.unshift(listener);
            } else {
              existing.push(listener);
            }

            // Check for listener leak
            m = _getMaxListeners(target);
            if (m > 0 && existing.length > m && !existing.warned) {
              existing.warned = true;
              // No error code for this since it is a Warning
              // eslint-disable-next-line no-restricted-syntax
              var w = new Error(
                'Possible EventEmitter memory leak detected. ' +
                  existing.length +
                  ' ' +
                  String(type) +
                  ' listeners ' +
                  'added. Use emitter.setMaxListeners() to ' +
                  'increase limit'
              );
              w.name = 'MaxListenersExceededWarning';
              w.emitter = target;
              w.type = type;
              w.count = existing.length;
              ProcessEmitWarning(w);
            }
          }

          return target;
        }

        EventEmitter.prototype.addListener = function addListener(type, listener) {
          return _addListener(this, type, listener, false);
        };

        EventEmitter.prototype.on = EventEmitter.prototype.addListener;

        EventEmitter.prototype.prependListener = function prependListener(type, listener) {
          return _addListener(this, type, listener, true);
        };

        function onceWrapper() {
          if (!this.fired) {
            this.target.removeListener(this.type, this.wrapFn);
            this.fired = true;
            if (arguments.length === 0) return this.listener.call(this.target);
            return this.listener.apply(this.target, arguments);
          }
        }

        function _onceWrap(target, type, listener) {
          var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
          var wrapped = onceWrapper.bind(state);
          wrapped.listener = listener;
          state.wrapFn = wrapped;
          return wrapped;
        }

        EventEmitter.prototype.once = function once(type, listener) {
          checkListener(listener);
          this.on(type, _onceWrap(this, type, listener));
          return this;
        };

        EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
          checkListener(listener);
          this.prependListener(type, _onceWrap(this, type, listener));
          return this;
        };

        // Emits a 'removeListener' event if and only if the listener was removed.
        EventEmitter.prototype.removeListener = function removeListener(type, listener) {
          var list, events, position, i, originalListener;

          checkListener(listener);

          events = this._events;
          if (events === undefined) return this;

          list = events[type];
          if (list === undefined) return this;

          if (list === listener || list.listener === listener) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else {
              delete events[type];
              if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
            }
          } else if (typeof list !== 'function') {
            position = -1;

            for (i = list.length - 1; i >= 0; i--) {
              if (list[i] === listener || list[i].listener === listener) {
                originalListener = list[i].listener;
                position = i;
                break;
              }
            }

            if (position < 0) return this;

            if (position === 0) list.shift();
            else {
              spliceOne(list, position);
            }

            if (list.length === 1) events[type] = list[0];

            if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
          }

          return this;
        };

        EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

        EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
          var listeners, events, i;

          events = this._events;
          if (events === undefined) return this;

          // not listening for removeListener, no need to emit
          if (events.removeListener === undefined) {
            if (arguments.length === 0) {
              this._events = Object.create(null);
              this._eventsCount = 0;
            } else if (events[type] !== undefined) {
              if (--this._eventsCount === 0) this._events = Object.create(null);
              else delete events[type];
            }
            return this;
          }

          // emit removeListener for all listeners on all events
          if (arguments.length === 0) {
            var keys = Object.keys(events);
            var key;
            for (i = 0; i < keys.length; ++i) {
              key = keys[i];
              if (key === 'removeListener') continue;
              this.removeAllListeners(key);
            }
            this.removeAllListeners('removeListener');
            this._events = Object.create(null);
            this._eventsCount = 0;
            return this;
          }

          listeners = events[type];

          if (typeof listeners === 'function') {
            this.removeListener(type, listeners);
          } else if (listeners !== undefined) {
            // LIFO order
            for (i = listeners.length - 1; i >= 0; i--) {
              this.removeListener(type, listeners[i]);
            }
          }

          return this;
        };

        function _listeners(target, type, unwrap) {
          var events = target._events;

          if (events === undefined) return [];

          var evlistener = events[type];
          if (evlistener === undefined) return [];

          if (typeof evlistener === 'function') return unwrap ? [evlistener.listener || evlistener] : [evlistener];

          return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
        }

        EventEmitter.prototype.listeners = function listeners(type) {
          return _listeners(this, type, true);
        };

        EventEmitter.prototype.rawListeners = function rawListeners(type) {
          return _listeners(this, type, false);
        };

        EventEmitter.listenerCount = function (emitter, type) {
          if (typeof emitter.listenerCount === 'function') {
            return emitter.listenerCount(type);
          } else {
            return listenerCount.call(emitter, type);
          }
        };

        EventEmitter.prototype.listenerCount = listenerCount;
        function listenerCount(type) {
          var events = this._events;

          if (events !== undefined) {
            var evlistener = events[type];

            if (typeof evlistener === 'function') {
              return 1;
            } else if (evlistener !== undefined) {
              return evlistener.length;
            }
          }

          return 0;
        }

        EventEmitter.prototype.eventNames = function eventNames() {
          return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
        };

        function arrayClone(arr, n) {
          var copy = new Array(n);
          for (var i = 0; i < n; ++i) copy[i] = arr[i];
          return copy;
        }

        function spliceOne(list, index) {
          for (; index + 1 < list.length; index++) list[index] = list[index + 1];
          list.pop();
        }

        function unwrapListeners(arr) {
          var ret = new Array(arr.length);
          for (var i = 0; i < ret.length; ++i) {
            ret[i] = arr[i].listener || arr[i];
          }
          return ret;
        }

        function once(emitter, name) {
          return new Promise(function (resolve, reject) {
            function errorListener(err) {
              emitter.removeListener(name, resolver);
              reject(err);
            }

            function resolver() {
              if (typeof emitter.removeListener === 'function') {
                emitter.removeListener('error', errorListener);
              }
              resolve([].slice.call(arguments));
            }

            eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
            if (name !== 'error') {
              addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
            }
          });
        }

        function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
          if (typeof emitter.on === 'function') {
            eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
          }
        }

        function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
          if (typeof emitter.on === 'function') {
            if (flags.once) {
              emitter.once(name, listener);
            } else {
              emitter.on(name, listener);
            }
          } else if (typeof emitter.addEventListener === 'function') {
            // EventTarget does not have `error` event semantics like Node
            // EventEmitters, we do not listen for `error` events here.
            emitter.addEventListener(name, function wrapListener(arg) {
              // IE does not have builtin `{ once: true }` support so we
              // have to do it manually.
              if (flags.once) {
                emitter.removeEventListener(name, wrapListener);
              }
              listener(arg);
            });
          } else {
            throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
          }
        }
      },
      {},
    ],
    43: [
      function (require, module, exports) {
        'use strict';

        var isCallable = require('is-callable');

        var toStr = Object.prototype.toString;
        var hasOwnProperty = Object.prototype.hasOwnProperty;

        var forEachArray = function forEachArray(array, iterator, receiver) {
          for (var i = 0, len = array.length; i < len; i++) {
            if (hasOwnProperty.call(array, i)) {
              if (receiver == null) {
                iterator(array[i], i, array);
              } else {
                iterator.call(receiver, array[i], i, array);
              }
            }
          }
        };

        var forEachString = function forEachString(string, iterator, receiver) {
          for (var i = 0, len = string.length; i < len; i++) {
            // no such thing as a sparse string.
            if (receiver == null) {
              iterator(string.charAt(i), i, string);
            } else {
              iterator.call(receiver, string.charAt(i), i, string);
            }
          }
        };

        var forEachObject = function forEachObject(object, iterator, receiver) {
          for (var k in object) {
            if (hasOwnProperty.call(object, k)) {
              if (receiver == null) {
                iterator(object[k], k, object);
              } else {
                iterator.call(receiver, object[k], k, object);
              }
            }
          }
        };

        var forEach = function forEach(list, iterator, thisArg) {
          if (!isCallable(iterator)) {
            throw new TypeError('iterator must be a function');
          }

          var receiver;
          if (arguments.length >= 3) {
            receiver = thisArg;
          }

          if (toStr.call(list) === '[object Array]') {
            forEachArray(list, iterator, receiver);
          } else if (typeof list === 'string') {
            forEachString(list, iterator, receiver);
          } else {
            forEachObject(list, iterator, receiver);
          }
        };

        module.exports = forEach;
      },
      { 'is-callable': 55 },
    ],
    44: [
      function (require, module, exports) {
        'use strict';

        /* eslint no-invalid-this: 1 */

        var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
        var slice = Array.prototype.slice;
        var toStr = Object.prototype.toString;
        var funcType = '[object Function]';

        module.exports = function bind(that) {
          var target = this;
          if (typeof target !== 'function' || toStr.call(target) !== funcType) {
            throw new TypeError(ERROR_MESSAGE + target);
          }
          var args = slice.call(arguments, 1);

          var bound;
          var binder = function () {
            if (this instanceof bound) {
              var result = target.apply(this, args.concat(slice.call(arguments)));
              if (Object(result) === result) {
                return result;
              }
              return this;
            } else {
              return target.apply(that, args.concat(slice.call(arguments)));
            }
          };

          var boundLength = Math.max(0, target.length - args.length);
          var boundArgs = [];
          for (var i = 0; i < boundLength; i++) {
            boundArgs.push('$' + i);
          }

          bound = Function(
            'binder',
            'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }'
          )(binder);

          if (target.prototype) {
            var Empty = function Empty() {};
            Empty.prototype = target.prototype;
            bound.prototype = new Empty();
            Empty.prototype = null;
          }

          return bound;
        };
      },
      {},
    ],
    45: [
      function (require, module, exports) {
        'use strict';

        var implementation = require('./implementation');

        module.exports = Function.prototype.bind || implementation;
      },
      { './implementation': 44 },
    ],
    46: [
      function (require, module, exports) {
        'use strict';

        var undefined;

        var $SyntaxError = SyntaxError;
        var $Function = Function;
        var $TypeError = TypeError;

        // eslint-disable-next-line consistent-return
        var getEvalledConstructor = function (expressionSyntax) {
          try {
            return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
          } catch (e) {}
        };

        var $gOPD = Object.getOwnPropertyDescriptor;
        if ($gOPD) {
          try {
            $gOPD({}, '');
          } catch (e) {
            $gOPD = null; // this is IE 8, which has a broken gOPD
          }
        }

        var throwTypeError = function () {
          throw new $TypeError();
        };
        var ThrowTypeError = $gOPD
          ? (function () {
              try {
                // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
                arguments.callee; // IE 8 does not throw here
                return throwTypeError;
              } catch (calleeThrows) {
                try {
                  // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
                  return $gOPD(arguments, 'callee').get;
                } catch (gOPDthrows) {
                  return throwTypeError;
                }
              }
            })()
          : throwTypeError;

        var hasSymbols = require('has-symbols')();

        var getProto =
          Object.getPrototypeOf ||
          function (x) {
            return x.__proto__;
          }; // eslint-disable-line no-proto

        var needsEval = {};

        var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

        var INTRINSICS = {
          '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
          '%Array%': Array,
          '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
          '%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
          '%AsyncFromSyncIteratorPrototype%': undefined,
          '%AsyncFunction%': needsEval,
          '%AsyncGenerator%': needsEval,
          '%AsyncGeneratorFunction%': needsEval,
          '%AsyncIteratorPrototype%': needsEval,
          '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
          '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
          '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
          '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
          '%Boolean%': Boolean,
          '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
          '%Date%': Date,
          '%decodeURI%': decodeURI,
          '%decodeURIComponent%': decodeURIComponent,
          '%encodeURI%': encodeURI,
          '%encodeURIComponent%': encodeURIComponent,
          '%Error%': Error,
          '%eval%': eval, // eslint-disable-line no-eval
          '%EvalError%': EvalError,
          '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
          '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
          '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
          '%Function%': $Function,
          '%GeneratorFunction%': needsEval,
          '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
          '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
          '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
          '%isFinite%': isFinite,
          '%isNaN%': isNaN,
          '%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
          '%JSON%': typeof JSON === 'object' ? JSON : undefined,
          '%Map%': typeof Map === 'undefined' ? undefined : Map,
          '%MapIteratorPrototype%':
            typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
          '%Math%': Math,
          '%Number%': Number,
          '%Object%': Object,
          '%parseFloat%': parseFloat,
          '%parseInt%': parseInt,
          '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
          '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
          '%RangeError%': RangeError,
          '%ReferenceError%': ReferenceError,
          '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
          '%RegExp%': RegExp,
          '%Set%': typeof Set === 'undefined' ? undefined : Set,
          '%SetIteratorPrototype%':
            typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
          '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
          '%String%': String,
          '%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
          '%Symbol%': hasSymbols ? Symbol : undefined,
          '%SyntaxError%': $SyntaxError,
          '%ThrowTypeError%': ThrowTypeError,
          '%TypedArray%': TypedArray,
          '%TypeError%': $TypeError,
          '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
          '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
          '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
          '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
          '%URIError%': URIError,
          '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
          '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
          '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
        };

        try {
          null.error; // eslint-disable-line no-unused-expressions
        } catch (e) {
          // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
          var errorProto = getProto(getProto(e));
          INTRINSICS['%Error.prototype%'] = errorProto;
        }

        var doEval = function doEval(name) {
          var value;
          if (name === '%AsyncFunction%') {
            value = getEvalledConstructor('async function () {}');
          } else if (name === '%GeneratorFunction%') {
            value = getEvalledConstructor('function* () {}');
          } else if (name === '%AsyncGeneratorFunction%') {
            value = getEvalledConstructor('async function* () {}');
          } else if (name === '%AsyncGenerator%') {
            var fn = doEval('%AsyncGeneratorFunction%');
            if (fn) {
              value = fn.prototype;
            }
          } else if (name === '%AsyncIteratorPrototype%') {
            var gen = doEval('%AsyncGenerator%');
            if (gen) {
              value = getProto(gen.prototype);
            }
          }

          INTRINSICS[name] = value;

          return value;
        };

        var LEGACY_ALIASES = {
          '%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
          '%ArrayPrototype%': ['Array', 'prototype'],
          '%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
          '%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
          '%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
          '%ArrayProto_values%': ['Array', 'prototype', 'values'],
          '%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
          '%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
          '%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
          '%BooleanPrototype%': ['Boolean', 'prototype'],
          '%DataViewPrototype%': ['DataView', 'prototype'],
          '%DatePrototype%': ['Date', 'prototype'],
          '%ErrorPrototype%': ['Error', 'prototype'],
          '%EvalErrorPrototype%': ['EvalError', 'prototype'],
          '%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
          '%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
          '%FunctionPrototype%': ['Function', 'prototype'],
          '%Generator%': ['GeneratorFunction', 'prototype'],
          '%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
          '%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
          '%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
          '%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
          '%JSONParse%': ['JSON', 'parse'],
          '%JSONStringify%': ['JSON', 'stringify'],
          '%MapPrototype%': ['Map', 'prototype'],
          '%NumberPrototype%': ['Number', 'prototype'],
          '%ObjectPrototype%': ['Object', 'prototype'],
          '%ObjProto_toString%': ['Object', 'prototype', 'toString'],
          '%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
          '%PromisePrototype%': ['Promise', 'prototype'],
          '%PromiseProto_then%': ['Promise', 'prototype', 'then'],
          '%Promise_all%': ['Promise', 'all'],
          '%Promise_reject%': ['Promise', 'reject'],
          '%Promise_resolve%': ['Promise', 'resolve'],
          '%RangeErrorPrototype%': ['RangeError', 'prototype'],
          '%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
          '%RegExpPrototype%': ['RegExp', 'prototype'],
          '%SetPrototype%': ['Set', 'prototype'],
          '%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
          '%StringPrototype%': ['String', 'prototype'],
          '%SymbolPrototype%': ['Symbol', 'prototype'],
          '%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
          '%TypedArrayPrototype%': ['TypedArray', 'prototype'],
          '%TypeErrorPrototype%': ['TypeError', 'prototype'],
          '%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
          '%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
          '%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
          '%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
          '%URIErrorPrototype%': ['URIError', 'prototype'],
          '%WeakMapPrototype%': ['WeakMap', 'prototype'],
          '%WeakSetPrototype%': ['WeakSet', 'prototype'],
        };

        var bind = require('function-bind');
        var hasOwn = require('has');
        var $concat = bind.call(Function.call, Array.prototype.concat);
        var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
        var $replace = bind.call(Function.call, String.prototype.replace);
        var $strSlice = bind.call(Function.call, String.prototype.slice);
        var $exec = bind.call(Function.call, RegExp.prototype.exec);

        /* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
        var rePropName =
          /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
        var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
        var stringToPath = function stringToPath(string) {
          var first = $strSlice(string, 0, 1);
          var last = $strSlice(string, -1);
          if (first === '%' && last !== '%') {
            throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
          } else if (last === '%' && first !== '%') {
            throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
          }
          var result = [];
          $replace(string, rePropName, function (match, number, quote, subString) {
            result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
          });
          return result;
        };
        /* end adaptation */

        var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
          var intrinsicName = name;
          var alias;
          if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
            alias = LEGACY_ALIASES[intrinsicName];
            intrinsicName = '%' + alias[0] + '%';
          }

          if (hasOwn(INTRINSICS, intrinsicName)) {
            var value = INTRINSICS[intrinsicName];
            if (value === needsEval) {
              value = doEval(intrinsicName);
            }
            if (typeof value === 'undefined' && !allowMissing) {
              throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
            }

            return {
              alias: alias,
              name: intrinsicName,
              value: value,
            };
          }

          throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
        };

        module.exports = function GetIntrinsic(name, allowMissing) {
          if (typeof name !== 'string' || name.length === 0) {
            throw new $TypeError('intrinsic name must be a non-empty string');
          }
          if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
            throw new $TypeError('"allowMissing" argument must be a boolean');
          }

          if ($exec(/^%?[^%]*%?$/, name) === null) {
            throw new $SyntaxError(
              '`%` may not be present anywhere but at the beginning and end of the intrinsic name'
            );
          }
          var parts = stringToPath(name);
          var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

          var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
          var intrinsicRealName = intrinsic.name;
          var value = intrinsic.value;
          var skipFurtherCaching = false;

          var alias = intrinsic.alias;
          if (alias) {
            intrinsicBaseName = alias[0];
            $spliceApply(parts, $concat([0, 1], alias));
          }

          for (var i = 1, isOwn = true; i < parts.length; i += 1) {
            var part = parts[i];
            var first = $strSlice(part, 0, 1);
            var last = $strSlice(part, -1);
            if (
              (first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') &&
              first !== last
            ) {
              throw new $SyntaxError('property names with quotes must have matching quotes');
            }
            if (part === 'constructor' || !isOwn) {
              skipFurtherCaching = true;
            }

            intrinsicBaseName += '.' + part;
            intrinsicRealName = '%' + intrinsicBaseName + '%';

            if (hasOwn(INTRINSICS, intrinsicRealName)) {
              value = INTRINSICS[intrinsicRealName];
            } else if (value != null) {
              if (!(part in value)) {
                if (!allowMissing) {
                  throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
                }
                return void undefined;
              }
              if ($gOPD && i + 1 >= parts.length) {
                var desc = $gOPD(value, part);
                isOwn = !!desc;

                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
                  value = desc.get;
                } else {
                  value = value[part];
                }
              } else {
                isOwn = hasOwn(value, part);
                value = value[part];
              }

              if (isOwn && !skipFurtherCaching) {
                INTRINSICS[intrinsicRealName] = value;
              }
            }
          }
          return value;
        };
      },
      { 'function-bind': 45, has: 51, 'has-symbols': 48 },
    ],
    47: [
      function (require, module, exports) {
        'use strict';

        var GetIntrinsic = require('get-intrinsic');

        var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);

        if ($gOPD) {
          try {
            $gOPD([], 'length');
          } catch (e) {
            // IE 8 has a broken gOPD
            $gOPD = null;
          }
        }

        module.exports = $gOPD;
      },
      { 'get-intrinsic': 46 },
    ],
    48: [
      function (require, module, exports) {
        'use strict';

        var origSymbol = typeof Symbol !== 'undefined' && Symbol;
        var hasSymbolSham = require('./shams');

        module.exports = function hasNativeSymbols() {
          if (typeof origSymbol !== 'function') {
            return false;
          }
          if (typeof Symbol !== 'function') {
            return false;
          }
          if (typeof origSymbol('foo') !== 'symbol') {
            return false;
          }
          if (typeof Symbol('bar') !== 'symbol') {
            return false;
          }

          return hasSymbolSham();
        };
      },
      { './shams': 49 },
    ],
    49: [
      function (require, module, exports) {
        'use strict';

        /* eslint complexity: [2, 18], max-statements: [2, 33] */
        module.exports = function hasSymbols() {
          if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') {
            return false;
          }
          if (typeof Symbol.iterator === 'symbol') {
            return true;
          }

          var obj = {};
          var sym = Symbol('test');
          var symObj = Object(sym);
          if (typeof sym === 'string') {
            return false;
          }

          if (Object.prototype.toString.call(sym) !== '[object Symbol]') {
            return false;
          }
          if (Object.prototype.toString.call(symObj) !== '[object Symbol]') {
            return false;
          }

          // temp disabled per https://github.com/ljharb/object.assign/issues/17
          // if (sym instanceof Symbol) { return false; }
          // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
          // if (!(symObj instanceof Symbol)) { return false; }

          // if (typeof Symbol.prototype.toString !== 'function') { return false; }
          // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

          var symVal = 42;
          obj[sym] = symVal;
          for (sym in obj) {
            return false;
          } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
          if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) {
            return false;
          }

          if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) {
            return false;
          }

          var syms = Object.getOwnPropertySymbols(obj);
          if (syms.length !== 1 || syms[0] !== sym) {
            return false;
          }

          if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
            return false;
          }

          if (typeof Object.getOwnPropertyDescriptor === 'function') {
            var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
            if (descriptor.value !== symVal || descriptor.enumerable !== true) {
              return false;
            }
          }

          return true;
        };
      },
      {},
    ],
    50: [
      function (require, module, exports) {
        'use strict';

        var hasSymbols = require('has-symbols/shams');

        module.exports = function hasToStringTagShams() {
          return hasSymbols() && !!Symbol.toStringTag;
        };
      },
      { 'has-symbols/shams': 49 },
    ],
    51: [
      function (require, module, exports) {
        'use strict';

        var bind = require('function-bind');

        module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);
      },
      { 'function-bind': 45 },
    ],
    52: [
      function (require, module, exports) {
        /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
        exports.read = function (buffer, offset, isLE, mLen, nBytes) {
          var e, m;
          var eLen = nBytes * 8 - mLen - 1;
          var eMax = (1 << eLen) - 1;
          var eBias = eMax >> 1;
          var nBits = -7;
          var i = isLE ? nBytes - 1 : 0;
          var d = isLE ? -1 : 1;
          var s = buffer[offset + i];

          i += d;

          e = s & ((1 << -nBits) - 1);
          s >>= -nBits;
          nBits += eLen;
          for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

          m = e & ((1 << -nBits) - 1);
          e >>= -nBits;
          nBits += mLen;
          for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

          if (e === 0) {
            e = 1 - eBias;
          } else if (e === eMax) {
            return m ? NaN : (s ? -1 : 1) * Infinity;
          } else {
            m = m + Math.pow(2, mLen);
            e = e - eBias;
          }
          return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
        };

        exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
          var e, m, c;
          var eLen = nBytes * 8 - mLen - 1;
          var eMax = (1 << eLen) - 1;
          var eBias = eMax >> 1;
          var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
          var i = isLE ? 0 : nBytes - 1;
          var d = isLE ? 1 : -1;
          var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;

          value = Math.abs(value);

          if (isNaN(value) || value === Infinity) {
            m = isNaN(value) ? 1 : 0;
            e = eMax;
          } else {
            e = Math.floor(Math.log(value) / Math.LN2);
            if (value * (c = Math.pow(2, -e)) < 1) {
              e--;
              c *= 2;
            }
            if (e + eBias >= 1) {
              value += rt / c;
            } else {
              value += rt * Math.pow(2, 1 - eBias);
            }
            if (value * c >= 2) {
              e++;
              c /= 2;
            }

            if (e + eBias >= eMax) {
              m = 0;
              e = eMax;
            } else if (e + eBias >= 1) {
              m = (value * c - 1) * Math.pow(2, mLen);
              e = e + eBias;
            } else {
              m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
              e = 0;
            }
          }

          for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

          e = (e << mLen) | m;
          eLen += mLen;
          for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

          buffer[offset + i - d] |= s * 128;
        };
      },
      {},
    ],
    53: [
      function (require, module, exports) {
        if (typeof Object.create === 'function') {
          // implementation from standard node.js 'util' module
          module.exports = function inherits(ctor, superCtor) {
            if (superCtor) {
              ctor.super_ = superCtor;
              ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                  value: ctor,
                  enumerable: false,
                  writable: true,
                  configurable: true,
                },
              });
            }
          };
        } else {
          // old school shim for old browsers
          module.exports = function inherits(ctor, superCtor) {
            if (superCtor) {
              ctor.super_ = superCtor;
              var TempCtor = function () {};
              TempCtor.prototype = superCtor.prototype;
              ctor.prototype = new TempCtor();
              ctor.prototype.constructor = ctor;
            }
          };
        }
      },
      {},
    ],
    54: [
      function (require, module, exports) {
        'use strict';

        var hasToStringTag = require('has-tostringtag/shams')();
        var callBound = require('call-bind/callBound');

        var $toString = callBound('Object.prototype.toString');

        var isStandardArguments = function isArguments(value) {
          if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
            return false;
          }
          return $toString(value) === '[object Arguments]';
        };

        var isLegacyArguments = function isArguments(value) {
          if (isStandardArguments(value)) {
            return true;
          }
          return (
            value !== null &&
            typeof value === 'object' &&
            typeof value.length === 'number' &&
            value.length >= 0 &&
            $toString(value) !== '[object Array]' &&
            $toString(value.callee) === '[object Function]'
          );
        };

        var supportsStandardArguments = (function () {
          return isStandardArguments(arguments);
        })();

        isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

        module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;
      },
      { 'call-bind/callBound': 40, 'has-tostringtag/shams': 50 },
    ],
    55: [
      function (require, module, exports) {
        'use strict';

        var fnToStr = Function.prototype.toString;
        var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
        var badArrayLike;
        var isCallableMarker;
        if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
          try {
            badArrayLike = Object.defineProperty({}, 'length', {
              get: function () {
                throw isCallableMarker;
              },
            });
            isCallableMarker = {};
            // eslint-disable-next-line no-throw-literal
            reflectApply(
              function () {
                throw 42;
              },
              null,
              badArrayLike
            );
          } catch (_) {
            if (_ !== isCallableMarker) {
              reflectApply = null;
            }
          }
        } else {
          reflectApply = null;
        }

        var constructorRegex = /^\s*class\b/;
        var isES6ClassFn = function isES6ClassFunction(value) {
          try {
            var fnStr = fnToStr.call(value);
            return constructorRegex.test(fnStr);
          } catch (e) {
            return false; // not a function
          }
        };

        var tryFunctionObject = function tryFunctionToStr(value) {
          try {
            if (isES6ClassFn(value)) {
              return false;
            }
            fnToStr.call(value);
            return true;
          } catch (e) {
            return false;
          }
        };
        var toStr = Object.prototype.toString;
        var objectClass = '[object Object]';
        var fnClass = '[object Function]';
        var genClass = '[object GeneratorFunction]';
        var ddaClass = '[object HTMLAllCollection]'; // IE 11
        var ddaClass2 = '[object HTML document.all class]';
        var ddaClass3 = '[object HTMLCollection]'; // IE 9-10
        var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`

        var isIE68 = !(0 in [,]); // eslint-disable-line no-sparse-arrays, comma-spacing

        var isDDA = function isDocumentDotAll() {
          return false;
        };
        if (typeof document === 'object') {
          // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
          var all = document.all;
          if (toStr.call(all) === toStr.call(document.all)) {
            isDDA = function isDocumentDotAll(value) {
              /* globals document: false */
              // in IE 6-8, typeof document.all is "object" and it's truthy
              if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) {
                try {
                  var str = toStr.call(value);
                  return (
                    (str === ddaClass ||
                      str === ddaClass2 ||
                      str === ddaClass3 || // opera 12.16
                      str === objectClass) && // IE 6-8
                    value('') == null
                  ); // eslint-disable-line eqeqeq
                } catch (e) {
                  /**/
                }
              }
              return false;
            };
          }
        }

        module.exports = reflectApply
          ? function isCallable(value) {
              if (isDDA(value)) {
                return true;
              }
              if (!value) {
                return false;
              }
              if (typeof value !== 'function' && typeof value !== 'object') {
                return false;
              }
              try {
                reflectApply(value, null, badArrayLike);
              } catch (e) {
                if (e !== isCallableMarker) {
                  return false;
                }
              }
              return !isES6ClassFn(value) && tryFunctionObject(value);
            }
          : function isCallable(value) {
              if (isDDA(value)) {
                return true;
              }
              if (!value) {
                return false;
              }
              if (typeof value !== 'function' && typeof value !== 'object') {
                return false;
              }
              if (hasToStringTag) {
                return tryFunctionObject(value);
              }
              if (isES6ClassFn(value)) {
                return false;
              }
              var strClass = toStr.call(value);
              if (strClass !== fnClass && strClass !== genClass && !/^\[object HTML/.test(strClass)) {
                return false;
              }
              return tryFunctionObject(value);
            };
      },
      {},
    ],
    56: [
      function (require, module, exports) {
        'use strict';

        var toStr = Object.prototype.toString;
        var fnToStr = Function.prototype.toString;
        var isFnRegex = /^\s*(?:function)?\*/;
        var hasToStringTag = require('has-tostringtag/shams')();
        var getProto = Object.getPrototypeOf;
        var getGeneratorFunc = function () {
          // eslint-disable-line consistent-return
          if (!hasToStringTag) {
            return false;
          }
          try {
            return Function('return function*() {}')();
          } catch (e) {}
        };
        var GeneratorFunction;

        module.exports = function isGeneratorFunction(fn) {
          if (typeof fn !== 'function') {
            return false;
          }
          if (isFnRegex.test(fnToStr.call(fn))) {
            return true;
          }
          if (!hasToStringTag) {
            var str = toStr.call(fn);
            return str === '[object GeneratorFunction]';
          }
          if (!getProto) {
            return false;
          }
          if (typeof GeneratorFunction === 'undefined') {
            var generatorFunc = getGeneratorFunc();
            GeneratorFunction = generatorFunc ? getProto(generatorFunc) : false;
          }
          return getProto(fn) === GeneratorFunction;
        };
      },
      { 'has-tostringtag/shams': 50 },
    ],
    57: [
      function (require, module, exports) {
        (function (global) {
          (function () {
            'use strict';

            var forEach = require('for-each');
            var availableTypedArrays = require('available-typed-arrays');
            var callBound = require('call-bind/callBound');

            var $toString = callBound('Object.prototype.toString');
            var hasToStringTag = require('has-tostringtag/shams')();
            var gOPD = require('gopd');

            var g = typeof globalThis === 'undefined' ? global : globalThis;
            var typedArrays = availableTypedArrays();

            var $indexOf =
              callBound('Array.prototype.indexOf', true) ||
              function indexOf(array, value) {
                for (var i = 0; i < array.length; i += 1) {
                  if (array[i] === value) {
                    return i;
                  }
                }
                return -1;
              };
            var $slice = callBound('String.prototype.slice');
            var toStrTags = {};
            var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
            if (hasToStringTag && gOPD && getPrototypeOf) {
              forEach(typedArrays, function (typedArray) {
                var arr = new g[typedArray]();
                if (Symbol.toStringTag in arr) {
                  var proto = getPrototypeOf(arr);
                  var descriptor = gOPD(proto, Symbol.toStringTag);
                  if (!descriptor) {
                    var superProto = getPrototypeOf(proto);
                    descriptor = gOPD(superProto, Symbol.toStringTag);
                  }
                  toStrTags[typedArray] = descriptor.get;
                }
              });
            }

            var tryTypedArrays = function tryAllTypedArrays(value) {
              var anyTrue = false;
              forEach(toStrTags, function (getter, typedArray) {
                if (!anyTrue) {
                  try {
                    anyTrue = getter.call(value) === typedArray;
                  } catch (e) {
                    /**/
                  }
                }
              });
              return anyTrue;
            };

            module.exports = function isTypedArray(value) {
              if (!value || typeof value !== 'object') {
                return false;
              }
              if (!hasToStringTag || !(Symbol.toStringTag in value)) {
                var tag = $slice($toString(value), 8, -1);
                return $indexOf(typedArrays, tag) > -1;
              }
              if (!gOPD) {
                return false;
              }
              return tryTypedArrays(value);
            };
          }.call(this));
        }.call(
          this,
          typeof global !== 'undefined'
            ? global
            : typeof self !== 'undefined'
            ? self
            : typeof window !== 'undefined'
            ? window
            : {}
        ));
      },
      {
        'available-typed-arrays': 37,
        'call-bind/callBound': 40,
        'for-each': 43,
        gopd: 47,
        'has-tostringtag/shams': 50,
      },
    ],
    58: [
      function (require, module, exports) {
        // shim for using process in browser
        var process = (module.exports = {});

        // cached from whatever global is present so that test runners that stub it
        // don't break things.  But we need to wrap it in a try catch in case it is
        // wrapped in strict mode code which doesn't define any globals.  It's inside a
        // function because try/catches deoptimize in certain engines.

        var cachedSetTimeout;
        var cachedClearTimeout;

        function defaultSetTimout() {
          throw new Error('setTimeout has not been defined');
        }
        function defaultClearTimeout() {
          throw new Error('clearTimeout has not been defined');
        }
        (function () {
          try {
            if (typeof setTimeout === 'function') {
              cachedSetTimeout = setTimeout;
            } else {
              cachedSetTimeout = defaultSetTimout;
            }
          } catch (e) {
            cachedSetTimeout = defaultSetTimout;
          }
          try {
            if (typeof clearTimeout === 'function') {
              cachedClearTimeout = clearTimeout;
            } else {
              cachedClearTimeout = defaultClearTimeout;
            }
          } catch (e) {
            cachedClearTimeout = defaultClearTimeout;
          }
        })();
        function runTimeout(fun) {
          if (cachedSetTimeout === setTimeout) {
            //normal enviroments in sane situations
            return setTimeout(fun, 0);
          }
          // if setTimeout wasn't available but was latter defined
          if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
            cachedSetTimeout = setTimeout;
            return setTimeout(fun, 0);
          }
          try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedSetTimeout(fun, 0);
          } catch (e) {
            try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
              return cachedSetTimeout.call(null, fun, 0);
            } catch (e) {
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
              return cachedSetTimeout.call(this, fun, 0);
            }
          }
        }
        function runClearTimeout(marker) {
          if (cachedClearTimeout === clearTimeout) {
            //normal enviroments in sane situations
            return clearTimeout(marker);
          }
          // if clearTimeout wasn't available but was latter defined
          if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
            cachedClearTimeout = clearTimeout;
            return clearTimeout(marker);
          }
          try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedClearTimeout(marker);
          } catch (e) {
            try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
              return cachedClearTimeout.call(null, marker);
            } catch (e) {
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
              // Some versions of I.E. have different rules for clearTimeout vs setTimeout
              return cachedClearTimeout.call(this, marker);
            }
          }
        }
        var queue = [];
        var draining = false;
        var currentQueue;
        var queueIndex = -1;

        function cleanUpNextTick() {
          if (!draining || !currentQueue) {
            return;
          }
          draining = false;
          if (currentQueue.length) {
            queue = currentQueue.concat(queue);
          } else {
            queueIndex = -1;
          }
          if (queue.length) {
            drainQueue();
          }
        }

        function drainQueue() {
          if (draining) {
            return;
          }
          var timeout = runTimeout(cleanUpNextTick);
          draining = true;

          var len = queue.length;
          while (len) {
            currentQueue = queue;
            queue = [];
            while (++queueIndex < len) {
              if (currentQueue) {
                currentQueue[queueIndex].run();
              }
            }
            queueIndex = -1;
            len = queue.length;
          }
          currentQueue = null;
          draining = false;
          runClearTimeout(timeout);
        }

        process.nextTick = function (fun) {
          var args = new Array(arguments.length - 1);
          if (arguments.length > 1) {
            for (var i = 1; i < arguments.length; i++) {
              args[i - 1] = arguments[i];
            }
          }
          queue.push(new Item(fun, args));
          if (queue.length === 1 && !draining) {
            runTimeout(drainQueue);
          }
        };

        // v8 likes predictible objects
        function Item(fun, array) {
          this.fun = fun;
          this.array = array;
        }
        Item.prototype.run = function () {
          this.fun.apply(null, this.array);
        };
        process.title = 'browser';
        process.browser = true;
        process.env = {};
        process.argv = [];
        process.version = ''; // empty string to avoid regexp issues
        process.versions = {};

        function noop() {}

        process.on = noop;
        process.addListener = noop;
        process.once = noop;
        process.off = noop;
        process.removeListener = noop;
        process.removeAllListeners = noop;
        process.emit = noop;
        process.prependListener = noop;
        process.prependOnceListener = noop;

        process.listeners = function (name) {
          return [];
        };

        process.binding = function (name) {
          throw new Error('process.binding is not supported');
        };

        process.cwd = function () {
          return '/';
        };
        process.chdir = function (dir) {
          throw new Error('process.chdir is not supported');
        };
        process.umask = function () {
          return 0;
        };
      },
      {},
    ],
    59: [
      function (require, module, exports) {
        module.exports = function isBuffer(arg) {
          return (
            arg &&
            typeof arg === 'object' &&
            typeof arg.copy === 'function' &&
            typeof arg.fill === 'function' &&
            typeof arg.readUInt8 === 'function'
          );
        };
      },
      {},
    ],
    60: [
      function (require, module, exports) {
        // Currently in sync with Node.js lib/internal/util/types.js
        // https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9

        'use strict';

        var isArgumentsObject = require('is-arguments');
        var isGeneratorFunction = require('is-generator-function');
        var whichTypedArray = require('which-typed-array');
        var isTypedArray = require('is-typed-array');

        function uncurryThis(f) {
          return f.call.bind(f);
        }

        var BigIntSupported = typeof BigInt !== 'undefined';
        var SymbolSupported = typeof Symbol !== 'undefined';

        var ObjectToString = uncurryThis(Object.prototype.toString);

        var numberValue = uncurryThis(Number.prototype.valueOf);
        var stringValue = uncurryThis(String.prototype.valueOf);
        var booleanValue = uncurryThis(Boolean.prototype.valueOf);

        if (BigIntSupported) {
          var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
        }

        if (SymbolSupported) {
          var symbolValue = uncurryThis(Symbol.prototype.valueOf);
        }

        function checkBoxedPrimitive(value, prototypeValueOf) {
          if (typeof value !== 'object') {
            return false;
          }
          try {
            prototypeValueOf(value);
            return true;
          } catch (e) {
            return false;
          }
        }

        exports.isArgumentsObject = isArgumentsObject;
        exports.isGeneratorFunction = isGeneratorFunction;
        exports.isTypedArray = isTypedArray;

        // Taken from here and modified for better browser support
        // https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
        function isPromise(input) {
          return (
            (typeof Promise !== 'undefined' && input instanceof Promise) ||
            (input !== null &&
              typeof input === 'object' &&
              typeof input.then === 'function' &&
              typeof input.catch === 'function')
          );
        }
        exports.isPromise = isPromise;

        function isArrayBufferView(value) {
          if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
            return ArrayBuffer.isView(value);
          }

          return isTypedArray(value) || isDataView(value);
        }
        exports.isArrayBufferView = isArrayBufferView;

        function isUint8Array(value) {
          return whichTypedArray(value) === 'Uint8Array';
        }
        exports.isUint8Array = isUint8Array;

        function isUint8ClampedArray(value) {
          return whichTypedArray(value) === 'Uint8ClampedArray';
        }
        exports.isUint8ClampedArray = isUint8ClampedArray;

        function isUint16Array(value) {
          return whichTypedArray(value) === 'Uint16Array';
        }
        exports.isUint16Array = isUint16Array;

        function isUint32Array(value) {
          return whichTypedArray(value) === 'Uint32Array';
        }
        exports.isUint32Array = isUint32Array;

        function isInt8Array(value) {
          return whichTypedArray(value) === 'Int8Array';
        }
        exports.isInt8Array = isInt8Array;

        function isInt16Array(value) {
          return whichTypedArray(value) === 'Int16Array';
        }
        exports.isInt16Array = isInt16Array;

        function isInt32Array(value) {
          return whichTypedArray(value) === 'Int32Array';
        }
        exports.isInt32Array = isInt32Array;

        function isFloat32Array(value) {
          return whichTypedArray(value) === 'Float32Array';
        }
        exports.isFloat32Array = isFloat32Array;

        function isFloat64Array(value) {
          return whichTypedArray(value) === 'Float64Array';
        }
        exports.isFloat64Array = isFloat64Array;

        function isBigInt64Array(value) {
          return whichTypedArray(value) === 'BigInt64Array';
        }
        exports.isBigInt64Array = isBigInt64Array;

        function isBigUint64Array(value) {
          return whichTypedArray(value) === 'BigUint64Array';
        }
        exports.isBigUint64Array = isBigUint64Array;

        function isMapToString(value) {
          return ObjectToString(value) === '[object Map]';
        }
        isMapToString.working = typeof Map !== 'undefined' && isMapToString(new Map());

        function isMap(value) {
          if (typeof Map === 'undefined') {
            return false;
          }

          return isMapToString.working ? isMapToString(value) : value instanceof Map;
        }
        exports.isMap = isMap;

        function isSetToString(value) {
          return ObjectToString(value) === '[object Set]';
        }
        isSetToString.working = typeof Set !== 'undefined' && isSetToString(new Set());
        function isSet(value) {
          if (typeof Set === 'undefined') {
            return false;
          }

          return isSetToString.working ? isSetToString(value) : value instanceof Set;
        }
        exports.isSet = isSet;

        function isWeakMapToString(value) {
          return ObjectToString(value) === '[object WeakMap]';
        }
        isWeakMapToString.working = typeof WeakMap !== 'undefined' && isWeakMapToString(new WeakMap());
        function isWeakMap(value) {
          if (typeof WeakMap === 'undefined') {
            return false;
          }

          return isWeakMapToString.working ? isWeakMapToString(value) : value instanceof WeakMap;
        }
        exports.isWeakMap = isWeakMap;

        function isWeakSetToString(value) {
          return ObjectToString(value) === '[object WeakSet]';
        }
        isWeakSetToString.working = typeof WeakSet !== 'undefined' && isWeakSetToString(new WeakSet());
        function isWeakSet(value) {
          return isWeakSetToString(value);
        }
        exports.isWeakSet = isWeakSet;

        function isArrayBufferToString(value) {
          return ObjectToString(value) === '[object ArrayBuffer]';
        }
        isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && isArrayBufferToString(new ArrayBuffer());
        function isArrayBuffer(value) {
          if (typeof ArrayBuffer === 'undefined') {
            return false;
          }

          return isArrayBufferToString.working ? isArrayBufferToString(value) : value instanceof ArrayBuffer;
        }
        exports.isArrayBuffer = isArrayBuffer;

        function isDataViewToString(value) {
          return ObjectToString(value) === '[object DataView]';
        }
        isDataViewToString.working =
          typeof ArrayBuffer !== 'undefined' &&
          typeof DataView !== 'undefined' &&
          isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
        function isDataView(value) {
          if (typeof DataView === 'undefined') {
            return false;
          }

          return isDataViewToString.working ? isDataViewToString(value) : value instanceof DataView;
        }
        exports.isDataView = isDataView;

        // Store a copy of SharedArrayBuffer in case it's deleted elsewhere
        var SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
        function isSharedArrayBufferToString(value) {
          return ObjectToString(value) === '[object SharedArrayBuffer]';
        }
        function isSharedArrayBuffer(value) {
          if (typeof SharedArrayBufferCopy === 'undefined') {
            return false;
          }

          if (typeof isSharedArrayBufferToString.working === 'undefined') {
            isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
          }

          return isSharedArrayBufferToString.working
            ? isSharedArrayBufferToString(value)
            : value instanceof SharedArrayBufferCopy;
        }
        exports.isSharedArrayBuffer = isSharedArrayBuffer;

        function isAsyncFunction(value) {
          return ObjectToString(value) === '[object AsyncFunction]';
        }
        exports.isAsyncFunction = isAsyncFunction;

        function isMapIterator(value) {
          return ObjectToString(value) === '[object Map Iterator]';
        }
        exports.isMapIterator = isMapIterator;

        function isSetIterator(value) {
          return ObjectToString(value) === '[object Set Iterator]';
        }
        exports.isSetIterator = isSetIterator;

        function isGeneratorObject(value) {
          return ObjectToString(value) === '[object Generator]';
        }
        exports.isGeneratorObject = isGeneratorObject;

        function isWebAssemblyCompiledModule(value) {
          return ObjectToString(value) === '[object WebAssembly.Module]';
        }
        exports.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;

        function isNumberObject(value) {
          return checkBoxedPrimitive(value, numberValue);
        }
        exports.isNumberObject = isNumberObject;

        function isStringObject(value) {
          return checkBoxedPrimitive(value, stringValue);
        }
        exports.isStringObject = isStringObject;

        function isBooleanObject(value) {
          return checkBoxedPrimitive(value, booleanValue);
        }
        exports.isBooleanObject = isBooleanObject;

        function isBigIntObject(value) {
          return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
        }
        exports.isBigIntObject = isBigIntObject;

        function isSymbolObject(value) {
          return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
        }
        exports.isSymbolObject = isSymbolObject;

        function isBoxedPrimitive(value) {
          return (
            isNumberObject(value) ||
            isStringObject(value) ||
            isBooleanObject(value) ||
            isBigIntObject(value) ||
            isSymbolObject(value)
          );
        }
        exports.isBoxedPrimitive = isBoxedPrimitive;

        function isAnyArrayBuffer(value) {
          return typeof Uint8Array !== 'undefined' && (isArrayBuffer(value) || isSharedArrayBuffer(value));
        }
        exports.isAnyArrayBuffer = isAnyArrayBuffer;

        ['isProxy', 'isExternal', 'isModuleNamespaceObject'].forEach(function (method) {
          Object.defineProperty(exports, method, {
            enumerable: false,
            value: function () {
              throw new Error(method + ' is not supported in userland');
            },
          });
        });
      },
      { 'is-arguments': 54, 'is-generator-function': 56, 'is-typed-array': 57, 'which-typed-array': 62 },
    ],
    61: [
      function (require, module, exports) {
        (function (process) {
          (function () {
            // Copyright Joyent, Inc. and other Node contributors.
            //
            // Permission is hereby granted, free of charge, to any person obtaining a
            // copy of this software and associated documentation files (the
            // "Software"), to deal in the Software without restriction, including
            // without limitation the rights to use, copy, modify, merge, publish,
            // distribute, sublicense, and/or sell copies of the Software, and to permit
            // persons to whom the Software is furnished to do so, subject to the
            // following conditions:
            //
            // The above copyright notice and this permission notice shall be included
            // in all copies or substantial portions of the Software.
            //
            // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
            // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
            // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
            // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
            // USE OR OTHER DEALINGS IN THE SOFTWARE.

            var getOwnPropertyDescriptors =
              Object.getOwnPropertyDescriptors ||
              function getOwnPropertyDescriptors(obj) {
                var keys = Object.keys(obj);
                var descriptors = {};
                for (var i = 0; i < keys.length; i++) {
                  descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
                }
                return descriptors;
              };

            var formatRegExp = /%[sdj%]/g;
            exports.format = function (f) {
              if (!isString(f)) {
                var objects = [];
                for (var i = 0; i < arguments.length; i++) {
                  objects.push(inspect(arguments[i]));
                }
                return objects.join(' ');
              }

              var i = 1;
              var args = arguments;
              var len = args.length;
              var str = String(f).replace(formatRegExp, function (x) {
                if (x === '%%') return '%';
                if (i >= len) return x;
                switch (x) {
                  case '%s':
                    return String(args[i++]);
                  case '%d':
                    return Number(args[i++]);
                  case '%j':
                    try {
                      return JSON.stringify(args[i++]);
                    } catch (_) {
                      return '[Circular]';
                    }
                  default:
                    return x;
                }
              });
              for (var x = args[i]; i < len; x = args[++i]) {
                if (isNull(x) || !isObject(x)) {
                  str += ' ' + x;
                } else {
                  str += ' ' + inspect(x);
                }
              }
              return str;
            };

            // Mark that a method should not be used.
            // Returns a modified function which warns once by default.
            // If --no-deprecation is set, then it is a no-op.
            exports.deprecate = function (fn, msg) {
              if (typeof process !== 'undefined' && process.noDeprecation === true) {
                return fn;
              }

              // Allow for deprecating things in the process of starting up.
              if (typeof process === 'undefined') {
                return function () {
                  return exports.deprecate(fn, msg).apply(this, arguments);
                };
              }

              var warned = false;
              function deprecated() {
                if (!warned) {
                  if (process.throwDeprecation) {
                    throw new Error(msg);
                  } else if (process.traceDeprecation) {
                    console.trace(msg);
                  } else {
                    console.error(msg);
                  }
                  warned = true;
                }
                return fn.apply(this, arguments);
              }

              return deprecated;
            };

            var debugs = {};
            var debugEnvRegex = /^$/;

            if (process.env.NODE_DEBUG) {
              var debugEnv = process.env.NODE_DEBUG;
              debugEnv = debugEnv
                .replace(/[|\\{}()[\]^$+?.]/g, '\\$&')
                .replace(/\*/g, '.*')
                .replace(/,/g, '$|^')
                .toUpperCase();
              debugEnvRegex = new RegExp('^' + debugEnv + '$', 'i');
            }
            exports.debuglog = function (set) {
              set = set.toUpperCase();
              if (!debugs[set]) {
                if (debugEnvRegex.test(set)) {
                  var pid = process.pid;
                  debugs[set] = function () {
                    var msg = exports.format.apply(exports, arguments);
                    console.error('%s %d: %s', set, pid, msg);
                  };
                } else {
                  debugs[set] = function () {};
                }
              }
              return debugs[set];
            };

            /**
             * Echos the value of a value. Trys to print the value out
             * in the best way possible given the different types.
             *
             * @param {Object} obj The object to print out.
             * @param {Object} opts Optional options object that alters the output.
             */
            /* legacy: obj, showHidden, depth, colors*/
            function inspect(obj, opts) {
              // default options
              var ctx = {
                seen: [],
                stylize: stylizeNoColor,
              };
              // legacy...
              if (arguments.length >= 3) ctx.depth = arguments[2];
              if (arguments.length >= 4) ctx.colors = arguments[3];
              if (isBoolean(opts)) {
                // legacy...
                ctx.showHidden = opts;
              } else if (opts) {
                // got an "options" object
                exports._extend(ctx, opts);
              }
              // set default options
              if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
              if (isUndefined(ctx.depth)) ctx.depth = 2;
              if (isUndefined(ctx.colors)) ctx.colors = false;
              if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
              if (ctx.colors) ctx.stylize = stylizeWithColor;
              return formatValue(ctx, obj, ctx.depth);
            }
            exports.inspect = inspect;

            // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
            inspect.colors = {
              bold: [1, 22],
              italic: [3, 23],
              underline: [4, 24],
              inverse: [7, 27],
              white: [37, 39],
              grey: [90, 39],
              black: [30, 39],
              blue: [34, 39],
              cyan: [36, 39],
              green: [32, 39],
              magenta: [35, 39],
              red: [31, 39],
              yellow: [33, 39],
            };

            // Don't use 'blue' not visible on cmd.exe
            inspect.styles = {
              special: 'cyan',
              number: 'yellow',
              boolean: 'yellow',
              undefined: 'grey',
              null: 'bold',
              string: 'green',
              date: 'magenta',
              // "name": intentionally not styling
              regexp: 'red',
            };

            function stylizeWithColor(str, styleType) {
              var style = inspect.styles[styleType];

              if (style) {
                return '\u001b[' + inspect.colors[style][0] + 'm' + str + '\u001b[' + inspect.colors[style][1] + 'm';
              } else {
                return str;
              }
            }

            function stylizeNoColor(str, styleType) {
              return str;
            }

            function arrayToHash(array) {
              var hash = {};

              array.forEach(function (val, idx) {
                hash[val] = true;
              });

              return hash;
            }

            function formatValue(ctx, value, recurseTimes) {
              // Provide a hook for user-specified inspect functions.
              // Check that value is an object with an inspect function on it
              if (
                ctx.customInspect &&
                value &&
                isFunction(value.inspect) &&
                // Filter out the util module, it's inspect function is special
                value.inspect !== exports.inspect &&
                // Also filter out any prototype objects using the circular check.
                !(value.constructor && value.constructor.prototype === value)
              ) {
                var ret = value.inspect(recurseTimes, ctx);
                if (!isString(ret)) {
                  ret = formatValue(ctx, ret, recurseTimes);
                }
                return ret;
              }

              // Primitive types cannot have properties
              var primitive = formatPrimitive(ctx, value);
              if (primitive) {
                return primitive;
              }

              // Look up the keys of the object.
              var keys = Object.keys(value);
              var visibleKeys = arrayToHash(keys);

              if (ctx.showHidden) {
                keys = Object.getOwnPropertyNames(value);
              }

              // IE doesn't make error fields non-enumerable
              // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
              if (isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
                return formatError(value);
              }

              // Some type of object without properties can be shortcutted.
              if (keys.length === 0) {
                if (isFunction(value)) {
                  var name = value.name ? ': ' + value.name : '';
                  return ctx.stylize('[Function' + name + ']', 'special');
                }
                if (isRegExp(value)) {
                  return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
                }
                if (isDate(value)) {
                  return ctx.stylize(Date.prototype.toString.call(value), 'date');
                }
                if (isError(value)) {
                  return formatError(value);
                }
              }

              var base = '',
                array = false,
                braces = ['{', '}'];

              // Make Array say that they are Array
              if (isArray(value)) {
                array = true;
                braces = ['[', ']'];
              }

              // Make functions say that they are functions
              if (isFunction(value)) {
                var n = value.name ? ': ' + value.name : '';
                base = ' [Function' + n + ']';
              }

              // Make RegExps say that they are RegExps
              if (isRegExp(value)) {
                base = ' ' + RegExp.prototype.toString.call(value);
              }

              // Make dates with properties first say the date
              if (isDate(value)) {
                base = ' ' + Date.prototype.toUTCString.call(value);
              }

              // Make error with message first say the error
              if (isError(value)) {
                base = ' ' + formatError(value);
              }

              if (keys.length === 0 && (!array || value.length == 0)) {
                return braces[0] + base + braces[1];
              }

              if (recurseTimes < 0) {
                if (isRegExp(value)) {
                  return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
                } else {
                  return ctx.stylize('[Object]', 'special');
                }
              }

              ctx.seen.push(value);

              var output;
              if (array) {
                output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
              } else {
                output = keys.map(function (key) {
                  return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
                });
              }

              ctx.seen.pop();

              return reduceToSingleString(output, base, braces);
            }

            function formatPrimitive(ctx, value) {
              if (isUndefined(value)) return ctx.stylize('undefined', 'undefined');
              if (isString(value)) {
                var simple =
                  "'" + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                return ctx.stylize(simple, 'string');
              }
              if (isNumber(value)) return ctx.stylize('' + value, 'number');
              if (isBoolean(value)) return ctx.stylize('' + value, 'boolean');
              // For some reason typeof null is "object", so special case here.
              if (isNull(value)) return ctx.stylize('null', 'null');
            }

            function formatError(value) {
              return '[' + Error.prototype.toString.call(value) + ']';
            }

            function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
              var output = [];
              for (var i = 0, l = value.length; i < l; ++i) {
                if (hasOwnProperty(value, String(i))) {
                  output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
                } else {
                  output.push('');
                }
              }
              keys.forEach(function (key) {
                if (!key.match(/^\d+$/)) {
                  output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
                }
              });
              return output;
            }

            function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
              var name, str, desc;
              desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
              if (desc.get) {
                if (desc.set) {
                  str = ctx.stylize('[Getter/Setter]', 'special');
                } else {
                  str = ctx.stylize('[Getter]', 'special');
                }
              } else {
                if (desc.set) {
                  str = ctx.stylize('[Setter]', 'special');
                }
              }
              if (!hasOwnProperty(visibleKeys, key)) {
                name = '[' + key + ']';
              }
              if (!str) {
                if (ctx.seen.indexOf(desc.value) < 0) {
                  if (isNull(recurseTimes)) {
                    str = formatValue(ctx, desc.value, null);
                  } else {
                    str = formatValue(ctx, desc.value, recurseTimes - 1);
                  }
                  if (str.indexOf('\n') > -1) {
                    if (array) {
                      str = str
                        .split('\n')
                        .map(function (line) {
                          return '  ' + line;
                        })
                        .join('\n')
                        .slice(2);
                    } else {
                      str =
                        '\n' +
                        str
                          .split('\n')
                          .map(function (line) {
                            return '   ' + line;
                          })
                          .join('\n');
                    }
                  }
                } else {
                  str = ctx.stylize('[Circular]', 'special');
                }
              }
              if (isUndefined(name)) {
                if (array && key.match(/^\d+$/)) {
                  return str;
                }
                name = JSON.stringify('' + key);
                if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
                  name = name.slice(1, -1);
                  name = ctx.stylize(name, 'name');
                } else {
                  name = name
                    .replace(/'/g, "\\'")
                    .replace(/\\"/g, '"')
                    .replace(/(^"|"$)/g, "'");
                  name = ctx.stylize(name, 'string');
                }
              }

              return name + ': ' + str;
            }

            function reduceToSingleString(output, base, braces) {
              var numLinesEst = 0;
              var length = output.reduce(function (prev, cur) {
                numLinesEst++;
                if (cur.indexOf('\n') >= 0) numLinesEst++;
                return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
              }, 0);

              if (length > 60) {
                return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
              }

              return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
            }

            // NOTE: These type checking functions intentionally don't use `instanceof`
            // because it is fragile and can be easily faked with `Object.create()`.
            exports.types = require('./support/types');

            function isArray(ar) {
              return Array.isArray(ar);
            }
            exports.isArray = isArray;

            function isBoolean(arg) {
              return typeof arg === 'boolean';
            }
            exports.isBoolean = isBoolean;

            function isNull(arg) {
              return arg === null;
            }
            exports.isNull = isNull;

            function isNullOrUndefined(arg) {
              return arg == null;
            }
            exports.isNullOrUndefined = isNullOrUndefined;

            function isNumber(arg) {
              return typeof arg === 'number';
            }
            exports.isNumber = isNumber;

            function isString(arg) {
              return typeof arg === 'string';
            }
            exports.isString = isString;

            function isSymbol(arg) {
              return typeof arg === 'symbol';
            }
            exports.isSymbol = isSymbol;

            function isUndefined(arg) {
              return arg === void 0;
            }
            exports.isUndefined = isUndefined;

            function isRegExp(re) {
              return isObject(re) && objectToString(re) === '[object RegExp]';
            }
            exports.isRegExp = isRegExp;
            exports.types.isRegExp = isRegExp;

            function isObject(arg) {
              return typeof arg === 'object' && arg !== null;
            }
            exports.isObject = isObject;

            function isDate(d) {
              return isObject(d) && objectToString(d) === '[object Date]';
            }
            exports.isDate = isDate;
            exports.types.isDate = isDate;

            function isError(e) {
              return isObject(e) && (objectToString(e) === '[object Error]' || e instanceof Error);
            }
            exports.isError = isError;
            exports.types.isNativeError = isError;

            function isFunction(arg) {
              return typeof arg === 'function';
            }
            exports.isFunction = isFunction;

            function isPrimitive(arg) {
              return (
                arg === null ||
                typeof arg === 'boolean' ||
                typeof arg === 'number' ||
                typeof arg === 'string' ||
                typeof arg === 'symbol' || // ES6 symbol
                typeof arg === 'undefined'
              );
            }
            exports.isPrimitive = isPrimitive;

            exports.isBuffer = require('./support/isBuffer');

            function objectToString(o) {
              return Object.prototype.toString.call(o);
            }

            function pad(n) {
              return n < 10 ? '0' + n.toString(10) : n.toString(10);
            }

            var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

            // 26 Feb 16:19:34
            function timestamp() {
              var d = new Date();
              var time = [pad(d.getHours()), pad(d.getMinutes()), pad(d.getSeconds())].join(':');
              return [d.getDate(), months[d.getMonth()], time].join(' ');
            }

            // log is just a thin wrapper to console.log that prepends a timestamp
            exports.log = function () {
              console.log(
                new Date().toLocaleString() + '  ➤  %s - %s',
                timestamp(),
                exports.format.apply(exports, arguments)
              );
            };

            /**
             * Inherit the prototype methods from one constructor into another.
             *
             * The Function.prototype.inherits from lang.js rewritten as a standalone
             * function (not on Function.prototype). NOTE: If this file is to be loaded
             * during bootstrapping this function needs to be rewritten using some native
             * functions as prototype setup using normal JavaScript does not work as
             * expected during bootstrapping (see mirror.js in r114903).
             *
             * @param {function} ctor Constructor function which needs to inherit the
             *     prototype.
             * @param {function} superCtor Constructor function to inherit prototype from.
             */
            exports.inherits = require('inherits');

            exports._extend = function (origin, add) {
              // Don't do anything if add isn't an object
              if (!add || !isObject(add)) return origin;

              var keys = Object.keys(add);
              var i = keys.length;
              while (i--) {
                origin[keys[i]] = add[keys[i]];
              }
              return origin;
            };

            function hasOwnProperty(obj, prop) {
              return Object.prototype.hasOwnProperty.call(obj, prop);
            }

            var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

            exports.promisify = function promisify(original) {
              if (typeof original !== 'function')
                throw new TypeError('The "original" argument must be of type Function');

              if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
                var fn = original[kCustomPromisifiedSymbol];
                if (typeof fn !== 'function') {
                  throw new TypeError('The "util.promisify.custom" argument must be of type Function');
                }
                Object.defineProperty(fn, kCustomPromisifiedSymbol, {
                  value: fn,
                  enumerable: false,
                  writable: false,
                  configurable: true,
                });
                return fn;
              }

              function fn() {
                var promiseResolve, promiseReject;
                var promise = new Promise(function (resolve, reject) {
                  promiseResolve = resolve;
                  promiseReject = reject;
                });

                var args = [];
                for (var i = 0; i < arguments.length; i++) {
                  args.push(arguments[i]);
                }
                args.push(function (err, value) {
                  if (err) {
                    promiseReject(err);
                  } else {
                    promiseResolve(value);
                  }
                });

                try {
                  original.apply(this, args);
                } catch (err) {
                  promiseReject(err);
                }

                return promise;
              }

              Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

              if (kCustomPromisifiedSymbol)
                Object.defineProperty(fn, kCustomPromisifiedSymbol, {
                  value: fn,
                  enumerable: false,
                  writable: false,
                  configurable: true,
                });
              return Object.defineProperties(fn, getOwnPropertyDescriptors(original));
            };

            exports.promisify.custom = kCustomPromisifiedSymbol;

            function callbackifyOnRejected(reason, cb) {
              // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
              // Because `null` is a special error value in callbacks which means "no error
              // occurred", we error-wrap so the callback consumer can distinguish between
              // "the promise rejected with null" or "the promise fulfilled with undefined".
              if (!reason) {
                var newReason = new Error('Promise was rejected with a falsy value');
                newReason.reason = reason;
                reason = newReason;
              }
              return cb(reason);
            }

            function callbackify(original) {
              if (typeof original !== 'function') {
                throw new TypeError('The "original" argument must be of type Function');
              }

              // We DO NOT return the promise as it gives the user a false sense that
              // the promise is actually somehow related to the callback's execution
              // and that the callback throwing will reject the promise.
              function callbackified() {
                var args = [];
                for (var i = 0; i < arguments.length; i++) {
                  args.push(arguments[i]);
                }

                var maybeCb = args.pop();
                if (typeof maybeCb !== 'function') {
                  throw new TypeError('The last argument must be of type Function');
                }
                var self = this;
                var cb = function () {
                  return maybeCb.apply(self, arguments);
                };
                // In true node style we process the callback on `nextTick` with all the
                // implications (stack, `uncaughtException`, `async_hooks`)
                original.apply(this, args).then(
                  function (ret) {
                    process.nextTick(cb.bind(null, null, ret));
                  },
                  function (rej) {
                    process.nextTick(callbackifyOnRejected.bind(null, rej, cb));
                  }
                );
              }

              Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
              Object.defineProperties(callbackified, getOwnPropertyDescriptors(original));
              return callbackified;
            }
            exports.callbackify = callbackify;
          }.call(this));
        }.call(this, require('_process')));
      },
      { './support/isBuffer': 59, './support/types': 60, _process: 58, inherits: 53 },
    ],
    62: [
      function (require, module, exports) {
        (function (global) {
          (function () {
            'use strict';

            var forEach = require('for-each');
            var availableTypedArrays = require('available-typed-arrays');
            var callBound = require('call-bind/callBound');
            var gOPD = require('gopd');

            var $toString = callBound('Object.prototype.toString');
            var hasToStringTag = require('has-tostringtag/shams')();

            var g = typeof globalThis === 'undefined' ? global : globalThis;
            var typedArrays = availableTypedArrays();

            var $slice = callBound('String.prototype.slice');
            var toStrTags = {};
            var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
            if (hasToStringTag && gOPD && getPrototypeOf) {
              forEach(typedArrays, function (typedArray) {
                if (typeof g[typedArray] === 'function') {
                  var arr = new g[typedArray]();
                  if (Symbol.toStringTag in arr) {
                    var proto = getPrototypeOf(arr);
                    var descriptor = gOPD(proto, Symbol.toStringTag);
                    if (!descriptor) {
                      var superProto = getPrototypeOf(proto);
                      descriptor = gOPD(superProto, Symbol.toStringTag);
                    }
                    toStrTags[typedArray] = descriptor.get;
                  }
                }
              });
            }

            var tryTypedArrays = function tryAllTypedArrays(value) {
              var foundName = false;
              forEach(toStrTags, function (getter, typedArray) {
                if (!foundName) {
                  try {
                    var name = getter.call(value);
                    if (name === typedArray) {
                      foundName = name;
                    }
                  } catch (e) {}
                }
              });
              return foundName;
            };

            var isTypedArray = require('is-typed-array');

            module.exports = function whichTypedArray(value) {
              if (!isTypedArray(value)) {
                return false;
              }
              if (!hasToStringTag || !(Symbol.toStringTag in value)) {
                return $slice($toString(value), 8, -1);
              }
              return tryTypedArrays(value);
            };
          }.call(this));
        }.call(
          this,
          typeof global !== 'undefined'
            ? global
            : typeof self !== 'undefined'
            ? self
            : typeof window !== 'undefined'
            ? window
            : {}
        ));
      },
      {
        'available-typed-arrays': 37,
        'call-bind/callBound': 40,
        'for-each': 43,
        gopd: 47,
        'has-tostringtag/shams': 50,
        'is-typed-array': 57,
      },
    ],
    63: [
      function (require, module, exports) {
        (function (global) {
          (function () {
            /** @namespace Twilio */
            var component = require('../lib');
            var componentName = 'TaskRouter';

            /* @license
  
  The following license applies to all parts of this software except as
  documented below.
  
      Copyright (c) 2015, Twilio, inc.
      All rights reserved.
  
      Redistribution and use in source and binary forms, with or without
      modification, are permitted provided that the following conditions are
      met:
  
        1. Redistributions of source code must retain the above copyright
           notice, this list of conditions and the following disclaimer.
  
        2. Redistributions in binary form must reproduce the above copyright
           notice, this list of conditions and the following disclaimer in
           the documentation and/or other materials provided with the
           distribution.
  
        3. Neither the name of Twilio nor the names of its contributors may
           be used to endorse or promote products derived from this software
           without specific prior written permission.
  
      THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
      "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
      LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
      A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
      HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
      SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
      LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
      DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
      THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
      (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
      OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  
  This software includes buffer.js under the following license.
  
      Copyright (c) 2014 Junction Networks, Inc. <http://www.onsip.com>
  
      License: The MIT License
  
      Permission is hereby granted, free of charge, to any person obtaining
      a copy of this software and associated documentation files (the
      "Software"), to deal in the Software without restriction, including
      without limitation the rights to use, copy, modify, merge, publish,
      distribute, sublicense, and/or sell copies of the Software, and to
      permit persons to whom the Software is furnished to do so, subject to
      the following conditions:
  
      The above copyright notice and this permission notice shall be
      included in all copies or substantial portions of the Software.
  
      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
      EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
      MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
      NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
      LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
      OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
      WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  */

            // Uses CommonJS, AMD or browser globals to create a
            // module using UMD (Universal Module Definition).
            (function (root) {
              // AMD (Requirejs etc)
              if (typeof define === 'function' && define.amd) {
                define([], function () {
                  return component;
                });
                // Browser globals
              } else {
                root.Twilio = root.Twilio || function Twilio() {};
                root.Twilio[componentName] = component;
              }
            })(window || global || this);
          }.call(this));
        }.call(
          this,
          typeof global !== 'undefined'
            ? global
            : typeof self !== 'undefined'
            ? self
            : typeof window !== 'undefined'
            ? window
            : {}
        ));
      },
      { '../lib': 9 },
    ],
  },
  {},
  [63]
);

//1.23.0
